(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

var aboutLanding = document.getElementById('about-section'),
	shareTools;

if(!aboutLanding) {
    return;
}


//initialization
window.BackToTop = require('./back-to-top');

window.BackToTop.init();


//return for garbage collection
aboutLanding = null;
},{"./back-to-top":10}],2:[function(require,module,exports){
'use strict';

function Accordions($accordion, optionsLogic) {
    this.$accordionModule = $accordion;
    this.$accordionSlides = null;
    this.$accordionNodes = null;
    this.options = {
        exclusive:false,
        duration: 350, //in ms,
        triggerClass: 'js-accordion-trigger',
        accordionContentClass: 'js-accordion-content',
        parentClass: 'js-accordion-node',
        activeClass: 'is-expanded'
    };

    Object.assign(this.options, optionsLogic || {});

    this.bindEvents();
    this.init();
}

Accordions.prototype.init = function init() {
    var _self = this;

    _self.$accordionNodes = _self.$accordionModule.find('.' + _self.options.parentClass);
    _self.$accordionSlides = _self.$accordionModule.find('.' + _self.options.accordionContentClass);

    _self.$accordionNodes.each(function (index, el) {
        var $accordionNode = $(el);
        var initializeExpanded = $accordionNode.hasClass(_self.options.activeClass);
        if (!initializeExpanded) {
            $accordionNode.find('.' + _self.options.accordionContentClass).slideUp();
        }
        $accordionNode
            .find('.' + _self.options.triggerClass)
                .attr('aria-expanded', initializeExpanded)
                .end()
            .find('.' + _self.options.accordionContentClass)
                .attr('aria-hidden', !initializeExpanded);
    });

    var $linkedPanel = _self.$accordionModule.find(window.location.hash);
    if ($linkedPanel.length) {
        var $parentNode = $linkedPanel.closest('.' + this.options.parentClass);
        this.expandAccordion($parentNode, null, true);
    }
};

Accordions.prototype.collapseAll = function collaseAll() {
    this.$accordionNodes.removeClass(this.options.activeClass);
    this.$accordionSlides.slideUp(this.options.duration, function(){
        if(window.BackToTop !== undefined) {
            window.BackToTop.refreshBodyDimensions();
        }

    

        if(window.ScrollSpy !== undefined) {
            window.ScrollSpy.refreshBodyDimensions();
        }
    });

    var _self = this;
    this.$accordionNodes.each(function(index, el) {
          $(el)
            .find('.' + _self.options.triggerClass)
                .attr('aria-expanded', 'false')
                .end()
            .find('.' + _self.options.accordionContentClass)
                .attr('aria-hidden', true);
    });
};

Accordions.prototype.collapseAccordion = function collapse($accordion, $trigger) {

    $accordion.removeClass(this.options.activeClass)
        .find('.' + this.options.accordionContentClass)
        .attr('aria-hidden', true)
        .slideUp(this.options.duration, function(){
            if(window.BackToTop !== undefined) {
                window.BackToTop.refreshBodyDimensions();
            }

            if(window.ScrollSpy !== undefined) {
                window.ScrollSpy.refreshBodyDimensions();
            }
        });


    //aria attribute updates
    if($trigger && $trigger.length) {
        $trigger.attr('aria-expanded', 'false');
    } else {
         $accordion
            .find('.' + this.options.triggerClass)
                .attr('aria-expanded', 'false')
    }
};

Accordions.prototype.expandAccordion = function expand($accordion, $trigger, shouldScrollIntoView) {

    if (this.options.exclusive) {
        this.collapseAll();
    }

    $accordion.addClass(this.options.activeClass)
        .find('.' + this.options.accordionContentClass)
            .attr('aria-hidden', false)
            .slideDown(this.options.duration,function(){
                if(window.BackToTop !== undefined) {
                    window.BackToTop.refreshBodyDimensions();
                }

                if(window.ScrollSpy !== undefined) {
                    window.ScrollSpy.refreshBodyDimensions();
                }

                if (shouldScrollIntoView) {
                    var accordionContentEl = this
                    accordionContentEl.scrollIntoView()
                }
            });


    if($trigger && $trigger.length) {
        $trigger.attr('aria-expanded', 'true');
    } else {
         $accordion
            .find('.' + this.options.triggerClass)
            .attr('aria-expanded', 'true');
    }
};

Accordions.prototype.toggleVisibility = function toggle($trigger) {
    var $parentNode = $trigger.closest('.' + this.options.parentClass);

    ( $parentNode.hasClass(this.options.activeClass) ) ? this.collapseAccordion($parentNode, $trigger) : this.expandAccordion($parentNode, $trigger);
};

Accordions.prototype.bindEvents = function bindEvents() {

    var _self = this;

    //initialize events
    _self.$accordionModule.on('click.Accordions', '.' + _self.options.triggerClass, function(ev) {
        ev.preventDefault();

        _self.toggleVisibility($(this));

    });

    //if accordion is exclusive, we cache elements for future use
    if (_self.options.exclusive) {
        _self.$accordionSlides = _self.$accordionModule.find('.' + _self.options.accordionContentClass);
        _self.$accordionNodes = _self.$accordionModule.find('.' + _self.options.parentClass);
    }
};

module.exports = Accordions;

},{}],3:[function(require,module,exports){
'use strict';

var $advancedSearch,
	$dropdowns,
	options,


	//module exports
	selectDropdowns,
	advancedSearch;


advancedSearch = {

	advancedSearchInit: function (configOption) {
		var $toggle = (configOption.toggle) ? configOption.toggle : $advancedSearch.find('.js-toggle')

		$toggle.on('click.toggle', function(e){
			e.preventDefault();
			e.stopPropagation();

			if($advancedSearch.hasClass('is-expanded') ) {
				$advancedSearch
					.find('.js-search-fields')
					.attr('aria-hidden', true)
					.attr('tabindex', -1)
					.slideUp(300, function(){
						$advancedSearch.removeClass('is-expanded');
					});

					$(this).attr('aria-expanded', false);

				$advancedSearch.parent().removeClass('is-expanded-andgray')

			} else {
				$advancedSearch
					.find('.js-search-fields')
					.attr('aria-hidden', false)
					.attr('tabindex', 0)
					.slideDown(300, function(){
						$advancedSearch.addClass('is-expanded');

						$(this).focus();
					});

				$(this).attr('aria-expanded', true);
				$advancedSearch.parent().addClass('is-expanded-andgray')
			}

		});

	},
	categoryFiltersInit: function(){

		$advancedSearch.find('.js-category-filters').find('input:radio').on('change', function(){
			if ( $(this).is(':checked') ) {
				options.categoryCallback( $(this) );
			}
		});

	},
	clearRadioButtons: function(){
			$advancedSearch
				.find('.js-category-filters')
					.find('input:radio')
						.filter(':checked').attr('checked', false) ;
	},
	selectDropdownsInit: function(cb){
		/*----------  initialize dropdown Functionality  ----------*/

		$dropdowns = $advancedSearch.find('.js-select-dropdown');

		selectDropdowns($dropdowns, cb);

		//back to gc
		$dropdowns = null;
	},
	init: function init(config) {

		options = (!!config) ? config : {};

		//modules
		selectDropdowns = require('./select-dropdown');

		//globalVariables
		$advancedSearch = (options.$module) ? options.$module : $('.js-advanced-search');


		this.advancedSearchInit({ toggle: config.$trigger });
		this.selectDropdownsInit(config.callback);


		if( typeof config.categoryCallback === 'function') {

			this.categoryFiltersInit();
		}

		config = null ;
	}

};


module.exports = advancedSearch;

},{"./select-dropdown":65}],4:[function(require,module,exports){
'use strict';

var alumniCleLibrary = document.getElementById('cle-library');

if(!alumniCleLibrary) {
    return;
}

var pageOptions = {
	pageName: 'alumni-cle-library',
	activateBackToTop: true,
	searchFormID: 'entity-search-control'
};

window.animationSearchLogic = require('./animation-search-logic');

window.animationSearchLogic.init(pageOptions);

//return for garbage collection
alumniCleLibrary = null;
},{"./animation-search-logic":9}],5:[function(require,module,exports){
'use strict';

var alumniDirectory = document.getElementById('alumni-directory'),
	
	//modules
	SearchLandingFilters;

if(!alumniDirectory) {
    return;
}



window.SearchLandingFilters = require('./search-landing-filters');

window.SearchLandingFilters.init({
	pageName: 'default-search',
	searchResultsID: 'alumni-directory-results'
});


//This logic can be replaced with angular/knockout specific syntax
window.SearchLandingFilters.initAlphaOptions();


//return for garbage collection
alumniDirectory = null;
},{"./search-landing-filters":61}],6:[function(require,module,exports){
'use strict';

var alumniHomepage = document.getElementById('alumni-homepage'),

	//modules
	FeaturedCarousel;

if(!alumniHomepage) {
    return;
}


FeaturedCarousel = require('./featured-carousel');

FeaturedCarousel.init();




//return for garbage collection
alumniHomepage = null;

},{"./featured-carousel":23}],7:[function(require,module,exports){
'use strict';

var alumniNewsEvents = document.getElementById('alumni-news-events'),

	//modules
	pageOptions;

if(!alumniNewsEvents) {
    return;
}

pageOptions = {
	pageName: 'alumni-news-events',
	searchResultsID: 'search-landing-results',
	activateBackToTop: true,
	activateBackToTopSilent: true,
	advancedSearch: true
};

// Panels
window.SearchLandingPanels = require('./search-landing-panels');

window.SearchLandingPanels.init(false, pageOptions);


window.ThrowawaySearchLandingFilters = require('./throwaway-search-landing-filters');

window.ThrowawaySearchLandingFilters.init(pageOptions);

window.animationSearchLogic = require('./animation-search-logic');

//return for garbage collection
alumniNewsEvents = null;

},{"./animation-search-logic":9,"./search-landing-panels":63,"./throwaway-search-landing-filters":71}],8:[function(require,module,exports){
'use strict';

var spotlightDetail = document.getElementById('spotlight-detail'),
	shareTools,


	//modules
	BackToTop,
	ToggleMenu;

if(!spotlightDetail) {
    return;
}


//initialization
BackToTop = require('./back-to-top');


BackToTop.init();

//share tools
ToggleMenu = require('./toggle-menu');

shareTools = $('.js-share-tools');

if (shareTools.length) {
	shareTools.each(function(index, el) {
		new ToggleMenu($(el));
	});	
}




//return for garbage collection
spotlightDetail = null;

},{"./back-to-top":10,"./toggle-menu":73}],9:[function(require,module,exports){
'use strict';

var animationSearchLogic,
	pageConfig,
	timeoutDelay = 750,
	$loadingScreen,


	globalVars = require('./variables'),
	cachedElements = globalVars.elementStates,

	//used on insights landing
	BackToTop = require('./back-to-top');


animationSearchLogic = {
	slideToSearchResults: function (NoSlideOnDesktop) {


		if(!!NoSlideOnDesktop && !globalVars.isMobile) {
			return;
		}

		var searchForm,
			filtersOffset,
			_self = this;

		searchForm = (!!pageConfig.searchFormID) ? document.getElementById(pageConfig.searchFormID) : document.getElementById('search-landing-filters');




		//compute offset of searchFilters
		filtersOffset = parseInt(searchForm.getBoundingClientRect().bottom + window.pageYOffset , 10);

		filtersOffset = Math.ceil(filtersOffset - cachedElements.headerHeight);

		$('html,body').animate({
			scrollTop:filtersOffset
		}, 500, function() {
			_self.focusOnSearchResults();
		});

		searchForm = null;
	},
	focusOnSearchResults: function() {
		var searchResultsContent = document.getElementById(pageConfig.searchResultsID);

		$(searchResultsContent).focus();

		searchResultsContent = null;
	},
	init: function(pageConfiguration) {
		pageConfig = pageConfiguration;

		//back to top init
		if (pageConfig != null && pageConfig.hasOwnProperty('activateBackToTop')) {
			if(pageConfig.activateBackToTop) {
				BackToTop.init({silentInit: pageConfig.activateBackToTopSilent});
			}
		}
		$loadingScreen = $('.js-loading-screen');
	},
	showLoadingScreen: function(){
		$loadingScreen.addClass('show-loading-screen');
	},
	hideLoadingScreen: function(){
		$loadingScreen.removeClass('show-loading-screen');
	},
	transitionFromDefaultToResults: function() {
		var defaultContent,
			_self = this;

		defaultContent = (!!pageConfig.defaultContentID) ?  document.getElementById(pageConfig.defaultContentID) : document.getElementById('search-landing-default');


		this.showLoadingScreen();

		if (!!defaultContent) {
			$(defaultContent).fadeOut('slow', function() {
				$(this).attr({
					'aria-hidden': true,
					'tabIndex': -1
				});

				_self.showSearchResults();


				defaultContent = null;
			});
		} else {
			_self.showSearchResults();
		}
	},
	showSearchResults: function() {
		var resultsBody,
			_self = this;

		resultsBody = (!!pageConfig.searchResultsID) ? document.getElementById(pageConfig.searchResultsID) : document.getElementById('search-landing-results');

		if ( resultsBody.getAttribute('aria-hidden') === 'true') {

			$(resultsBody).fadeIn('fast', function() {

				$(this).attr({
					'aria-hidden': false,
					'tabIndex': 0
				});

				_self.slideToSearchResults();
				_self.hideLoadingScreen();
			});


			if(pageConfig.activateBackToTop) {
				BackToTop.refreshBodyDimensions();
			}

			resultsBody = null;

		} else {

			_self.slideToSearchResults();

			if(pageConfig.activateBackToTop) {

				if( !BackToTop.isEnabled() ) {

					BackToTop.activateFeature();
				}

				BackToTop.refreshBodyDimensions();
			}
			resultsBody = null;

			setTimeout(_self.hideLoadingScreen, timeoutDelay);
		}
	},
	refreshBackToTop: function() {
		BackToTop.refreshBodyDimensions()
	},
	transitionToSearchDefault: function() {

		var resultsBody,
			defaultContent,
			timeoutID,
            keywordEntrySectionOffset,
            siteHeaderHeight,
			_self = this;

		defaultContent = (!!pageConfig.defaultContentID) ? document.getElementById(pageConfig.defaultContentID) : false;
		resultsBody = (!!pageConfig.searchResultsID) ? document.getElementById(pageConfig.searchResultsID) : document.getElementById('search-landing-results');

		this.showLoadingScreen();

		$('.js-applied-filters').find('.js-filter').fadeOut();

        siteHeaderHeight = $('.js-site-header').outerHeight();
        keywordEntrySectionOffset = $('.js-entity-search-control').offset();

		$('html,body').animate({
			scrollTop: keywordEntrySectionOffset ? keywordEntrySectionOffset.top - siteHeaderHeight : 0
		}, timeoutDelay);

		//if default content exists on the page, then we will fade out the current display and fade in the respected content
		if(!!defaultContent) {
			$(resultsBody).slideUp(timeoutDelay, function() {
				$(this).attr({
					'aria-hidden': true,
					'tabIndex': -1
				});

				_self.hideLoadingScreen();

				$(defaultContent).fadeIn('fast', function() {

					$(this).attr({
						'aria-hidden': false,
						'tabIndex': 0
					});

					resultsBody = defaultContent= null;


					if(pageConfig.activateBackToTop) {
						BackToTop.refreshBodyDimensions();
					}

				});

			});
		} else {
			//default content doesnt exist so we simply scroll to thte top and hide the loading screen;

			setTimeout(function(){
				_self.hideLoadingScreen();

				if(pageConfig.activateBackToTop) {
					BackToTop.refreshBodyDimensions();
				}

			}, timeoutDelay);
		}
	}
};


module.exports = animationSearchLogic;

},{"./back-to-top":10,"./variables":75}],10:[function(require,module,exports){
'use strict';

var $backToTop,
	$trigger,

	//offsets/classes
	headerOffsets,

	//magic controller
	magicController,
	sceneCollection,

	//object with supplied options
	config,

	//module exports
	globalVars,
	windowResize,
	BackToTop;


BackToTop = {
	stickyTriggerInit: function (silentInit) {

		var sceneDuration = (silentInit) ? 0 :  Math.ceil( $backToTop.height() ) - Math.ceil( $trigger.outerHeight() );

		sceneCollection['back-to-top'] = new ScrollMagic.Scene({
			triggerElement: $backToTop[0],
			triggerHook: 0,
			offset: headerOffsets,
			duration:  sceneDuration
		})
		.setClassToggle($trigger[0], 'is-sticky-top')
		.on('end', function(e){
            (e.state === 'AFTER' ) ? $trigger.addClass('is-sticky-bottom') : $trigger.removeClass('is-sticky-bottom') ;
        })
		//.addIndicators()
		.addTo(magicController);


		if(silentInit) {
			this.disableFeature();
		}

		this.windowResizeEvent();
	},
	isEnabled: function() {
		return sceneCollection['back-to-top'].enabled();
	},
	activateFeature: function() {
		sceneCollection['back-to-top'].enabled(true);
	},
	disableFeature: function(){
		sceneCollection['back-to-top'].enabled(false);
	},
	refreshBodyDimensions: function() {

		if( !sceneCollection['back-to-top'].enabled() ) {
			this.activateFeature();
		}
		sceneCollection['back-to-top'].duration(Math.ceil( $backToTop.height() ) - Math.ceil( $trigger.outerHeight() ));
	},
	windowResizeEvent: function() {
		var resizeMagicLogic,
			_self = this;

		resizeMagicLogic = function() {
			var resizeDuration;

			//if magic scene is disabled do nothing until it's activated;
			if( !sceneCollection['back-to-top'].enabled() ) {
				return;
			}

			headerOffsets = globalVars.elementStates.headerHeight * -1;

			resizeDuration =  Math.ceil($backToTop.height() ) - Math.ceil( $trigger.outerHeight() ); 

			if (resizeDuration < 0) {
				//this.disabledFeature();

				return;
			}

			sceneCollection['back-to-top']
				.duration( resizeDuration )
				.offset(headerOffsets);
    	};

    	windowResize.add(resizeMagicLogic);
	},
	animateToTop: function(){

		var finalOffset = $backToTop.offset().top + headerOffsets * 2;

		if (globalVars.isMobile) { finalOffset = finalOffset - 70;} //magic number is height of subnavigation;

		$('body,html').animate({
				scrollTop: finalOffset
		}, 500);

	},
	triggerEventsInit: function() {
		var _self = this;

		$trigger.on('click.backToTop', function(ev) {

			ev.preventDefault();
			ev.stopPropagation();

			_self.animateToTop();
		});
	},
	init: function init(options) {


		config = (!options) ?  {} : options;


		//globalVariables
		globalVars = require('./variables');
		windowResize = globalVars.windowResize;

		magicController = globalVars.magicController;
		sceneCollection = globalVars.sceneCollection;

		//initialize elements;
		$backToTop = (!!config.$wrapper) ? config.$wrapper : $('.js-back-to-top') ;

		if ($backToTop.length === 0) {
			return;
		}

		$trigger = $backToTop.find('.back-to-top-trigger');

		//variables
		headerOffsets = globalVars.elementStates.headerHeight * -1;

		this.stickyTriggerInit(!!config.silentInit) ;

		this.triggerEventsInit();
	}
};

module.exports = BackToTop;

},{"./variables":75}],11:[function(require,module,exports){
'use strict';

var capabilityDetail = document.getElementById('capability-detail'),
	$siteHeader,
	$experienceSections,
    shareTools,
      
	//modules
	ReadMore,
	Accordions,
    ToggleMenu;

if(!capabilityDetail) {
    return;
}

//pull in global vars
$siteHeader = require('./variables').$elements.$siteHeader;


//initialize overview
ReadMore = require('./read-more');

//initialize Overview Read More If it's needed
var readMoreNodes = []; 
// readMoreNodes.push($(capabilityDetail).find('.js-read-more')); 
readMoreNodes.push($(capabilityDetail).find('.js-insights-listing')); 

if(readMoreNodes.length) {
    for (var i = 0; i < readMoreNodes.length; i++) {
        new ReadMore( readMoreNodes[i] ); 
    }
}

//Expand Latest Insights and News Component
$('#latest-insights .related-insights-view-more').click(); 

//initiialize Experience
Accordions = require('./accordions');

$experienceSections = $(capabilityDetail).find('.js-accordions');

var initAccordions = function($accordionSection) {
	
	new Accordions( $accordionSection );
};

for (var i = $experienceSections.length - 1; i >= 0; i--) {
	initAccordions( $experienceSections.eq(i) );
}

//share tools
ToggleMenu = require('./toggle-menu');

shareTools = new ToggleMenu($('.js-share-tools'));

//scrollspy initialization
window.ScrollSpy = require('./scrollspy');

window.ScrollSpy.init();

//return for garbage collection
capabilityDetail = shareTools = null;
for (var i = 0; i < readMoreNodes.length; i++) {
    readMoreNodes[i] = null;
}

},{"./accordions":2,"./read-more":59,"./scrollspy":60,"./toggle-menu":73,"./variables":75}],12:[function(require,module,exports){
'use strict';

var capabilityLanding = document.getElementById('capability-landing'),
	$capabilityLanding = $(capabilityLanding),
	$siteHeader,
	$accordions,

	//modules
	Accordions,
	pageOptions;

if(!capabilityLanding) {
    return;
}

//pull in global vars
$siteHeader = require('./variables').$elements.$siteHeader;

//initiialize Experience
Accordions = require('./accordions');

$accordions = $capabilityLanding.find('.js-accordions');

var initAccordions = function($accordionSection) {
	new Accordions( $accordionSection );
};

for (var i = $accordions.length - 1; i >= 0; i--) {
	initAccordions( $accordions.eq(i) );
}

//setup Capabilities Landing Form

pageOptions = {
	pageName: 'capabilities-landing',
	searchFormID: 'capabilities-keyword-search'
};

window.animationSearchLogic = require('./animation-search-logic');

window.animationSearchLogic.init(pageOptions);

// background images
var $backgroundImages = $('[data-background-img]');

$.each($backgroundImages, function(i) {
	var $this = $(this);

	$this.css('background-image', 'url(' + $this.attr('data-background-img') + ')').attr('data-background-img', '');
});

//scrollspy initialization
window.ScrollSpy = require('./scrollspy');


window.setTimeout(function(){
	//wait for content ot load
	window.ScrollSpy.init();
}, 300);


//return for garbage collection
capabilityLanding = null;
$capabilityLanding = null;

},{"./accordions":2,"./animation-search-logic":9,"./scrollspy":60,"./variables":75}],13:[function(require,module,exports){
'use strict';

require('./../vendor/slick-onenorth');

function CareersCarousel ($el) {
    this.$careersCarousel = (!!$el) ? $el : $('.js-careers-carousel').first();
        
    // Initialize Slick
    this.$arrows = this.$careersCarousel.find('.js-arrows');
    this.$slickCarousel = this.$careersCarousel.find('.js-carousel-slick');
    this.$slickCarousel.slick({
        infinite: false,
        dots: false,
        slide: '.js-carousel-slide',
        adaptiveHeight: false,
        prevArrow: this.$arrows.find('.js-arrow-left')[0],
        nextArrow: this.$arrows.find('.js-arrow-right')[0],
        speed: 300,
        slidesToShow: 1,
        fade: false,
        centerMode: true,
        variableWidth: true,
        responsive: [
            {
                breakpoint: 1086, // page-wrapper max-width
                settings: {
                    variableWidth: false,
                    centerMode: false,
                    adaptiveHeight: true
                }
            },
        ]
    });
    this.$arrows = null;
    
    // Bind navigation events
    var _self = this;
    this.$navigation = this.$careersCarousel.find('.js-slick-nav');
    this.$navigation.on('click.clickNav', '.js-nav-option', function(ev) {
        ev.stopPropagation();
        
        var selectedIndex = _self.$navigation.find('.js-nav-option').index( $(this) );
        
        _self.moveToCarouselSlide(selectedIndex);
    });

    this.$slickCarousel.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        // Update indicators
        var $navOptions = _self.$navigation.find('.js-nav-option');
        $navOptions
            .eq(currentSlide)
            .removeClass('is-selected')
            .attr('aria-selected', false);
        $navOptions
            .eq(nextSlide)
            .addClass('is-selected')
            .attr('aria-selected', true);
        $navOptions = null;

        // Pause Vimeo embedded video on current slide
        var $currentSlide = $(slick.$slides[currentSlide]);
        var iframe = $currentSlide.find('iframe')[0];
        if (iframe) {
            var player = new Vimeo.Player(iframe);
            player.pause();
            player = null;
        }
        $currentSlide = null;
    });
}

CareersCarousel.prototype.resetCarouselDisplay = function() {
    this.$slickCarousel.slick('setPosition');
}

CareersCarousel.prototype.moveToCarouselSlide = function(idx) {
    if (this.$slickCarousel.slick('slickCurrentSlide') === idx) return;

    this.$slickCarousel.slick('slickGoTo', idx);
}


module.exports = CareersCarousel;

},{"./../vendor/slick-onenorth":77}],14:[function(require,module,exports){
'use strict';

var careersDetail = document.getElementById('careers-detail'),
  $careersDetail = $(careersDetail),
  $accordions,
	//modules
  Accordions;

if(!careersDetail) {
    return;
}

//initiialize Experience
Accordions = require('./accordions');

$accordions = $careersDetail.find('.js-accordions');

var initAccordions = function ($accordionSection) {
  new Accordions($accordionSection);
};

for (var i = $accordions.length - 1; i >= 0; i--) {
  initAccordions($accordions.eq(i));
}

window.setTimeout(function () {
  //wait for content ot load
  window.ScrollSpy.init();
}, 300);


//return for garbage collection
careersDetail = null;

},{"./accordions":2}],15:[function(require,module,exports){
'use strict';

var careersLanding = document.getElementById('careers-landing'),
	shareTools;

if(!careersLanding) {
    return;
}


//initialization
window.BackToTop = require('./back-to-top');


window.BackToTop.init();


//return for garbage collection
careersLanding = null;
},{"./back-to-top":10}],16:[function(require,module,exports){
'use strict';

var careersPage = document.getElementById('careers-lawyer-page'),
	$careersPage = $(careersPage),
	$accordions,

	//modules
	Accordions,
	BackToTop,
	ToggleMenu,
	CareersCarousel;

if(!careersPage) {
    return;
}

//initialize overview
BackToTop = require('./back-to-top');
BackToTop.init();

//share tools
ToggleMenu = require('./toggle-menu');
$('.share-tools').each(function() {
  var shareTools = new ToggleMenu($(this));
});

require('./tabs')

CareersCarousel = require('./careers-carousel');
window.$careersCarousel = $('.js-careers-carousel');
if ($careersCarousel.length) {
	$careersCarousel.each(function(index, el) {
		new CareersCarousel($(el));
	});	
}

Accordions = require('./accordions');

$accordions = $careersPage.find('.js-accordions');

var initAccordions = function ($accordionSection) {
  new Accordions($accordionSection, { exclusive: true });
};

for (var i = $accordions.length - 1; i >= 0; i--) {
  initAccordions($accordions.eq(i));
}

//scrollspy initialization
window.ScrollSpy = require('./scrollspy');
window.ScrollSpy.init();


//return for garbage collection
careersPage = null;

},{"./accordions":2,"./back-to-top":10,"./careers-carousel":13,"./scrollspy":60,"./tabs":70,"./toggle-menu":73}],17:[function(require,module,exports){
'use strict';

var $careersLocationHeader = $('.js-careers-location-header'),
	$video;

if (!$careersLocationHeader.length) {
    return;
}

$video = $careersLocationHeader.find('video');

if ($video.length) {
    var videoSrc = $video.find('source')[0];

    videoSrc.setAttribute('src', videoSrc.getAttribute('data-lazy-video'));
    videoSrc.removeAttribute('data-lazy-video');

    $video[0].load();
    $video[0].play();
}
},{}],18:[function(require,module,exports){
'use strict';

var $carouselSpotlight,
	$slickCarousel,
	$navigation,
	$arrows,
	$video,	
	carouselSpotlight;

require('./../vendor/slick-onenorth');


carouselSpotlight = {
	carouselLogicInit: function () {

		$slickCarousel.slick({
			infinite: true,
			dots: false,
      slide: '.js-carousel-slide',
			adaptiveHeight: true,
			prevArrow: $arrows.find('.js-arrow-left')[0],
			nextArrow: $arrows.find('.js-arrow-right')[0],
			speed: 300,
			slidesToShow: 1,
			fade: true
		});

		//garbage collection
		$arrows = null;

	},
	resetCarouselDisplay: function() {
		$slickCarousel.slick('setPosition');
  },
  
	carouselSlidedEvent: function(){
		$slickCarousel.on('beforeChange', function(event, slick, currentSlide, nextSlide){
  			var $navOptions = $navigation.find('.js-nav-option');

  			$navOptions
  				.eq(currentSlide)
  				.removeClass('is-selected')
  				.attr('aria-selected', false);

			$navOptions
				.eq(nextSlide)
				.addClass('is-selected')
				.attr('aria-selected', true);

			//GC
			$navOptions = null;
		});
	},
	moveToCarouselSlide: function(idx){

		if( $slickCarousel.slick('slickCurrentSlide') === idx ) {return;}

		$slickCarousel.slick('slickGoTo', idx);

	},
	navigationLogicInit: function () {
		var _self = this;

		$navigation.on('click.clickNav', '.js-nav-option', function(ev){
			ev.stopPropagation();

      var selectedIndex = $navigation.find('.js-nav-option').index( $(this) ); //could cache navitems for better performance

			_self.moveToCarouselSlide(selectedIndex);

		});
	},
	videoInit: function () {
		$video = $carouselSpotlight.find('video');

		if ($video.length) {
			var videoSrc = $video.find('source')[0];

			videoSrc.setAttribute('src', videoSrc.getAttribute('data-lazy-video'));
			videoSrc.removeAttribute('data-lazy-video');

			$video[0].load();
			$video[0].play();
		}
	},
	init: function init($carouselNode) {

		//initialize elements;
    $carouselSpotlight = (!!$carouselNode) ? $carouselNode : $('.js-carousel-spotlight');
		
		$slickCarousel = $carouselSpotlight.find('.js-carousel-slick');

		$navigation = $carouselSpotlight.find('.js-slick-nav');

		$arrows = $carouselSpotlight.find('.js-arrows');

		this.carouselLogicInit();
		this.navigationLogicInit();
		this.carouselSlidedEvent();
		this.videoInit()
	}
};


module.exports = carouselSpotlight;

},{"./../vendor/slick-onenorth":77}],19:[function(require,module,exports){
function create(tag, className) {
  const element = document.createElement(tag);
  if (className) addClass(element, className);
  return element;
}

function append(container, child) {
  container.appendChild(child);
}

function addClass(element, className) {
  element.classList.add(className);
}

function createAndAppend({ tag, className, innerHTML, container }) {
  const element = create(tag, className);
  if (innerHTML) element.innerHTML = innerHTML;
  append(container, element);
}

module.exports = { create, append, addClass, createAndAppend };
},{}],20:[function(require,module,exports){
'use strict';

var entitySearchModule,
	$keywordSearch,
	$clearAll,
	pageOptions,

	//module exports	
	animationSearchLogic = require('./animation-search-logic'),
	throwawayLogic = require('./throwaway-search-logic'),

	//export module
	entitySearchControl;


entitySearchControl = {
	handleContentDisplay: function() {

		var opportunityPanel = document.getElementById(pageOptions.defaultContentID);

		if (!!opportunityPanel) {
			(opportunityPanel.getAttribute('aria-hidden') === 'false' ) ? (
				animationSearchLogic.transitionFromDefaultToResults()
			) : (
				animationSearchLogic.showSearchResults()
			);
		}
	},
	initClearAllEvent: function() {

		$clearAll.on('click.clearResults', function(ev) {
			ev.stopPropagation();

			animationSearchLogic.transitionToSearchDefault();
		});
		
	},
	transitionToSearchDefault: function() {
		animationSearchLogic.transitionToSearchDefault();
	},
	transitionFromDefaultToResults: function() {
		animationSearchLogic.transitionFromDefaultToResults();
	},
	showSearchResults: function() {
		animationSearchLogic.showSearchResults();
	},	
	showLoadingScreen: function(){
		animationSearchLogic.showLoadingScreen();
	},
	hideLoadingScreen: function(){
		animationSearchLogic.hideLoadingScreen();
	},
	initSubmitEvent: function() {

		var _self = this;

		$( entitySearchModule ).submit(function( ev ) {

			ev.preventDefault();

			_self.handleContentDisplay();

			if( !!$keywordSearch.val() ) {
				throwawayLogic.applySelectedFilter( $keywordSearch.val() );
			}
		
		});
	},
	init: function init(pageConfig) {

		if(!pageConfig) {
			//console.log('invalid argument, need Object supplied' );
		}

		pageOptions = pageConfig;
		pageOptions.searchFormID = 'entity-search-control';


		//assign vanilla elements
		entitySearchModule = document.getElementById('entity-search-control');

		//assign jquery elements
		$keywordSearch = $(entitySearchModule).find('.js-keyword-search').find('input');
		$clearAll = $('.js-applied-filters').find('.js-filter-clear');


		//can be removed 
		animationSearchLogic.init(pageOptions);

		this.initSubmitEvent();
		this.initClearAllEvent();
	}
};

module.exports = entitySearchControl;

},{"./animation-search-logic":9,"./throwaway-search-logic":72}],21:[function(require,module,exports){
'use strict';

var $exposedSearchFilters,
	$dropdowns,
	options,


	//module exports
	selectDropdowns,
	exposedSearchFilters;


exposedSearchFilters = {

	selectDropdownsInit: function(cb){
		/*----------  initialize dropdown Functionality  ----------*/

		$dropdowns = $exposedSearchFilters.find('.js-select-dropdown');

		selectDropdowns($dropdowns, cb);

		//back to gc
		$dropdowns = null;
	},
	init: function init(config) {

		options = (!!config) ? config : {};

		//modules
		selectDropdowns = require('./select-dropdown');

		//globalVariables
		$exposedSearchFilters = (!!options.$module) ? options.$module : $('.js-exposed-search-filters');
		
		this.selectDropdownsInit(config.callback);


		if( typeof config.categoryCallback === 'function') {
			
			this.categoryFiltersInit();
		}

		config = null ;
	}

};


module.exports = exposedSearchFilters;

},{"./select-dropdown":65}],22:[function(require,module,exports){
//open all external links in new window
$(document).ready(function() {
    $('a:not([href^="http://' + window.location.host + '"]):not([href^="https://' + window.location.host + '"]):not([href^="#"]):not([href^="/"]):not([href^="mailto:"]):not([href^="javascript:void(0);"]):not([href^="javascript:void(0)"]):not([target="_self"])').attr("target", "_blank");
});
},{}],23:[function(require,module,exports){
'use strict';

var $featuredCarousel,
	$slickCarousel,
	$navigation,
	$arrows,

	showNavClass,

	//module exports
	globalVars,
	
	featuredCarousel;

require('./../vendor/slick-onenorth');


featuredCarousel = {
	carouselLogicInit: function () {

		$slickCarousel.slick({
			infinite: true,
			dots: false,
			slide: '.js-featured-topic-slide',
			adaptiveHeight: true,
			prevArrow: $arrows.find('.js-arrow-left')[0],
			nextArrow: $arrows.find('.js-arrow-right')[0],
			speed: 300,
			slidesToShow: 1
		});

		//garbage collection
		$arrows = null;

	},
	resetCarouselDisplay: function() {
		$slickCarousel.slick('setPosition');
	},
	mobileToggleInit: function(){

		$navigation.on('click.mobileToggle', '.js-mobile-toggle', function(ev){
			ev.stopPropagation();

			if(window.innerWidth > 860) {return;}

			if( $navigation.hasClass(showNavClass) ) {
				$navigation.removeClass(showNavClass)
					.find('.featured-carousel-nav-list')
						.attr('aria-hidden', 'true');

				$(this).attr('aria-expanded', 'false');

			} else {
				$navigation.addClass(showNavClass)
					.find('.featured-carousel-nav-list')
						.attr('aria-hidden', 'false');

				$(this).attr('aria-expanded', 'true');
			}
		});	
	},
	carouselSlidedEvent: function(){
		$slickCarousel.on('beforeChange', function(event, slick, currentSlide, nextSlide){
  			var $navOptions = $navigation.find('.js-nav-option');

  			$navOptions
  				.eq(currentSlide)
  				.removeClass('is-selected')
  				.attr('aria-selected', false);

			$navOptions
				.eq(nextSlide)
				.addClass('is-selected')
				.attr('aria-selected', true);

			//GC
			$navOptions = null;
		});
	},
	moveToCarouselSlide: function(idx){

		if( $slickCarousel.slick('slickCurrentSlide') === idx ) {return;}

		$slickCarousel.slick('slickGoTo', idx);

	},
	navigationLogicInit: function () {
		var _self = this;

		$navigation.on('click.carouselNav', '.js-nav-option', function(ev){
			ev.stopPropagation();

			var selectedIndex = $navigation.find('.js-nav-option').index( $(this) ); //could cache navitems for better performance

			_self.moveToCarouselSlide(selectedIndex);

			$navigation.removeClass(showNavClass);

		});
	},
	updateAriaStatus: function() {

		if(globalVars.isMobile || window.innerWidth < 861) {
			$navigation.find('.featured-carousel-nav-list')
					.attr('aria-hidden', 'true')
				.end()
				.find('.js-mobile-toggle')
					.attr('aria-expanded', 'false');
		} else {
			$navigation.find('.featured-carousel-nav-list')
					.attr('aria-hidden', 'false')
				.end()
					.find('.js-mobile-toggle')
					.attr('aria-expanded', 'true');
		}
	},
	init: function init($carouselNode) {

		//initialize elements;
		$featuredCarousel = (!!$carouselNode) ? $carouselNode : $('.js-featured-carousel');
		
		$slickCarousel = $featuredCarousel.find('.js-carousel-slick');

		$navigation = $featuredCarousel.find('.js-nav');

		$arrows = $featuredCarousel.find('.js-arrows');

		showNavClass = 'show-topics';

		globalVars = require('./variables');

		this.carouselLogicInit();
		this.navigationLogicInit();
		this.carouselSlidedEvent();
		this.mobileToggleInit();
		this.updateAriaStatus();
		
	}
};


module.exports = featuredCarousel;

},{"./../vendor/slick-onenorth":77,"./variables":75}],24:[function(require,module,exports){
'use strict';

var $jumpLinks = $("a[href*=#ftn],a[href*=#topftn]");

if (!$jumpLinks || $jumpLinks.length == 0) {
	return;
}

var globalVars = require('./variables'),
	cachedElements = globalVars.elementStates

$jumpLinks.each(function(){
    var $this = $(this); 

    // Check for already bound click events
    if (!$this.data('events') || !$this.data('events').click || $this.data('events').click.length == 0) {

    	// Get Anchor and Find Target
	    var anchorHref = $this.attr("href");

	    if (!! anchorHref) { 
	    	
	    	// Check If Target Exists
	    	var $target = $('[name=' +  anchorHref.substring(1) + ']');

	    	if (!!$target && $target.length > 0) {

	    		// Add Click Event With Header offset
	    		$this.on('click.jumpLink', function(ev) {
					ev.preventDefault();
					ev.stopPropagation();

					var elementOffset = parseInt( $target.get(0).getBoundingClientRect().top + window.pageYOffset , 10);

					elementOffset = Math.ceil((elementOffset - cachedElements.headerHeight) - 10);

					$('html,body').animate({
						scrollTop:elementOffset 
					}, 500);

				});
	    	}
	    }
	}
	
})

},{"./variables":75}],25:[function(require,module,exports){
const { create, append, addClass } = require("./dom-utils");

function createAudioControls({ audioElement, source, transcript, className }) {
  let audio;
  if (audioElement) {
    audio = audioElement;
  } else {
    audio = create("audio", className);
    audio.src = source;
  }
  const controls = create("div", `${className}--controls`);
  append(controls, audio);
  const audioButton = create("button", `${className}--button`);
  audioButton.classList.add("paused");
  audioButton.setAttribute("aria-label", "Toggle audio playback");
  append(controls, audioButton);
  const playIcon = create("span", `${className}--play-icon`);
  playIcon.innerHTML = `
  <svg tabindex="-1" width="15" height="20" viewBox="0 0 15 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path tabindex="-1" d="M0.319092 19.3297V0.787109L14.4468 10.4999L0.319092 19.3297Z" fill="#DB4535"/>
  </svg>
  `;
  const pauseIcon = create("span", `${className}--pause-icon`);
  pauseIcon.innerHTML = `
  <svg tabindex="-1" width="2" height="11" viewBox="0 0 2 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path tabindex="-1" d="M1 0V10.5" stroke="#DB4535" stroke-width="2"/>
  </svg>
  <svg tabindex="-1" width="2" height="11" viewBox="0 0 2 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path tabindex="-1" d="M1 0V10.5" stroke="#DB4535" stroke-width="2"/>
  </svg>
  `;
  [playIcon, pauseIcon].forEach((icon) => {
    icon.setAttribute("aria-hidden", "true");
  });
  append(audioButton, playIcon);
  append(audioButton, pauseIcon);

  const timestamp = create("div", `${className}--timestamp`);
  const current = create("span", `${className}--timestamp-current`);
  current.textContent = formatTime(audio.currentTime);
  const divider = create("span", `${className}--timestamp-divider`);
  divider.textContent = " / ";
  const duration = create("span", `${className}--timestamp-duration`);
  duration.textContent = formatTime(audio.duration);
  append(timestamp, current);
  append(timestamp, divider);
  append(timestamp, duration);
  append(controls, timestamp);

  const progressContainer = create("div", `${className}--progress-outer`);
  const progressBar = create("div", `${className}--progress-inner`);
  progressBar.style.transform = "translate3d(-100%, 0px, 0px)";
  append(progressContainer, progressBar);
  append(controls, progressContainer);

  const menuContainer = create("div", `${className}--menu-container`);
  const menuButton = create("button", `${className}--menu-button`);
  menuButton.innerHTML = `
  <span class="visually-hidden">Audio menu</span>
  <div class="audio-menu-dot"></div>
  <div class="audio-menu-dot"></div>
  <div class="audio-menu-dot"></div>
  `;
  const menu = create("ul", `${className}--menu`);
  menu.setAttribute("data-expanded", "false");
  menu.setAttribute("aria-expanded", "false");
  append(menuContainer, menuButton);
  append(menuContainer, menu);

  const clickOutsideMenu = (e) => {
    if (menuButton.contains(e.target)) return;
    if (!menu.contains(e.target)) toggleMenu();
  }
  const toggleMenu = () => {
    menu.dataset.expanded = menu.dataset.expanded === "true" ? "false" : "true";
    menu.setAttribute("aria-expanded", `${menu.dataset.expanded}`);
    if (menu.dataset.expanded === "true") {
      window.addEventListener('click', clickOutsideMenu, true);
    } else {
      window.removeEventListener('click', clickOutsideMenu, true);
    }
  };

  menuButton.addEventListener("click", toggleMenu);

  const downloadLink = create("li", `${className}--download`);
  downloadLink.innerHTML = `<a href="${audio.src}">Download</a>`;
  append(menu, downloadLink);
  if (transcript) {
    const transcriptLink = create("li", `${className}--transcript`);
    transcriptLink.innerHTML = `<a href="${transcript}" target="_blank" rel="noopener noreferrer">View Transcript</a>`;
    append(menu, transcriptLink);
  }
  append(controls, menuContainer);

  audio.addEventListener("canplaythrough", () => {
    duration.textContent = formatTime(audio.duration);
  });
  audio.addEventListener("timeupdate", () => {
    current.textContent = formatTime(audio.currentTime);
    progressBar.style.transform = `translate3d(${
      (audio.currentTime / audio.duration - 1) * 100
    }%, 0px, 0px)`;
  });
  audioButton.addEventListener("click", () => {
    if (audio.paused) {
      audioButton.classList.remove("paused");
      audio.play();
    } else {
      audioButton.classList.add("paused");
      audio.pause();
    }
  });
  return controls;
}

function formatTime(time) {
  const minutes = Math.floor((time || 0) / 60);
  const seconds = Math.floor((time || 0) % 60)
    .toString()
    .padStart(2, "0");
  return `${minutes}:${seconds}`;
}

module.exports = createAudioControls;

},{"./dom-utils":19}],26:[function(require,module,exports){
const { append } = require("./dom-utils");
const createAudioControls = require("./foundation-audio");
const modals = require("./foundation-modals");

const carouselClass = ".foundation-homepage-carousel";

function createCarousel() {
  let index = 0;
  let itemsLength = 5;

  function init() {
    const carouselItems = document.querySelectorAll(`${carouselClass}__item`);
    itemsLength = carouselItems.length;

    const carouselItemBodies = document.querySelectorAll(`${carouselClass}__item--body`);
    carouselItemBodies.forEach((body) => {
      if (body.scrollHeight > body.clientHeight) {
        const parent = body.parentElement;
        if (!parent) return;
        parent.classList.add('can-scroll');
        body.addEventListener('scroll', (e) => {
          if (e.target.scrollTop === (e.target.scrollHeight - e.target.clientHeight)) {
            parent.classList.add('at-bottom');
          } else {
            if (parent.classList.contains('at-bottom')) parent.classList.remove('at-bottom');
          }
        });
      }
    });

    const leftButtons = document.querySelectorAll(
      `${carouselClass}__nav--left`
    );
    const rightButtons = document.querySelectorAll(
      `${carouselClass}__nav--right`
    );
    const itemButtons = document.querySelectorAll(`${carouselClass}__nav--btn`);
    const videoButtons = document.querySelectorAll(
      `${carouselClass}__item--video-button`
    );
    const audios = document.querySelectorAll(
      `${carouselClass}__item--audio-container`
    );
    itemButtons.forEach((button) => {
      button.addEventListener("click", () => {
        select(parseInt(button.dataset.buttonIndex, 10));
      });
    });
    leftButtons.forEach((button) => {
      button.addEventListener("click", decrement);
    });
    rightButtons.forEach((button) => {
      button.addEventListener("click", increment);
    });
    videoButtons.forEach((button) => {
      button.addEventListener("click", () => {
        modals.video(button.dataset.videoEmbed, () => {
          button.focus();
        });
      });
    });
    audios.forEach((audio) => {
      const audioElement = audio.querySelector("audio");
      const customAudioEl = createAudioControls({
        audioElement,
        transcript: audio.dataset.transcript,
        className: `foundation-homepage-carousel__item--audio`,
      });
      append(audio, customAudioEl);
    });
  }

  function setActiveCarouselItem(newIndex) {
    const currentItem = document.querySelector(".active-item");
    const nextItem = document.querySelector(
      `[data-carousel-index="${newIndex}"]`
    );
    if (!nextItem || !currentItem) return;
    currentItem.classList.remove("active-item");
    nextItem.classList.add("active-item");
  }

  function set(newIndex) {
    if (index === newIndex) return;
    index = newIndex;
    setActiveCarouselItem(index);
  }

  function select(newIndex) {
    set(newIndex);
    focusSelected();
  }

  function increment() {
    const nextIndex = index === itemsLength - 1 ? 0 : index + 1;
    set(nextIndex);
    focusIncrement();
  }

  function decrement() {
    const nextIndex = index === 0 ? itemsLength - 1 : index - 1;
    set(nextIndex);
    focusDecrement();
  }

  function focus(element) {
    element.focus();
  }

  function focusIncrement() {
    const currentItem = document.querySelector(
      `.active-item ${carouselClass}__nav--right`
    );
    focus(currentItem);
  }

  function focusDecrement() {
    const currentItem = document.querySelector(
      `.active-item ${carouselClass}__nav--left`
    );
    focus(currentItem);
  }

  function focusSelected() {
    const currentItem = document.querySelector(
      `.active-item [data-button-index="${index}"]`
    );
    focus(currentItem);
  }

  return {
    init,
  };
}
const carousel = createCarousel();
module.exports = carousel;

},{"./dom-utils":19,"./foundation-audio":25,"./foundation-modals":33}],27:[function(require,module,exports){
'use strict';

var foundationFacts = document.getElementById('foundation-facts'),


	//modules
	selectDropdowns;

if(!foundationFacts) {
    return;
}


/*----------  initialize dropdown Functionality  ----------*/
selectDropdowns =  require('./select-dropdown');

var $dropdowns = $(foundationFacts).find('.js-select-dropdown');

selectDropdowns($dropdowns);



//return for garbage collection
foundationFacts = $dropdowns = null;

},{"./select-dropdown":65}],28:[function(require,module,exports){
'use strict';

var foundationFellowsDirectory = document.getElementById('foundation-fellows'),
	
	//modules
	throwawaySearchLandingFilters,
	pageOptions;

if(!foundationFellowsDirectory) {
    return;
}

pageOptions = {
	pageName: 'foundation-fellows',
	searchResultsID: '',
	filterCategories: true,
	activateBackToTop: false,
	exposedSearchFilters: true,
	alphaSearch: true
};

//window.SearchLandingFilters = require('./search-landing-filters');

//window.SearchLandingFilters.init(pageOptions);

window.ThrowawaySearchLandingFilters = require('./throwaway-search-landing-filters');

window.ThrowawaySearchLandingFilters.init(pageOptions);

//return for garbage collection
foundationFellowsDirectory = null;
},{"./throwaway-search-landing-filters":71}],29:[function(require,module,exports){
'use strict';

var foundationForumDetail = document.getElementById('foundation-forum-detail'),
	shareTools,
	

	//modules
	
	ToggleMenu;

if(!foundationForumDetail) {
    return;
}


//initialization
window.BackToTop = require('./back-to-top');


window.BackToTop.init();

//share tools
ToggleMenu = require('./toggle-menu');


shareTools = new ToggleMenu($('.share-tools'));


//return for garbage collection
foundationForumDetail = null;
},{"./back-to-top":10,"./toggle-menu":73}],30:[function(require,module,exports){
'use strict';

var foundationForum = document.getElementById('foundation-forum'),
	
	//modules
	EntitySearchControl;

if(!foundationForum) {
    return;
}

window.EntitySearchControl = require('./entity-search-control');

window.EntitySearchControl.init({
	pageName: 'foundation-forum',
	searchResultsID: 'search-landing-results',
	defaultContentID: 'forum-latest-posts',
	activateBackToTop: false
});



//return for garbage collection
foundationForum = null;
},{"./entity-search-control":20}],31:[function(require,module,exports){
'use strict';

var genericContent = document.getElementById('foundation-generic-content'),
	shareTools,	

	//modules
	ToggleMenu;

if(!genericContent) {
    return;
}

//initialization
window.BackToTop = require('./back-to-top');

window.BackToTop.init();

//share tools
ToggleMenu = require('./toggle-menu');

shareTools = new ToggleMenu($('.js-share-tools'));
//return for garbage collection
genericContent = shareTools = null;
},{"./back-to-top":10,"./toggle-menu":73}],32:[function(require,module,exports){
"use strict";

var foundationHomepage = document.getElementById("foundation-homepage"),
  //modules
  heroExplore;

if (!foundationHomepage) {
  return;
}

heroExplore = require("./hero-explore");

heroExplore.init();

//return for garbage collection
foundationHomepage = null;

const carousel = require('./foundation-carousel');
carousel.init();

const timeline = require('./foundation-timeline');
timeline.init();

},{"./foundation-carousel":26,"./foundation-timeline":36,"./hero-explore":40}],33:[function(require,module,exports){
const createAudioControls = require("./foundation-audio");
const { create, append, addClass, createAndAppend } = require("./dom-utils");

const fellowModalClass = "foundation-homepage-fellow-modal";
const modalTimeout = 300;

const modals = createModalManager();
module.exports = modals;

function createModalManager() {
  const modals = [];

  function fellow({ fellow, videoButtonLabel }, closeCallback) {
    const fellowModal = launchFellowModal(fellow, videoButtonLabel);
    modals.push(fellowModal);
    const callback = () => {
      modals.pop();
      closeCallback();
    };
    fellowModal.launch(callback);
  }

  function video(embed, closeCallback) {
    const videoModal = launchVideoModal(embed);
    modals.push(videoModal);
    const videoModalIndex = modals.indexOf(videoModal);

    const previousModal =
      videoModalIndex > 0 ? modals[videoModalIndex - 1] : undefined;
    if (previousModal) previousModal.removeClickOutside();
    const callback = () => {
      modals.pop();
      closeCallback();
      if (previousModal) previousModal.attachClickOutside();
    };
    videoModal.launch(callback);
  }

  return { fellow, video };
}

function launchFellowModal(fellow, videoButtonLabel) {
  const modal = createModal(fellowModalClass);
  modal.init();
  const modalBody = create("div", `${fellowModalClass}__body`);
  modal.add(modalBody);
  const modalAssets = create("div", `${fellowModalClass}__assets`);

  if (fellow.Image) {
    const imageContainer = create(
      "div",
      `${fellowModalClass}__image-container`
    );
    const img = create("img", `${fellowModalClass}__image`);
    img.src = fellow.Image;
    img.alt = fellow.ImageCaption || fellow.Name;
    append(imageContainer, img);

    if (fellow.ImageCaption) {
      createAndAppend({
        tag: "span",
        className: `${fellowModalClass}__image-caption`,
        innerHTML: fellow.ImageCaption,
        container: imageContainer,
      });
    }
    modal.add(imageContainer);
  }
  if (fellow.Category) {
    createAndAppend({
      tag: "span",
      className: `${fellowModalClass}__category`,
      innerHTML: fellow.Category,
      container: modalBody,
    });
  }
  if (fellow.Title) {
    createAndAppend({
      tag: "span",
      className: `${fellowModalClass}__title`,
      innerHTML: fellow.Title,
      container: modalBody,
    });
  }
  if (fellow.Name) {
    createAndAppend({
      tag: "h2",
      className: `${fellowModalClass}__name`,
      innerHTML: fellow.Name,
      container: modalBody,
    });
    createAndAppend({
      tag: "div",
      className: `${fellowModalClass}__divider`,
      container: modalBody,
    });
  }
  if (fellow.Content) {
    createAndAppend({
      tag: "span",
      className: `${fellowModalClass}__content`,
      innerHTML: fellow.Content,
      container: modalAssets,
    });
  }
  if (fellow.Audio) {
    const audio = createAudioControls({
      source: fellow.Audio,
      transcript: fellow.Transcript,
      className: `${fellowModalClass}__audio`,
    });
    append(modalAssets, audio);
  }
  if (fellow.Video) {
    const videoButton = createWatchVideoButton(
      `${fellowModalClass}__video-button`,
      videoButtonLabel
    );
    videoButton.dataset.videoEmbed = fellow.Video;
    videoButton.addEventListener("click", () => {
      modals.video(fellow.Video, () => {
        videoButton.focus();
      });
    });
    append(modalAssets, videoButton);
  }
  if (fellow.Quote) {
    createAndAppend({
      tag: "p",
      className: `${fellowModalClass}__quote`,
      innerHTML: fellow.Quote,
      container: modalAssets,
    });
  }
  append(modalBody, modalAssets);

  return modal;
}

const videoModalClass = "foundation-homepage-video-modal";
const LT = /&lt;/g;
const GT = /&gt;/g;

function launchVideoModal(embed) {
  const modal = createModal(videoModalClass);
  modal.init();
  const body = create("div", `${videoModalClass}__body`);
  body.innerHTML = embed
    .replace(LT, "<")
    .replace(GT, ">")
    .replace(/web-share/g, "");
  modal.add(body);
  return modal;
}

function createModal(className) {
  let modal;
  let modalContainer;
  let closeButton;
  let focusManager;
  let clickOutside;

  function init() {
    modal = create("div", className);
    modalContainer = create("div", `${className}__container`);
    closeButton = createCloseButton(`${className}__close-button`);
    const closeButtonContainer = create("div", `${className}__close-button-container`);
    append(closeButtonContainer, closeButton);
    append(modalContainer, closeButtonContainer);
    append(modal, modalContainer);
  }

  function launch(closeCallback) {
    if (!modal) return;

    append(document.body, modal);
    document.body.style.overflow = "hidden";
    setTimeout(() => {
      addClass(modal, 'modal-intro');
    }, modalTimeout);
    
    handleFocus();

    closeButton.addEventListener("click", () => close(closeCallback));
    attachClickOutside(closeCallback);
  }

  function close(closeCallback) {
    if (!modal) return;
    removeClickOutside();
    document.removeEventListener("keydown", focusManager);
    addClass(modal, "modal-outro");
    setTimeout(() => {
      document.body.removeChild(modal);
      document.body.style.overflow = "visible";
      if (closeCallback) closeCallback();
    }, modalTimeout);
  }

  function add(element) {
    append(modalContainer, element);
  }

  function handleFocus() {
    const focusableElements =
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
    const firstFocusableElement = modal.querySelectorAll(focusableElements)[0];
    const lastFocusableElement =
      modal.querySelectorAll(focusableElements)[focusableElements.length - 1];
    focusManager = (e) => {
      if (e.key !== "Tab") return;
      if (e.shiftKey) {
        if (document.activeElement === firstFocusableElement) {
          e.preventDefault();
          lastFocusableElement.focus();
        }
      } else {
        if (document.activeElement === lastFocusableElement) {
          e.preventDefault();
          firstFocusableElement.focus();
        }
      }
    };
    document.addEventListener("keydown", focusManager);
    firstFocusableElement.focus();
  }

  function attachClickOutside(closeCallback) {
    if (!clickOutside) {
      clickOutside = function (e) {
        if (!modalContainer.contains(e.target)) close(closeCallback);
      };
    }
    setTimeout(() => {
      window.addEventListener("click", clickOutside, true);
    }, 0);
  }

  function removeClickOutside() {
    window.removeEventListener("click", clickOutside, true);
  }
  return { init, add, launch, attachClickOutside, removeClickOutside };
}

function createCloseButton(className) {
  const closeButton = create("button", className);
  closeButton.innerHTML = `
  <span class="visually-hidden">Close modal</span>
  <svg tabindex="-1" width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path tabindex="-1" d="M1 1L12 12" stroke="white" stroke-width="2"/>
    <path tabindex="-1" d="M12 1L1 12" stroke="white" stroke-width="2"/>
  </svg>`;
  return closeButton;
}

function createWatchVideoButton(className, labelText, textHidden = false) {
  const watchVideoButton = create("button", className);
  const textContent = labelText || 'Watch video';
  watchVideoButton.innerHTML = `
  <span class="${className}--icon" aria-hidden="true">
    <svg tabindex="-1" width="15" height="20" viewBox="0 0 15 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path tabindex="-1" d="M0.319092 19.3297V0.787109L14.4468 10.4999L0.319092 19.3297Z" fill="white"/>
    </svg>
  </span>
  <span class="${className}--text ${
    textHidden ? "visually-hidden" : ""
  }">${textContent}</span>`;
  return watchVideoButton;
}

},{"./dom-utils":19,"./foundation-audio":25}],34:[function(require,module,exports){
'use strict';

var foundationNewsDetail = document.getElementById('fountation-news-detail'),
	shareTools,
	

	//modules
	ToggleMenu;

if(!foundationNewsDetail) {
    return;
}


//initialization
window.BackToTop = require('./back-to-top');


window.BackToTop.init();

//share tools
ToggleMenu = require('./toggle-menu');


shareTools = new ToggleMenu($('.share-tools'));


//return for garbage collection
foundationNewsDetail = null;
},{"./back-to-top":10,"./toggle-menu":73}],35:[function(require,module,exports){
'use strict';

var foundationNewsStories = document.getElementById('foundation-news-stories'),
	
	//modules
	throwawaySearchLandingFilters,
	searchLandingPanels,
	pageOptions;

if(!foundationNewsStories) {
    return;
}

pageOptions = {
	pageName: 'foundation-news-stories',
	searchResultsID: 'search-landing-results',
	filterCategories: true,
	activateBackToTop: true,
	activateBackToTopSilent: true,
	categoryFilters: true,
	advancedSearch: true
};

// Panels
window.SearchLandingPanels = require('./search-landing-panels');

window.SearchLandingPanels.init(false, pageOptions);

window.ThrowawaySearchLandingFilters = require('./throwaway-search-landing-filters');

window.ThrowawaySearchLandingFilters.init(pageOptions);

window.animationSearchLogic = require('./animation-search-logic');

//return for garbage collection
foundationNewsStories = null;
},{"./animation-search-logic":9,"./search-landing-panels":63,"./throwaway-search-landing-filters":71}],36:[function(require,module,exports){
const modals = require("./foundation-modals");

const timelineClass = ".foundation-homepage-timeline";

function createTimeline() {
  // DOM elements
  let timeline;
  let container;
  let cards;

  // internal state
  let intersecting = false;
  let scrolling = false;
  let shouldCheckHover = false;
  let touching = false;
  let dragging = false;
  let initialX;
  let scrollLeft;

  function init() {
    timeline = document.querySelector(timelineClass);
    container = document.querySelector(`${timelineClass}__container`);

    const containerObserverConfig = {
      rootMargin: "0px",
      threshold: 0.9,
    };
    const containerObserver = new IntersectionObserver((entries) => {
      setIntersecting(entries[0].isIntersecting);
      shouldCheckHover = entries[0].isIntersecting;
    }, containerObserverConfig);
    containerObserver.observe(container);

    const cardObserverConfig = {
      root: timeline,
      rootMargin: "0% -50%",
      threshold: 0,
    };
    const cardObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setActiveGroup(entry.target.dataset.timelineIndex);
        }
      });
    }, cardObserverConfig);

    cards = Array.from(document.querySelectorAll(`${timelineClass}__card`));
    cards.forEach((card, index) => {
      const positionClass =
        index === 0 ? "top" : index % 2 === 0 ? "top" : "bottom";
      card.classList.add(positionClass);
      cardObserver.observe(card);
    });

    const lastCardObserverConfig = {
      root: timeline,
      threshold: 1,
    };
    const lastCardObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setActiveGroup(entry.target.dataset.timelineIndex);
        }
      });
    }, lastCardObserverConfig);
    lastCardObserver.observe(cards.at(-1));

    attachButtonListeners();
    attachContainerListeners();
    splitFellowName();
  }

  function attachContainerListeners() {
    let touchendTimeout;
    container.addEventListener("touchstart", () => {
      clearTimeout(touchendTimeout);
      touching = true;
      cancelAutoScroll();
    });
    container.addEventListener("touchend", () => {
      if (!touching) return;
      clearTimeout(touchendTimeout);

      if (intersecting) {
        // set timeout to allow some inertia scroll
        touchendTimeout = setTimeout(() => {
          touching = false;
          initAutoScroll();
        }, 500);
      }
    });
    container.addEventListener("mousedown", handleTimelineMouseDown);
    container.addEventListener("mousemove", handleTimelineMouseMove);
    container.addEventListener("mouseup", handleTimelineMouseUp);
    container.addEventListener("mouseleave", handleTimelineMouseLeave);
  }

  function handleTimelineMouseDown(e) {
    e.stopPropagation();
    if (touching) return;
    cancelAutoScroll();
    initialX = e.pageX;
    scrollLeft = container.scrollLeft;
    setDragging(true);
  }

  function handleTimelineMouseMove(e) {
    if (!dragging) return;
    container.scrollLeft = scrollLeft - (e.pageX - initialX);
  }

  function handleTimelineMouseUp() {
    setDragging(false);
    initialX = undefined;
    scrollLeft = undefined;
    if (intersecting && shouldCheckHover) initAutoScroll();
  }

  function handleTimelineMouseLeave() {
    setDragging(false);
    if (intersecting && shouldCheckHover) initAutoScroll();
  }

  function attachButtonListeners() {
    const timelineNavButtons = document.querySelectorAll(
      `${timelineClass}__nav--button`
    );
    timelineNavButtons.forEach((button, index) => {
      button.addEventListener("click", () => handleTimelineNavClick(index));
    });
    const timelineCardButtons = document.querySelectorAll(
      `${timelineClass}__card--button`
    );
    timelineCardButtons.forEach((button) => {
      const { timelineGroup, timelineName } = button.dataset;
      button.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
      });
      button.addEventListener("mouseenter", handleTimelineCardMouseEnter);
      button.addEventListener("mouseleave", handleTimelineCardMouseLeave);
      button.addEventListener("mousedown", handleTimelineMouseDown);
      button.addEventListener("mousemove", (e) => {
        handleTimelineCardMouseMove({ event: e, button });
      });
      button.addEventListener("mouseup", (e) => {
        handleTimelineCardMouseUp({
          button,
          timelineGroup,
          timelineName,
          event: e,
        });
      });
      button.addEventListener("touchstart", handleTimelineCardTouchStart);
      button.addEventListener("touchend", (e) => {
        if (Math.abs(initialX - e.changedTouches[0].pageX) < 10) {
          handleTimelineCardClick({ button, timelineGroup, timelineName });
        }
      });
    });
  }

  function handleTimelineCardClick({ button, timelineGroup, timelineName }) {
    const timelineGroups = window.TimelineGroups;
    if (!timelineGroups) return;
    const group = timelineGroups.find((g) => g.Title === timelineGroup);
    if (!group) return;
    const videoButtonLabel = group.VideoButtonLabel;
    const fellow = group.Fellows.find((f) => f.Name === timelineName);
    if (!fellow) return;
    shouldCheckHover = false;
    touching = false;
    cancelAutoScroll();
    modals.fellow({ fellow, videoButtonLabel }, () => {
      button.focus();
      if (intersecting) {
        shouldCheckHover = true;
        initAutoScroll();
      }
    });
  }

  function handleTimelineCardTouchStart(e) {
    initialX = e.changedTouches[0].pageX;
  }

  function handleTimelineCardMouseMove({ event, button }) {
    if (!dragging) return;
    button.classList.add("dragging");
    container.scrollLeft = scrollLeft - (event.pageX - initialX);
  }

  function handleTimelineCardMouseUp({
    button,
    timelineGroup,
    timelineName,
    event,
  }) {
    event.preventDefault();
    event.stopPropagation();
    setDragging(false);
    button.classList.remove("dragging");
    if (Math.abs(initialX - event.pageX) < 10) {
      handleTimelineCardClick({ button, timelineGroup, timelineName });
    }
    initialX = undefined;
    scrollLeft = undefined;
  }

  function handleTimelineCardMouseEnter() {
    if (dragging) return;
    if (intersecting && shouldCheckHover) {
      cancelAutoScroll();
    }
  }

  function handleTimelineCardMouseLeave() {
    if (dragging) return;
    if (intersecting && shouldCheckHover) {
      initAutoScroll();
    }
  }

  function setDragging(isDragging) {
    dragging = isDragging;
    const method = dragging ? "add" : "remove";
    container.classList[method]("dragging");
  }

  function setIntersecting(isIntersecting) {
    if (intersecting === isIntersecting) return;
    intersecting = isIntersecting;
    if (intersecting) {
      initAutoScroll();
    } else {
      cancelAutoScroll();
    }
  }

  function initAutoScroll() {
    const properties = { scrollLeft: `${container.scrollWidth}` };
    const options = {
      duration: (container.scrollWidth - container.scrollLeft) * 15,
      easing: "linear",
    };
    $(container).animate(properties, options);
  }

  function cancelAutoScroll() {
    $(container).stop(true);
  }

  function handleTimelineNavClick(index) {
    const nextSection = cards.find((card) => card.dataset.timelineIndex === index.toString());
    if (!nextSection) return;

    const properties = { scrollLeft: `${nextSection.offsetLeft}` };
    const options = {
      duration: 1000,
      start: () => scrollingStart(index),
      complete: () => scrollingComplete(index),
    };
    cancelAutoScroll();
    $(container).stop().animate(properties, options);
  }

  function setActiveGroup(newIndex) {
    if (scrolling) return;
    activeIndex = newIndex;
    const currentItem = document.querySelector(".active-timeline-button");
    const nextItem = document.querySelector(
      `[data-timeline-button-index="${newIndex}"]`
    );
    if (!nextItem || !currentItem) return;
    currentItem.classList.remove("active-timeline-button");
    nextItem.classList.add("active-timeline-button");
  }

  function scrollingComplete() {
    scrolling = false;
    initAutoScroll();
  }

  function scrollingStart(index) {
    setActiveGroup(index);
    scrolling = true;
  }

  function splitFellowName() {
    const nameEls = timeline.querySelectorAll('.foundation-homepage-timeline__card--name');
    nameEls.forEach((nameEl) => {
      nameEl.innerHTML = nameEl.innerHTML.trim().replaceAll(' ', '<br>').replaceAll('-', '-<br>');
    })
  }

  return {
    init,
  };
}

const timeline = createTimeline();
module.exports = timeline;

},{"./foundation-modals":33}],37:[function(require,module,exports){
'use strict';

var foundationWebinars = document.getElementById('webinars-listing');

if(!foundationWebinars) {
    return;
}


//initialization
window.BackToTop = require('./back-to-top');


window.BackToTop.init();

//return for garbage collection
foundationWebinars  = null;

},{"./back-to-top":10}],38:[function(require,module,exports){
'use strict';

var generalContent = document.getElementById('general-content'),
  shareTools,
  $generalContent = $(generalContent),
  $accordions,	 

	//modules
  Accordions,
	ToggleMenu;

if(!generalContent) {
    return; 
}

//initiialize Experience
Accordions = require('./accordions');

$accordions = $generalContent.find('.js-accordions');

var initAccordions = function ($accordionSection) {
  new Accordions($accordionSection);
};

for (var i = $accordions.length - 1; i >= 0; i--) {
  initAccordions($accordions.eq(i));
}

//initialization
window.BackToTop = require('./back-to-top');

window.BackToTop.init();

//share tools
ToggleMenu = require('./toggle-menu');

shareTools = new ToggleMenu($('.js-share-tools'));

//scrollspy initialization
window.ScrollSpy = require('./scrollspy');


window.setTimeout(function () {
  //wait for content ot load
  window.ScrollSpy.init();
}, 300);


//return for garbage collection
generalContent = shareTools = null;

},{"./accordions":2,"./back-to-top":10,"./scrollspy":60,"./toggle-menu":73}],39:[function(require,module,exports){
'use strict';

	var globalVars = require('./variables'),

	//Module Exports
	handleIOSFixedScrolling;

//basic idea taken from here from stackoverflow
//http://stackoverflow.com/questions/29001977/safari-in-ios8-is-scrolling-screen-when-fixed-elements-get-focus

handleIOSFixedScrolling = (function(){

	//Get the fixed element, and the input element it contains.
	var savedScrollPos,
		inputBox,
		initializeFixedScrolling,
		handleBlurEvent,
		handleInputFocus;

	//Switch back when focus is lost.
	handleBlurEvent = function blured() {

        $('body,html')
        	.scrollTop(savedScrollPos)
        	.removeAttr('style');

    	inputBox.removeEventListener('blur', blured);
			
	}


	handleInputFocus = function () {
		if (globalVars.device.isIphone || globalVars.device.isIpad) {

	  		savedScrollPos = window.scrollY;

	  		$('body').css({
	            position: 'relative',
	            top: -savedScrollPos
	        });
	        $('html').css({
	        	'overflow':'hidden'
	        });

	        inputBox.addEventListener('blur', handleBlurEvent);


	        document.getElementById('site-search-panel').addEventListener('touchmove', function(e) {

		        e.preventDefault();

			}, false);

	    } else { return; }

	}

	initializeFixedScrolling = function($input) {

		if (globalVars.device.isIphone || globalVars.device.isIpad) {
			inputBox = $input[0];

			$('body').addClass('ios-device');
		}

	};


	return {
		init: initializeFixedScrolling,
		handleInputFocus: handleInputFocus,
		handleBlurEvent: handleBlurEvent
	}

})();

module.exports = handleIOSFixedScrolling;
},{"./variables":75}],40:[function(require,module,exports){
'use strict';

var $heroExplore,
	$scrollBtn,
	$siteHeader,
	$sectionNav,

	//Is In View Header
	animateHeaderOffset,
	inViewClass,
	pageOffset,
	rAFTicker,

	//Module Exports
	heroExplore,
	inViewClass,
    siteHeader;


heroExplore = {

	initNavMenu: function(){
		$heroExplore.on('click.siteMenu', '.js-mobile-toggle', siteHeader.toggleNavMenu)
	},
	initSearchToggle: function(){
		$heroExplore.on('click.siteSearch', '.js-site-search-toggle', siteHeader.toggleSearchbox);
	},
	initScrollToggle: function() {

		$scrollBtn.on('click', function(e){
			$('body,html').animate({
				scrollTop: Math.ceil(window.innerHeight) - $siteHeader.height()
			}, 600);
		});
	},
	initInViewHeader: function(){

		/*=============================================
		=            REquestion animation Frame            =
		=============================================*/
		function setupWindowOffsets() {
			animateHeaderOffset = parseInt(window.innerHeight, 10) * 0.5;
		}

		function windowScrollLogic(){
			pageOffset = window.pageYOffset;

			if( pageOffset >= animateHeaderOffset ) {
				$siteHeader.addClass(inViewClass);
			}	

			else {
				$siteHeader.removeClass(inViewClass);
			}
			
			rAFTicker = false;
		}

		function requestTicker() {
			if (!rAFTicker) {
				requestAnimationFrame(windowScrollLogic);
				rAFTicker = true;
			}
		}

		function attachScrollEvent() {
			// only listen for scroll events
			window.addEventListener('scroll', requestTicker, false);
		}

		function removeScrollEvent() {
			//remove ScrollEvent
			window.removeEventListener('scroll', requestTicker, false);
		}

		

		//setup initial values
		setupWindowOffsets();
		attachScrollEvent();

		/*=====  End RAF Animation  ======*/
	},
	init: function(pageConfig){

		var config = (!pageConfig) ? {}: pageConfig;

		//initialize Variables
		$heroExplore = $('.js-hero-explore');
		$scrollBtn = $heroExplore.find('.js-explore-scroll');

		//Pull in UI functionality for site header
		siteHeader = require('./site-header');

		//setup classes for is in view header
		$('body').addClass('hero-explore');
		$siteHeader = require('./variables').$elements.$siteHeader;

		inViewClass = 'is-inview-header';

		this.initNavMenu();
		this.initScrollToggle();
		this.initInViewHeader();

		if(!!config.initSearchToggle) {
			this.initSearchToggle();
		}
	}
};

module.exports = heroExplore;
},{"./site-header":67,"./variables":75}],41:[function(require,module,exports){
'use strict';

var $heroVideoResize,
	cachedWindowWidth,
	$container,
	
	globalVars = require('./variables.js'),
	//Module Exports
	
	heroVideoResize;


heroVideoResize = (function(){

	var $video,
		aspectRatio,

		computeWindowScreen,
		handleVideoResize,
		initializeVideoResize;


	computeWindowScreen = function(){
		var winWidth,
			winHeight, 
			largerDimension,


		winWidth = window.innerWidth;
		winHeight = $container.height();


		largerDimension = (winWidth/winHeight < aspectRatio) ?  {'height': winHeight} : {'width': winWidth };

		return largerDimension;

	};


	handleVideoResize = function() {

		var resizeBy = computeWindowScreen();

		


		if (resizeBy.hasOwnProperty('width'))  {
			//changed to 100% because the scroll bar was causing inconsistencies 
			$video.css({
				width: '100%',
				height: ''
			})
		} else {
			$video.css({
				width: '',
				height: resizeBy['height'] / 16 + 'em'
			})
		}


		cachedWindowWidth = window.innerWidth;

	};


	initializeVideoResize = function($wrapper) {
		$video = $wrapper.find('video');
		$container = $wrapper;

		if($video.length === 0 )  {
			return;
		}

		var videoSrc = $video.find('source')[0];

		videoSrc.setAttribute('src', videoSrc.getAttribute('data-lazy-video') );
		videoSrc.removeAttribute('data-lazy-video');

		$video[0].load();

		$video[0].addEventListener("canplay", function () {

			aspectRatio = $video.width() / $video.height();

			handleVideoResize ();		

			globalVars.windowResize.add( handleVideoResize.bind(this) );

			$video.addClass('is-video-ready');

			$wrapper = null;

		});

	};


	return {
		init: initializeVideoResize
	}

})();

module.exports = heroVideoResize;
},{"./variables.js":75}],42:[function(require,module,exports){
'use strict';

var $homeExplore = $('.js-home-explore'),
	$scrollBtn,

    siteHeader,
    heroVideoResize;


if(!$homeExplore.length) {
    return;
}


//pull in global vars
siteHeader = require('./site-header');

heroVideoResize = require('./hero-video-resize');

$homeExplore.on('click.siteMenu', '.js-mobile-toggle', siteHeader.toggleNavMenu)
            .on('click.siteSearch', '.js-site-search-toggle', siteHeader.toggleSearchbox);


$scrollBtn = $homeExplore.find('.js-explore-scroll');


$scrollBtn.on('click', function(e){
	$('body,html').animate({
		scrollTop: Math.ceil(window.innerHeight)
	}, 600);
});





heroVideoResize.init($homeExplore);
},{"./hero-video-resize":41,"./site-header":67}],43:[function(require,module,exports){
'use strict';

var homepage = document.getElementById('homepage'),
	$siteHeader,
	animateHeaderOffset,
	inViewClass,
	pageOffset,
	rAFTicker;


if(!homepage) {
    return;
}

//pull in global vars
$siteHeader = require('./variables').$elements.$siteHeader;

inViewClass = 'is-inview-header';

require('./lazy-load').init();


/*=============================================
=            REquestion animation Frame            =
=============================================*/
function setupWindowOffsets() {
	animateHeaderOffset = parseInt(window.innerHeight, 10) * 0.5;
}

function attachScrollEvent() {
	// only listen for scroll events
	window.addEventListener('scroll', requestTicker, false);
}

function removeScrollEvent() {
	//remove ScrollEvent
	window.removeEventListener('scroll', requestTicker, false);
}

function requestTicker() {
	if (!rAFTicker) {
		requestAnimationFrame(windowScrollLogic);
		rAFTicker = true;
	}
}

function displayHiddenElement() {
    var hiddenElement = $(homepage).find('.js-timeout');
    if(hiddenElement)
    {
        setTimeout(function () { 
            hiddenElement.show();
        }, 500);
    }
}

function windowScrollLogic(){
	pageOffset = window.pageYOffset;

	if( pageOffset >= animateHeaderOffset ) {
		$siteHeader.addClass(inViewClass);
	}	

	else {
		$siteHeader.removeClass(inViewClass);
	}
	
	rAFTicker = false;
}

//setup initial values
setupWindowOffsets();
attachScrollEvent();
displayHiddenElement();

/*=====  End RAF Animation  ======*/
},{"./lazy-load":50,"./variables":75}],44:[function(require,module,exports){
'use strict';

var insightsDetail = document.getElementById('insights-detail'),
  $insightsDetail = $(insightsDetail),
  $accordions,
	//modules
  
  Accordions,
	ToggleMenu;

if(!insightsDetail) {
    return;
}

//initiialize Experience
Accordions = require('./accordions');

$accordions = $insightsDetail.find('.js-accordions');

var initAccordions = function ($accordionSection) {
  new Accordions($accordionSection);
};

for (var i = $accordions.length - 1; i >= 0; i--) {
  initAccordions($accordions.eq(i));
}

//initialization
window.BackToTop = require('./back-to-top');

window.BackToTop.init();

//share tools
ToggleMenu = require('./toggle-menu');

// share tools
$('.share-tools').each(function() {
  var shareTools = new ToggleMenu($(this));
});

//scrollspy initialization
window.ScrollSpy = require('./scrollspy');


window.setTimeout(function () {
  //wait for content ot load
  window.ScrollSpy.init();
}, 300);


//return for garbage collection
insightsDetail = null;

},{"./accordions":2,"./back-to-top":10,"./scrollspy":60,"./toggle-menu":73}],45:[function(require,module,exports){
'use strict';

var insightsLanding = document.getElementById('insights-landing'),

	//modules
	pageOptions;

if (!insightsLanding) {
    return;
}

pageOptions = {
	pageName:  'insights-landing',
	searchResultsID: 'search-landing-results',
	activateBackToTop: true,
	activateBackToTopSilent: true,
	advancedSearch: true,
	exploreCallback: function () { window.carouselSpotlight.resetCarouselDisplay() }
};

window.carouselSpotlight = require('./carousel-spotlight');

window.carouselSpotlight.init();

window.SearchLandingPanels = require('./search-landing-panels-no-tabs');

window.SearchLandingPanels.init(
	pageOptions.exploreCallback, 
	pageOptions
);

window.ThrowawaySearchLandingFilters = require('./throwaway-search-landing-filters');

window.ThrowawaySearchLandingFilters.init(pageOptions);

window.animationSearchLogic = require('./animation-search-logic');

//return for garbage collection
insightsLanding = null;
},{"./animation-search-logic":9,"./carousel-spotlight":18,"./search-landing-panels-no-tabs":62,"./throwaway-search-landing-filters":71}],46:[function(require,module,exports){
'use strict';

var jobBoard = document.getElementById('job-board'),
	shareTools,


	//modules
	selectDropdowns,
	BackToTop;

if(!jobBoard) {
    return;
}


//initialization
window.BackToTop = require('./back-to-top');

window.BackToTop.init();

/*----------  initialize dropdown Functionality  ----------*/
selectDropdowns =  require('./select-dropdown');

var $dropdowns = $(jobBoard).find('.js-select-dropdown');

selectDropdowns($dropdowns);



//return for garbage collection
jobBoard = $dropdowns = null;

},{"./back-to-top":10,"./select-dropdown":65}],47:[function(require,module,exports){
'use strict';

var jobDetail = document.getElementById('job-detail'),
	shareTools,
	

	//modules
	BackToTop,
	ToggleMenu;

if(!jobDetail) {
    return;
}


//initialization
BackToTop = require('./back-to-top');

BackToTop.init();


//share tools
ToggleMenu = require('./toggle-menu');


shareTools = new ToggleMenu($('.share-tools'));


//return for garbage collection
jobDetail = null;
},{"./back-to-top":10,"./toggle-menu":73}],48:[function(require,module,exports){
typeof JSON!="object"&&(JSON={}),function(){"use strict";function f(e){return e<10?"0"+e:e}function quote(e){return escapable.lastIndex=0,escapable.test(e)?'"'+e.replace(escapable,function(e){var t=meta[e];return typeof t=="string"?t:"\\u"+("0000"+e.charCodeAt(0).toString(16)).slice(-4)})+'"':'"'+e+'"'}function str(e,t){var n,r,i,s,o=gap,u,a=t[e];a&&typeof a=="object"&&typeof a.toJSON=="function"&&(a=a.toJSON(e)),typeof rep=="function"&&(a=rep.call(t,e,a));switch(typeof a){case"string":return quote(a);case"number":return isFinite(a)?String(a):"null";case"boolean":case"null":return String(a);case"object":if(!a)return"null";gap+=indent,u=[];if(Object.prototype.toString.apply(a)==="[object Array]"){s=a.length;for(n=0;n<s;n+=1)u[n]=str(n,a)||"null";return i=u.length===0?"[]":gap?"[\n"+gap+u.join(",\n"+gap)+"\n"+o+"]":"["+u.join(",")+"]",gap=o,i}if(rep&&typeof rep=="object"){s=rep.length;for(n=0;n<s;n+=1)typeof rep[n]=="string"&&(r=rep[n],i=str(r,a),i&&u.push(quote(r)+(gap?": ":":")+i))}else for(r in a)Object.prototype.hasOwnProperty.call(a,r)&&(i=str(r,a),i&&u.push(quote(r)+(gap?": ":":")+i));return i=u.length===0?"{}":gap?"{\n"+gap+u.join(",\n"+gap)+"\n"+o+"}":"{"+u.join(",")+"}",gap=o,i}}typeof Date.prototype.toJSON!="function"&&(Date.prototype.toJSON=function(e){return isFinite(this.valueOf())?this.getUTCFullYear()+"-"+f(this.getUTCMonth()+1)+"-"+f(this.getUTCDate())+"T"+f(this.getUTCHours())+":"+f(this.getUTCMinutes())+":"+f(this.getUTCSeconds())+"Z":null},String.prototype.toJSON=Number.prototype.toJSON=Boolean.prototype.toJSON=function(e){return this.valueOf()});var cx=/[\u0000\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,escapable=/[\\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,gap,indent,meta={"\b":"\\b","	":"\\t","\n":"\\n","\f":"\\f","\r":"\\r",'"':'\\"',"\\":"\\\\"},rep;typeof JSON.stringify!="function"&&(JSON.stringify=function(e,t,n){var r;gap="",indent="";if(typeof n=="number")for(r=0;r<n;r+=1)indent+=" ";else typeof n=="string"&&(indent=n);rep=t;if(!t||typeof t=="function"||typeof t=="object"&&typeof t.length=="number")return str("",{"":e});throw new Error("JSON.stringify")}),typeof JSON.parse!="function"&&(JSON.parse=function(text,reviver){function walk(e,t){var n,r,i=e[t];if(i&&typeof i=="object")for(n in i)Object.prototype.hasOwnProperty.call(i,n)&&(r=walk(i,n),r!==undefined?i[n]=r:delete i[n]);return reviver.call(e,t,i)}var j;text=String(text),cx.lastIndex=0,cx.test(text)&&(text=text.replace(cx,function(e){return"\\u"+("0000"+e.charCodeAt(0).toString(16)).slice(-4)}));if(/^[\],:{}\s]*$/.test(text.replace(/\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g,"@").replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g,"]").replace(/(?:^|:|,)(?:\s*\[)+/g,"")))return j=eval("("+text+")"),typeof reviver=="function"?walk({"":j},""):j;throw new SyntaxError("JSON.parse")})}(),function(e,t){"use strict";var n=e.History=e.History||{},r=e.jQuery;if(typeof n.Adapter!="undefined")throw new Error("History.js Adapter has already been loaded...");n.Adapter={bind:function(e,t,n){r(e).bind(t,n)},trigger:function(e,t,n){r(e).trigger(t,n)},extractEventData:function(e,n,r){var i=n&&n.originalEvent&&n.originalEvent[e]||r&&r[e]||t;return i},onDomLoad:function(e){r(e)}},typeof n.init!="undefined"&&n.init()}(window),function(e,t){"use strict";var n=e.document,r=e.setTimeout||r,i=e.clearTimeout||i,s=e.setInterval||s,o=e.History=e.History||{};if(typeof o.initHtml4!="undefined")throw new Error("History.js HTML4 Support has already been loaded...");o.initHtml4=function(){if(typeof o.initHtml4.initialized!="undefined")return!1;o.initHtml4.initialized=!0,o.enabled=!0,o.savedHashes=[],o.isLastHash=function(e){var t=o.getHashByIndex(),n;return n=e===t,n},o.isHashEqual=function(e,t){return e=encodeURIComponent(e).replace(/%25/g,"%"),t=encodeURIComponent(t).replace(/%25/g,"%"),e===t},o.saveHash=function(e){return o.isLastHash(e)?!1:(o.savedHashes.push(e),!0)},o.getHashByIndex=function(e){var t=null;return typeof e=="undefined"?t=o.savedHashes[o.savedHashes.length-1]:e<0?t=o.savedHashes[o.savedHashes.length+e]:t=o.savedHashes[e],t},o.discardedHashes={},o.discardedStates={},o.discardState=function(e,t,n){var r=o.getHashByState(e),i;return i={discardedState:e,backState:n,forwardState:t},o.discardedStates[r]=i,!0},o.discardHash=function(e,t,n){var r={discardedHash:e,backState:n,forwardState:t};return o.discardedHashes[e]=r,!0},o.discardedState=function(e){var t=o.getHashByState(e),n;return n=o.discardedStates[t]||!1,n},o.discardedHash=function(e){var t=o.discardedHashes[e]||!1;return t},o.recycleState=function(e){var t=o.getHashByState(e);return o.discardedState(e)&&delete o.discardedStates[t],!0},o.emulated.hashChange&&(o.hashChangeInit=function(){o.checkerFunction=null;var t="",r,i,u,a,f=Boolean(o.getHash());return o.isInternetExplorer()?(r="historyjs-iframe",i=n.createElement("iframe"),i.setAttribute("id",r),i.setAttribute("src","#"),i.style.display="none",n.body.appendChild(i),i.contentWindow.document.open(),i.contentWindow.document.close(),u="",a=!1,o.checkerFunction=function(){if(a)return!1;a=!0;var n=o.getHash(),r=o.getHash(i.contentWindow.document);return n!==t?(t=n,r!==n&&(u=r=n,i.contentWindow.document.open(),i.contentWindow.document.close(),i.contentWindow.document.location.hash=o.escapeHash(n)),o.Adapter.trigger(e,"hashchange")):r!==u&&(u=r,f&&r===""?o.back():o.setHash(r,!1)),a=!1,!0}):o.checkerFunction=function(){var n=o.getHash()||"";return n!==t&&(t=n,o.Adapter.trigger(e,"hashchange")),!0},o.intervalList.push(s(o.checkerFunction,o.options.hashChangeInterval)),!0},o.Adapter.onDomLoad(o.hashChangeInit)),o.emulated.pushState&&(o.onHashChange=function(t){var n=t&&t.newURL||o.getLocationHref(),r=o.getHashByUrl(n),i=null,s=null,u=null,a;return o.isLastHash(r)?(o.busy(!1),!1):(o.doubleCheckComplete(),o.saveHash(r),r&&o.isTraditionalAnchor(r)?(o.Adapter.trigger(e,"anchorchange"),o.busy(!1),!1):(i=o.extractState(o.getFullUrl(r||o.getLocationHref()),!0),o.isLastSavedState(i)?(o.busy(!1),!1):(s=o.getHashByState(i),a=o.discardedState(i),a?(o.getHashByIndex(-2)===o.getHashByState(a.forwardState)?o.back(!1):o.forward(!1),!1):(o.pushState(i.data,i.title,encodeURI(i.url),!1),!0))))},o.Adapter.bind(e,"hashchange",o.onHashChange),o.pushState=function(t,n,r,i){r=encodeURI(r).replace(/%25/g,"%");if(o.getHashByUrl(r))throw new Error("History.js does not support states with fragment-identifiers (hashes/anchors).");if(i!==!1&&o.busy())return o.pushQueue({scope:o,callback:o.pushState,args:arguments,queue:i}),!1;o.busy(!0);var s=o.createStateObject(t,n,r),u=o.getHashByState(s),a=o.getState(!1),f=o.getHashByState(a),l=o.getHash(),c=o.expectedStateId==s.id;return o.storeState(s),o.expectedStateId=s.id,o.recycleState(s),o.setTitle(s),u===f?(o.busy(!1),!1):(o.saveState(s),c||o.Adapter.trigger(e,"statechange"),!o.isHashEqual(u,l)&&!o.isHashEqual(u,o.getShortUrl(o.getLocationHref()))&&o.setHash(u,!1),o.busy(!1),!0)},o.replaceState=function(t,n,r,i){r=encodeURI(r).replace(/%25/g,"%");if(o.getHashByUrl(r))throw new Error("History.js does not support states with fragment-identifiers (hashes/anchors).");if(i!==!1&&o.busy())return o.pushQueue({scope:o,callback:o.replaceState,args:arguments,queue:i}),!1;o.busy(!0);var s=o.createStateObject(t,n,r),u=o.getHashByState(s),a=o.getState(!1),f=o.getHashByState(a),l=o.getStateByIndex(-2);return o.discardState(a,s,l),u===f?(o.storeState(s),o.expectedStateId=s.id,o.recycleState(s),o.setTitle(s),o.saveState(s),o.Adapter.trigger(e,"statechange"),o.busy(!1)):o.pushState(s.data,s.title,s.url,!1),!0}),o.emulated.pushState&&o.getHash()&&!o.emulated.hashChange&&o.Adapter.onDomLoad(function(){o.Adapter.trigger(e,"hashchange")})},typeof o.init!="undefined"&&o.init()}(window),function(e,t){"use strict";var n=e.console||t,r=e.document,i=e.navigator,s=!1,o=e.setTimeout,u=e.clearTimeout,a=e.setInterval,f=e.clearInterval,l=e.JSON,c=e.alert,h=e.History=e.History||{},p=e.history;try{s=e.sessionStorage,s.setItem("TEST","1"),s.removeItem("TEST")}catch(d){s=!1}l.stringify=l.stringify||l.encode,l.parse=l.parse||l.decode;if(typeof h.init!="undefined")throw new Error("History.js Core has already been loaded...");h.init=function(e){return typeof h.Adapter=="undefined"?!1:(typeof h.initCore!="undefined"&&h.initCore(),typeof h.initHtml4!="undefined"&&h.initHtml4(),!0)},h.initCore=function(d){if(typeof h.initCore.initialized!="undefined")return!1;h.initCore.initialized=!0,h.options=h.options||{},h.options.hashChangeInterval=h.options.hashChangeInterval||100,h.options.safariPollInterval=h.options.safariPollInterval||500,h.options.doubleCheckInterval=h.options.doubleCheckInterval||500,h.options.disableSuid=h.options.disableSuid||!1,h.options.storeInterval=h.options.storeInterval||1e3,h.options.busyDelay=h.options.busyDelay||250,h.options.debug=h.options.debug||!1,h.options.initialTitle=h.options.initialTitle||r.title,h.options.html4Mode=h.options.html4Mode||!1,h.options.delayInit=h.options.delayInit||!1,h.intervalList=[],h.clearAllIntervals=function(){var e,t=h.intervalList;if(typeof t!="undefined"&&t!==null){for(e=0;e<t.length;e++)f(t[e]);h.intervalList=null}},h.debug=function(){(h.options.debug||!1)&&h.log.apply(h,arguments)},h.log=function(){var e=typeof n!="undefined"&&typeof n.log!="undefined"&&typeof n.log.apply!="undefined",t=r.getElementById("log"),i,s,o,u,a;e?(u=Array.prototype.slice.call(arguments),i=u.shift(),typeof n.debug!="undefined"?n.debug.apply(n,[i,u]):n.log.apply(n,[i,u])):i="\n"+arguments[0]+"\n";for(s=1,o=arguments.length;s<o;++s){a=arguments[s];if(typeof a=="object"&&typeof l!="undefined")try{a=l.stringify(a)}catch(f){}i+="\n"+a+"\n"}return t?(t.value+=i+"\n-----\n",t.scrollTop=t.scrollHeight-t.clientHeight):e||c(i),!0},h.getInternetExplorerMajorVersion=function(){var e=h.getInternetExplorerMajorVersion.cached=typeof h.getInternetExplorerMajorVersion.cached!="undefined"?h.getInternetExplorerMajorVersion.cached:function(){var e=3,t=r.createElement("div"),n=t.getElementsByTagName("i");while((t.innerHTML="<!--[if gt IE "+ ++e+"]><i></i><![endif]-->")&&n[0]);return e>4?e:!1}();return e},h.isInternetExplorer=function(){var e=h.isInternetExplorer.cached=typeof h.isInternetExplorer.cached!="undefined"?h.isInternetExplorer.cached:Boolean(h.getInternetExplorerMajorVersion());return e},h.options.html4Mode?h.emulated={pushState:!0,hashChange:!0}:h.emulated={pushState:!Boolean(e.history&&e.history.pushState&&e.history.replaceState&&!/ Mobile\/([1-7][a-z]|(8([abcde]|f(1[0-8]))))/i.test(i.userAgent)&&!/AppleWebKit\/5([0-2]|3[0-2])/i.test(i.userAgent)),hashChange:Boolean(!("onhashchange"in e||"onhashchange"in r)||h.isInternetExplorer()&&h.getInternetExplorerMajorVersion()<8)},h.enabled=!h.emulated.pushState,h.bugs={setHash:Boolean(!h.emulated.pushState&&i.vendor==="Apple Computer, Inc."&&/AppleWebKit\/5([0-2]|3[0-3])/.test(i.userAgent)),safariPoll:Boolean(!h.emulated.pushState&&i.vendor==="Apple Computer, Inc."&&/AppleWebKit\/5([0-2]|3[0-3])/.test(i.userAgent)),ieDoubleCheck:Boolean(h.isInternetExplorer()&&h.getInternetExplorerMajorVersion()<8),hashEscape:Boolean(h.isInternetExplorer()&&h.getInternetExplorerMajorVersion()<7)},h.isEmptyObject=function(e){for(var t in e)if(e.hasOwnProperty(t))return!1;return!0},h.cloneObject=function(e){var t,n;return e?(t=l.stringify(e),n=l.parse(t)):n={},n},h.getRootUrl=function(){var e=r.location.protocol+"//"+(r.location.hostname||r.location.host);if(r.location.port||!1)e+=":"+r.location.port;return e+="/",e},h.getBaseHref=function(){var e=r.getElementsByTagName("base"),t=null,n="";return e.length===1&&(t=e[0],n=t.href.replace(/[^\/]+$/,"")),n=n.replace(/\/+$/,""),n&&(n+="/"),n},h.getBaseUrl=function(){var e=h.getBaseHref()||h.getBasePageUrl()||h.getRootUrl();return e},h.getPageUrl=function(){var e=h.getState(!1,!1),t=(e||{}).url||h.getLocationHref(),n;return n=t.replace(/\/+$/,"").replace(/[^\/]+$/,function(e,t,n){return/\./.test(e)?e:e+"/"}),n},h.getBasePageUrl=function(){var e=h.getLocationHref().replace(/[#\?].*/,"").replace(/[^\/]+$/,function(e,t,n){return/[^\/]$/.test(e)?"":e}).replace(/\/+$/,"")+"/";return e},h.getFullUrl=function(e,t){var n=e,r=e.substring(0,1);return t=typeof t=="undefined"?!0:t,/[a-z]+\:\/\//.test(e)||(r==="/"?n=h.getRootUrl()+e.replace(/^\/+/,""):r==="#"?n=h.getPageUrl().replace(/#.*/,"")+e:r==="?"?n=h.getPageUrl().replace(/[\?#].*/,"")+e:t?n=h.getBaseUrl()+e.replace(/^(\.\/)+/,""):n=h.getBasePageUrl()+e.replace(/^(\.\/)+/,"")),n.replace(/\#$/,"")},h.getShortUrl=function(e){var t=e,n=h.getBaseUrl(),r=h.getRootUrl();return h.emulated.pushState&&(t=t.replace(n,"")),t=t.replace(r,"/"),h.isTraditionalAnchor(t)&&(t="./"+t),t=t.replace(/^(\.\/)+/g,"./").replace(/\#$/,""),t},h.getLocationHref=function(e){return e=e||r,e.URL===e.location.href?e.location.href:e.location.href===decodeURIComponent(e.URL)?e.URL:e.location.hash&&decodeURIComponent(e.location.href.replace(/^[^#]+/,""))===e.location.hash?e.location.href:e.URL.indexOf("#")==-1&&e.location.href.indexOf("#")!=-1?e.location.href:e.URL||e.location.href},h.store={},h.idToState=h.idToState||{},h.stateToId=h.stateToId||{},h.urlToId=h.urlToId||{},h.storedStates=h.storedStates||[],h.savedStates=h.savedStates||[],h.normalizeStore=function(){h.store.idToState=h.store.idToState||{},h.store.urlToId=h.store.urlToId||{},h.store.stateToId=h.store.stateToId||{}},h.getState=function(e,t){typeof e=="undefined"&&(e=!0),typeof t=="undefined"&&(t=!0);var n=h.getLastSavedState();return!n&&t&&(n=h.createStateObject()),e&&(n=h.cloneObject(n),n.url=n.cleanUrl||n.url),n},h.getIdByState=function(e){var t=h.extractId(e.url),n;if(!t){n=h.getStateString(e);if(typeof h.stateToId[n]!="undefined")t=h.stateToId[n];else if(typeof h.store.stateToId[n]!="undefined")t=h.store.stateToId[n];else{for(;;){t=(new Date).getTime()+String(Math.random()).replace(/\D/g,"");if(typeof h.idToState[t]=="undefined"&&typeof h.store.idToState[t]=="undefined")break}h.stateToId[n]=t,h.idToState[t]=e}}return t},h.normalizeState=function(e){var t,n;if(!e||typeof e!="object")e={};if(typeof e.normalized!="undefined")return e;if(!e.data||typeof e.data!="object")e.data={};return t={},t.normalized=!0,t.title=e.title||"",t.url=h.getFullUrl(e.url?e.url:h.getLocationHref()),t.hash=h.getShortUrl(t.url),t.data=h.cloneObject(e.data),t.id=h.getIdByState(t),t.cleanUrl=t.url.replace(/\??\&_suid.*/,""),t.url=t.cleanUrl,n=!h.isEmptyObject(t.data),(t.title||n)&&h.options.disableSuid!==!0&&(t.hash=h.getShortUrl(t.url).replace(/\??\&_suid.*/,""),/\?/.test(t.hash)||(t.hash+="?"),t.hash+="&_suid="+t.id),t.hashedUrl=h.getFullUrl(t.hash),(h.emulated.pushState||h.bugs.safariPoll)&&h.hasUrlDuplicate(t)&&(t.url=t.hashedUrl),t},h.createStateObject=function(e,t,n){var r={data:e,title:t,url:n};return r=h.normalizeState(r),r},h.getStateById=function(e){e=String(e);var n=h.idToState[e]||h.store.idToState[e]||t;return n},h.getStateString=function(e){var t,n,r;return t=h.normalizeState(e),n={data:t.data,title:e.title,url:e.url},r=l.stringify(n),r},h.getStateId=function(e){var t,n;return t=h.normalizeState(e),n=t.id,n},h.getHashByState=function(e){var t,n;return t=h.normalizeState(e),n=t.hash,n},h.extractId=function(e){var t,n,r,i;return e.indexOf("#")!=-1?i=e.split("#")[0]:i=e,n=/(.*)\&_suid=([0-9]+)$/.exec(i),r=n?n[1]||e:e,t=n?String(n[2]||""):"",t||!1},h.isTraditionalAnchor=function(e){var t=!/[\/\?\.]/.test(e);return t},h.extractState=function(e,t){var n=null,r,i;return t=t||!1,r=h.extractId(e),r&&(n=h.getStateById(r)),n||(i=h.getFullUrl(e),r=h.getIdByUrl(i)||!1,r&&(n=h.getStateById(r)),!n&&t&&!h.isTraditionalAnchor(e)&&(n=h.createStateObject(null,null,i))),n},h.getIdByUrl=function(e){var n=h.urlToId[e]||h.store.urlToId[e]||t;return n},h.getLastSavedState=function(){return h.savedStates[h.savedStates.length-1]||t},h.getLastStoredState=function(){return h.storedStates[h.storedStates.length-1]||t},h.hasUrlDuplicate=function(e){var t=!1,n;return n=h.extractState(e.url),t=n&&n.id!==e.id,t},h.storeState=function(e){return h.urlToId[e.url]=e.id,h.storedStates.push(h.cloneObject(e)),e},h.isLastSavedState=function(e){var t=!1,n,r,i;return h.savedStates.length&&(n=e.id,r=h.getLastSavedState(),i=r.id,t=n===i),t},h.saveState=function(e){return h.isLastSavedState(e)?!1:(h.savedStates.push(h.cloneObject(e)),!0)},h.getStateByIndex=function(e){var t=null;return typeof e=="undefined"?t=h.savedStates[h.savedStates.length-1]:e<0?t=h.savedStates[h.savedStates.length+e]:t=h.savedStates[e],t},h.getCurrentIndex=function(){var e=null;return h.savedStates.length<1?e=0:e=h.savedStates.length-1,e},h.getHash=function(e){var t=h.getLocationHref(e),n;return n=h.getHashByUrl(t),n},h.unescapeHash=function(e){var t=h.normalizeHash(e);return t=decodeURIComponent(t),t},h.normalizeHash=function(e){var t=e.replace(/[^#]*#/,"").replace(/#.*/,"");return t},h.setHash=function(e,t){var n,i;return t!==!1&&h.busy()?(h.pushQueue({scope:h,callback:h.setHash,args:arguments,queue:t}),!1):(h.busy(!0),n=h.extractState(e,!0),n&&!h.emulated.pushState?h.pushState(n.data,n.title,n.url,!1):h.getHash()!==e&&(h.bugs.setHash?(i=h.getPageUrl(),h.pushState(null,null,i+"#"+e,!1)):r.location.hash=e),h)},h.escapeHash=function(t){var n=h.normalizeHash(t);return n=e.encodeURIComponent(n),h.bugs.hashEscape||(n=n.replace(/\%21/g,"!").replace(/\%26/g,"&").replace(/\%3D/g,"=").replace(/\%3F/g,"?")),n},h.getHashByUrl=function(e){var t=String(e).replace(/([^#]*)#?([^#]*)#?(.*)/,"$2");return t=h.unescapeHash(t),t},h.setTitle=function(e){var t=e.title,n;t||(n=h.getStateByIndex(0),n&&n.url===e.url&&(t=n.title||h.options.initialTitle));try{r.getElementsByTagName("title")[0].innerHTML=t.replace("<","&lt;").replace(">","&gt;").replace(" & "," &amp; ")}catch(i){}return r.title=t,h},h.queues=[],h.busy=function(e){typeof e!="undefined"?h.busy.flag=e:typeof h.busy.flag=="undefined"&&(h.busy.flag=!1);if(!h.busy.flag){u(h.busy.timeout);var t=function(){var e,n,r;if(h.busy.flag)return;for(e=h.queues.length-1;e>=0;--e){n=h.queues[e];if(n.length===0)continue;r=n.shift(),h.fireQueueItem(r),h.busy.timeout=o(t,h.options.busyDelay)}};h.busy.timeout=o(t,h.options.busyDelay)}return h.busy.flag},h.busy.flag=!1,h.fireQueueItem=function(e){return e.callback.apply(e.scope||h,e.args||[])},h.pushQueue=function(e){return h.queues[e.queue||0]=h.queues[e.queue||0]||[],h.queues[e.queue||0].push(e),h},h.queue=function(e,t){return typeof e=="function"&&(e={callback:e}),typeof t!="undefined"&&(e.queue=t),h.busy()?h.pushQueue(e):h.fireQueueItem(e),h},h.clearQueue=function(){return h.busy.flag=!1,h.queues=[],h},h.stateChanged=!1,h.doubleChecker=!1,h.doubleCheckComplete=function(){return h.stateChanged=!0,h.doubleCheckClear(),h},h.doubleCheckClear=function(){return h.doubleChecker&&(u(h.doubleChecker),h.doubleChecker=!1),h},h.doubleCheck=function(e){return h.stateChanged=!1,h.doubleCheckClear(),h.bugs.ieDoubleCheck&&(h.doubleChecker=o(function(){return h.doubleCheckClear(),h.stateChanged||e(),!0},h.options.doubleCheckInterval)),h},h.safariStatePoll=function(){var t=h.extractState(h.getLocationHref()),n;if(!h.isLastSavedState(t))return n=t,n||(n=h.createStateObject()),h.Adapter.trigger(e,"popstate"),h;return},h.back=function(e){return e!==!1&&h.busy()?(h.pushQueue({scope:h,callback:h.back,args:arguments,queue:e}),!1):(h.busy(!0),h.doubleCheck(function(){h.back(!1)}),p.go(-1),!0)},h.forward=function(e){return e!==!1&&h.busy()?(h.pushQueue({scope:h,callback:h.forward,args:arguments,queue:e}),!1):(h.busy(!0),h.doubleCheck(function(){h.forward(!1)}),p.go(1),!0)},h.go=function(e,t){var n;if(e>0)for(n=1;n<=e;++n)h.forward(t);else{if(!(e<0))throw new Error("History.go: History.go requires a positive or negative integer passed.");for(n=-1;n>=e;--n)h.back(t)}return h};if(h.emulated.pushState){var v=function(){};h.pushState=h.pushState||v,h.replaceState=h.replaceState||v}else h.onPopState=function(t,n){var r=!1,i=!1,s,o;return h.doubleCheckComplete(),s=h.getHash(),s?(o=h.extractState(s||h.getLocationHref(),!0),o?h.replaceState(o.data,o.title,o.url,!1):(h.Adapter.trigger(e,"anchorchange"),h.busy(!1)),h.expectedStateId=!1,!1):(r=h.Adapter.extractEventData("state",t,n)||!1,r?i=h.getStateById(r):h.expectedStateId?i=h.getStateById(h.expectedStateId):i=h.extractState(h.getLocationHref()),i||(i=h.createStateObject(null,null,h.getLocationHref())),h.expectedStateId=!1,h.isLastSavedState(i)?(h.busy(!1),!1):(h.storeState(i),h.saveState(i),h.setTitle(i),h.Adapter.trigger(e,"statechange"),h.busy(!1),!0))},h.Adapter.bind(e,"popstate",h.onPopState),h.pushState=function(t,n,r,i){if(h.getHashByUrl(r)&&h.emulated.pushState)throw new Error("History.js does not support states with fragement-identifiers (hashes/anchors).");if(i!==!1&&h.busy())return h.pushQueue({scope:h,callback:h.pushState,args:arguments,queue:i}),!1;h.busy(!0);var s=h.createStateObject(t,n,r);return h.isLastSavedState(s)?h.busy(!1):(h.storeState(s),h.expectedStateId=s.id,p.pushState(s.id,s.title,s.url),h.Adapter.trigger(e,"popstate")),!0},h.replaceState=function(t,n,r,i){if(h.getHashByUrl(r)&&h.emulated.pushState)throw new Error("History.js does not support states with fragement-identifiers (hashes/anchors).");if(i!==!1&&h.busy())return h.pushQueue({scope:h,callback:h.replaceState,args:arguments,queue:i}),!1;h.busy(!0);var s=h.createStateObject(t,n,r);return h.isLastSavedState(s)?h.busy(!1):(h.storeState(s),h.expectedStateId=s.id,p.replaceState(s.id,s.title,s.url),h.Adapter.trigger(e,"popstate")),!0};if(s){try{h.store=l.parse(s.getItem("History.store"))||{}}catch(m){h.store={}}h.normalizeStore()}else h.store={},h.normalizeStore();h.Adapter.bind(e,"unload",h.clearAllIntervals),h.saveState(h.storeState(h.extractState(h.getLocationHref(),!0))),s&&(h.onUnload=function(){var e,t,n;try{e=l.parse(s.getItem("History.store"))||{}}catch(r){e={}}e.idToState=e.idToState||{},e.urlToId=e.urlToId||{},e.stateToId=e.stateToId||{};for(t in h.idToState){if(!h.idToState.hasOwnProperty(t))continue;e.idToState[t]=h.idToState[t]}for(t in h.urlToId){if(!h.urlToId.hasOwnProperty(t))continue;e.urlToId[t]=h.urlToId[t]}for(t in h.stateToId){if(!h.stateToId.hasOwnProperty(t))continue;e.stateToId[t]=h.stateToId[t]}h.store=e,h.normalizeStore(),n=l.stringify(e);try{s.setItem("History.store",n)}catch(i){if(i.code!==DOMException.QUOTA_EXCEEDED_ERR)throw i;s.length&&(s.removeItem("History.store"),s.setItem("History.store",n))}},h.intervalList.push(a(h.onUnload,h.options.storeInterval)),h.Adapter.bind(e,"beforeunload",h.onUnload),h.Adapter.bind(e,"unload",h.onUnload));if(!h.emulated.pushState){h.bugs.safariPoll&&h.intervalList.push(a(h.safariStatePoll,h.options.safariPollInterval));if(i.vendor==="Apple Computer, Inc."||(i.appCodeName||"")==="Mozilla")h.Adapter.bind(e,"hashchange",function(){h.Adapter.trigger(e,"popstate")}),h.getHash()&&h.Adapter.onDomLoad(function(){h.Adapter.trigger(e,"hashchange")})}},(!h.options||!h.options.delayInit)&&h.init()}(window)
},{}],49:[function(require,module,exports){
'use strict';

var globalVars,
    $lawyerCareersMobileNav,
    $lawyerCareersMobileNavToggle,
    setLawyerCareersNavAriaStates,
    toggleLawyerCareersMobileNav;

globalVars = require('./variables');
$lawyerCareersMobileNav = $('.js-lawyer-careers-mobile-nav');
$lawyerCareersMobileNavToggle = $('.js-lawyer-careers-mobile-nav-toggle');


toggleLawyerCareersMobileNav = function toggleLawyerCareersMobileNav(e, preventFocusToggle) {
    e.stopPropagation();
    e.preventDefault();

    //only on lawyer careers interior pages
    if($lawyerCareersMobileNav) {
        $lawyerCareersMobileNav.toggleClass('show-menu');
        setLawyerCareersNavAriaStates();
    }
}

setLawyerCareersNavAriaStates = function setLawyerCareersNavAriaStates(doNotSetFocus) {
    if(globalVars.isMobileLawyerCareers && !$lawyerCareersMobileNav.hasClass('show-menu') )  {
        $lawyerCareersMobileNav.attr('aria-hidden', true)
        $lawyerCareersMobileNavToggle.attr('aria-expanded', false)
        // $lawyerCareersMobileNavToggle.focus();
        $lawyerCareersMobileNav.find('a').attr('tabindex', -1)        
    }
    else {
        $lawyerCareersMobileNav.attr('aria-hidden', false)
        $lawyerCareersMobileNavToggle.attr('aria-expanded', true)
        //do not set focus the first time
        if(!doNotSetFocus)
            $lawyerCareersMobileNav.find('a').attr('tabindex', '').eq(0).focus();
    }
}

if($lawyerCareersMobileNavToggle ) {
    $lawyerCareersMobileNavToggle .on('click', function(e) {
        e.stopPropagation();
        toggleLawyerCareersMobileNav(e);
    });

    //set initially
    setLawyerCareersNavAriaStates(true);
}

},{"./variables":75}],50:[function(require,module,exports){
'use strict';

var lazyLoad;


lazyLoad = (function(){


	var lazyLoadImages,
		lazyLoadBackgroundImages,
		initializeLazyLoad;


	lazyLoadImages = function($images) {
		if($images.length) {

			$images.each(function(index, el) {
				var $el = $(el);

				$el.attr('src', $el.data('lazy-img') )
				   .attr('data-lazy-img', '');
				
				

			});
		}

		$images = null;
	};



	lazyLoadBackgroundImages = function($images) {

		if($images.length) {

			$images.each(function(index, el) {
				var $el = $(el);

				$el.attr('src', $el.data('lazy-img') );

				$el.css('background-image', 'url(' + $el.data('lazy-background-img') + ')')
				   .attr('lazy-background-img', '');
				

			});
		}

		$images = null;

	};

	initializeLazyLoad = function() {
		
		lazyLoadImages( $('[data-lazy-img]') );
		
		lazyLoadBackgroundImages($('[data-lazy-background-img]') );

	};


	return {
		init: initializeLazyLoad
	}

})();

module.exports = lazyLoad;
},{}],51:[function(require,module,exports){
'use strict';

var locationsDetail = document.getElementById('locations-detail'),
	$siteHeader,
	shareTools,

	//modules
	ReadMore,
	Accordions,
	ToggleMenu;

if(!locationsDetail) {
    return;
}

//pull in global vars
$siteHeader = require('./variables').$elements.$siteHeader;


//initialize overview
ReadMore = require('./read-more');

var relatedInsightsListing = $(locationsDetail).find('.js-insights-listing');

if(relatedInsightsListing.length) {
	new ReadMore( relatedInsightsListing );
}


//initiialize Experience
Accordions = require('./accordions');

var accordionNodes = $(locationsDetail).find('.related-experience .js-accordions');

if(accordionNodes.length) {
	new Accordions( accordionNodes );	
}

//scrollspy initialization
window.ScrollSpy = require('./scrollspy');

window.ScrollSpy.init();


//share tools
ToggleMenu = require('./toggle-menu');


shareTools = new ToggleMenu($('.share-tools'));



//return for garbage collection
locationsDetail = relatedInsightsListing = accordionNodes = null;
},{"./accordions":2,"./read-more":59,"./scrollspy":60,"./toggle-menu":73,"./variables":75}],52:[function(require,module,exports){
'use strict';

var locationsLanding = document.getElementById('locations-landing');

if(!locationsLanding) {
    return;
}


//scrollspy initialization
window.ScrollSpy = require('./scrollspy');


window.ScrollSpy.init();


//return for garbage collection
locationsLanding = null;
},{"./scrollspy":60}],53:[function(require,module,exports){
"use strict";

var $messaging = $(".js-messaging-platform");

if (!$messaging.length) {
    return;
}

//globalVariables

var animationTime = 0.7;
var isMobile = function() {
    return window.innerWidth < 960;
};

initialize();

function initialize() {
    function createScene() {
        tween.kill();
        tween = new TimelineMax()
            .fromTo(
                ".message-one",
                animationTime,
                {
                    opacity: 0,
                    transform: "translateY(-25px)"
                },
                {
                    ease: Sine.easeIn,
                    opacity: 1,
                    transform: "translateY(0px)"
                }
            )
            .fromTo(
                ".divider-one",
                animationTime,
                {
                    height: isMobile() ? "2px" : "0%",
                    width: isMobile() ? "0%" : "2px",
                    opacity: 0
                },
                {
                    ease: Sine.easeIn,
                    height: isMobile() ? "2px" : "100%",
                    width: isMobile() ? "100%" : "2px",
                    opacity: 1
                },
                "-=.5"
            )
            .fromTo(
                ".message-two",
                animationTime,
                {
                    opacity: 0,
                    transform: "translateY(-25px)"
                },
                {
                    ease: Sine.easeIn,
                    opacity: 1,
                    transform: "translateY(0px)"
                }
            )
            .fromTo(
                ".divider-two",
                animationTime,
                {
                    height: isMobile() ? "2px" : "0%",
                    width: isMobile() ? "0%" : "2px",
                    opacity: 0
                },
                {
                    height: isMobile() ? "2px" : "100%",
                    width: isMobile() ? "100%" : "2px",
                    opacity: 1
                },
                "-=.5"
            )
            .fromTo(
                ".message-three",
                animationTime,
                {
                    opacity: 0,
                    transform: "translateY(-25px)"
                },
                {
                    ease: Sine.easeIn,
                    opacity: 1,
                    transform: "translateY(0px)"
                }
            );

        var controller = new ScrollMagic.Controller();
        scene.setTween(tween).addTo(controller);
    }
    var scene = new ScrollMagic.Scene({
        triggerElement: ".messaging-platform",
        triggerHook: 0.9, // show, when scrolled 10% into view
        reverse: false
    });
    var tween = new TimelineMax();

    createScene();
    // window.resize event listener
    var timeout = false;
    window.addEventListener("resize", function() {
        // clear the timeout
        clearTimeout(timeout);
        // start timing for event "completion"
        timeout = setTimeout(function() {
            createScene();
        }, 250);
    });
}

},{}],54:[function(require,module,exports){
'use strict';

var newsRankings = document.getElementById('news-rankings');

if(!newsRankings) {
    return;
}
 
var pageOptions = {
	pageName: 'news-rankings',
	searchResultsID: 'search-landing-results',
	activateBackToTop: true,
	activateBackToTopSilent: true,
	advancedSearch: true
};

// Panels
window.SearchLandingPanels = require('./search-landing-panels');

window.SearchLandingPanels.init(false, pageOptions);

window.ThrowawaySearchLandingFilters = require('./throwaway-search-landing-filters');

window.ThrowawaySearchLandingFilters.init(pageOptions);

window.animationSearchLogic = require('./animation-search-logic');

//return for garbage collection
newsRankings = null;
},{"./animation-search-logic":9,"./search-landing-panels":63,"./throwaway-search-landing-filters":71}],55:[function(require,module,exports){
'use strict';

var $oniTables = $('.oni-table')
	
if(!$oniTables.length > 0) {
    return;
}

function formatTableWithMobileLabel(table) {
  
  var $headers = $(table).find('thead th')

  var $tableRows = $(table).find('tbody').find('tr')

  var headerTextList =  []

  // Populate our headers
  $headers.each(function(index) {
    headerTextList[index] = $headers[index].innerText
  })

  // Populate our headers
  $tableRows.each(function(index) {
    var rowCells  = $tableRows[index] && $tableRows[index].children

    $(rowCells).each(function(idx) {
      const cell = rowCells[idx]

      if(cell && !cell.getAttribute('colspan')) {
        cell.dataset.label = headerTextList[idx]
      }
    })
  })
  
}


try {
  $oniTables.each(function(tableCellIndex) {
    formatTableWithMobileLabel($oniTables[tableCellIndex])
  })
} catch (error) {
  console.log('onitable error', error)
}


//return for garbage collection
$oniTables = null;
},{}],56:[function(require,module,exports){
'use strict';

var peopleDetail = document.getElementById('people-detail'),
	$siteHeader,

	//modules
	ReadMore,
	Accordions,
	ToggleMenu;

if(!peopleDetail) {
    return;
}

//pull in global vars
$siteHeader = require('./variables').$elements.$siteHeader;

//initialize overview
ReadMore = require('./read-more');


var relatedInsightsListing = $(peopleDetail).find('.js-insights-listing');

if(relatedInsightsListing.length) {
	new ReadMore( relatedInsightsListing );
}

//initiialize Experience
Accordions = require('./accordions');

var experienceNode = $(peopleDetail).find('.related-experience .js-accordions');

if(experienceNode.length) {
	new Accordions( experienceNode );
}


//scrollspy initialization
window.ScrollSpy = require('./scrollspy');
window.ScrollSpy.init();

// toggle menu
ToggleMenu = require('./toggle-menu');

// share tools
$('.share-tools').each(function() {
	var shareTools = new ToggleMenu($(this));
});


// return for garbage collection
peopleDetail = experienceNode = relatedInsightsListing = null;

},{"./accordions":2,"./read-more":59,"./scrollspy":60,"./toggle-menu":73,"./variables":75}],57:[function(require,module,exports){
  var ca = document.cookie.split(';');
  var showPopup = true;
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf('popupCookie') === 0) {
      if(c.substring('popupCookie='.length, c.length) === 'true'){
        showPopup = false;
      }
    }
  }
  if(showPopup) {
    $('.popup__component').removeClass('popup--disabled');
  }

  $('.popup__close').click (function () {
    $('.popup__component').addClass('popup--disabled');
    document.cookie = "popupCookie=true; path=/";
  });
},{}],58:[function(require,module,exports){
'use strict';

var professionalsLanding = document.getElementById('professionals-landing'),
	
	//modules
	SearchLandingFilters;

if(!professionalsLanding) {
    return;
}

window.SearchLandingFilters = require('./search-landing-filters');

window.SearchLandingFilters.init({pageName: 'professionals'});

//This logic can be replaced with angular/knockout specific syntax
window.SearchLandingFilters.initAlphaOptions();

//return for garbage collection
professionalsLanding = null;
},{"./search-landing-filters":61}],59:[function(require,module,exports){
'use strict';

var globalVars = require('./variables');
var customID = 1000;

function ReadMore($expandNode) {
	this.$ReadMore = $expandNode;
	this.$trigger = this.$ReadMore.find('.js-toggle-btn');
	this.$contentCollapsed = this.$ReadMore.find('.js-full-copy');
	this.labelCollapsed = this.$contentCollapsed.data('label-more');
	this.labelExpanded = this.$contentCollapsed.data('label-less');
	this.visibility = false;
	this.activeClass =  'is-expanded';
	this.animationSpeed =  350;
	this.scrollUpOnCollapse = false;

	this.bindEvents();
}

ReadMore.prototype.expandContent = function readMore() {
	this.visibility = true;

	this.$contentCollapsed
			.slideDown(this.animationSpeed, function(){
				$(this).attr('aria-hidden', false)
					.attr('tabindex', "0")
				
				if(window.BackToTop !== undefined) {
					window.BackToTop.refreshBodyDimensions();
				}

				if(window.ScrollSpy !== undefined) {
					window.ScrollSpy.refreshBodyDimensions();
				}

				if(globalVars.isMobile) {
					var padding = parseInt($('.page-wrapper').css('padding-left')) || 0;
					var scrollTop = $(this).offset().top - (globalVars.elementStates.headerHeight + padding)

					$('body,html').animate({ scrollTop: scrollTop }, this.animationSpeed);
				}

				$(this).focus();
			});
			

	this.$trigger.addClass(this.activeClass)
				 .text(this.labelExpanded)
				 .attr('aria-expanded', true);
};

ReadMore.prototype.collapseContent = function readLess() {
	this.visibility = false;

	this.$trigger.removeClass(this.activeClass)
				 .text(this.labelCollapsed)
				 .attr('aria-expanded', false);

	this.$contentCollapsed
		.attr('aria-hidden', true)
		.attr('tabindex', "-1")
		.slideUp(this.animationSpeed, function(){
			
			if(window.BackToTop !== undefined) {
				window.BackToTop.refreshBodyDimensions();
			}

			if(window.ScrollSpy !== undefined) {
				window.ScrollSpy.refreshBodyDimensions();
			}
		});
	
	$('body,html').animate( {scrollTop: this.$ReadMore.offset().top - 60}, this.animationSpeed);

};

ReadMore.prototype.toggleVisibility = function toggle() {
	(this.visibility === true )  ? this.collapseContent() : this.expandContent() ; 
};

ReadMore.prototype.bindEvents = function bindEvents() {
	var _self = this;

	// this.scrollUpOnCollapse = this.$ReadMore.data('scroll-on-collapse');
	const hasExpandableContent = _self.$contentCollapsed[0]
	const missingExpandableContent = hasExpandableContent && !Boolean(_self.$contentCollapsed[0].getAttribute('id'))

	if (hasExpandableContent && missingExpandableContent) {
		_self.$contentCollapsed[0].setAttribute('id', 'readmore-' + customID)

		if (_self.$trigger.length !== 0){
			_self.$trigger[0].setAttribute('aria-controls', 'readmore-' + customID)
		}
		
		++customID
	}

	_self.$trigger.on('click.ReadMore', function(ev){
		ev.preventDefault();
		_self.toggleVisibility();
	});
};


// Auto initialize on page to find all Read-More's. Read-More can also be added by client inside richtext. 
var readMoreNodes = $('.js-read-more');
if (readMoreNodes.length) {
	for (var i = 0; i < readMoreNodes.length; i++) {
		new ReadMore($(readMoreNodes[i]));
	}
}

for (var i = 0; i < readMoreNodes.length; i++) {
	readMoreNodes[i] = null;
}

module.exports = ReadMore;
},{"./variables":75}],60:[function(require,module,exports){
'use strict';

var $scrollspy,
	$menu,
	$menuItems,
	$scrollSections,
	$bodyHtml,
	$mobileToggle,

	//offsets/classes
	headerOffsets,
	nodeCollection,
	activeNavClass,
	mobileToggleClass,

	//magic controller
	magicController,
	sceneCollection,

	//module exports
	globalVars,
	windowResize,
	ScrollSpy;


ScrollSpy = {
	stickyMenuInit: function (headerOffsets) {

        var triggerElement,
        	deviceOffset,
            $capabilitiesLanding;

        $capabilitiesLanding = $('.page-capabilities-landing .js-scrollspy-capabilities-landing');

        triggerElement = $capabilitiesLanding.length ? $capabilitiesLanding[0] : $scrollspy[0];

        deviceOffset = (window.innerWidth < 900) ? Math.ceil( $menu.outerHeight() + 49 ) : 0;//49 accounts for padding on top of scrollnav section;


		sceneCollection['sticky-menu'] = new ScrollMagic.Scene({
			triggerElement: $scrollspy[0],
			triggerHook: 0,
			offset: headerOffsets,
			duration:  Math.ceil( $scrollspy.height() ) - Math.ceil( $menu.outerHeight() ) + deviceOffset
		})
		.on('enter leave', function(e){
            (e.type === 'enter') ? $menu.addClass('is-sticky-top') : $menu.removeClass('is-sticky-top') ;
        })
		.on('end', function(e){
		    (e.state === 'AFTER') ? $menu.addClass('is-sticky-bottom') : $menu.removeClass('is-sticky-bottom');
        })
		//.addIndicators()
		.addTo(magicController);
	},
	scrollToSection: function(sectionName) {

		var $sectionModule = nodeCollection[sectionName].module,
			sectionOffset = $sectionModule.offset().top,
			finalOffset = sectionOffset + headerOffsets * 2;

		if (globalVars.isMobile) { finalOffset = finalOffset - 70;} //magic number is height of subnavigation;

		$bodyHtml.animate({
			scrollTop: finalOffset
		}, 500, function(){
			$sectionModule.focus();
		});

	},
	menuEventsInit: function(){
		var _self = this;
		$menu.on('click.scrollspy', '.scrollspy-nav-link', function(ev){

			ev.stopPropagation();
			ev.preventDefault();

			var sectionID =  this.getAttribute('href');

	        sectionID = sectionID.slice(1).toLowerCase();

        	_self.scrollToSection(sectionID);

		});


		//mobile toggle
		$menu.on('click', '.js-nav-toggle', function(ev){

			ev.preventDefault();
			ev.stopPropagation();

			if( $menu.hasClass(mobileToggleClass) ) {
				$menu.removeClass(mobileToggleClass)
					.find('.scrollspy-nav-list')
						.attr('aria-hidden', 'true');

				$(this).attr('aria-expanded', 'false');

			} else {
				$menu.addClass(mobileToggleClass)
					.find('.scrollspy-nav-list')
						.attr('aria-hidden', 'false');

				$(this).attr('aria-expanded', 'true');
			}

		});
	},
	updateAriaStatus: function() {

		if(globalVars.isMobile || globalVars.isIpadPortrait) {
			$menu.removeClass(mobileToggleClass)
				.find('.scrollspy-nav-list')
					.attr('aria-hidden', 'true')
				.end()
				.find('.js-nav-toggle')
					.attr('aria-expanded', 'false');
		} else {
			$menu.addClass(mobileToggleClass)
				.find('.scrollspy-nav-list')
					.attr('aria-hidden', 'false')
				.end()
				.find('.js-nav-toggle')
					.attr('aria-expanded', 'true');
		}
	},
	magicSceneInit: function() {
		//
		var updateNavStatus,
			addMagicSceneSection,
			_self = this;


		//updating navigation
    	updateNavStatus = function(sectionName) {
        	$menuItems
        		.removeClass(activeNavClass)
        			.find('.scrollspy-nav-link')
        				.attr('aria-label', '');


        	if(!!sectionName) {
            	nodeCollection[sectionName]
            			.navItem.addClass(activeNavClass)
            			.find('.scrollspy-nav-link')
            				.attr('aria-label', 'Is Selected');
        	}

        	$mobileToggle.text(nodeCollection[sectionName].navItem.text());
        	$menu.removeClass(mobileToggleClass);
    	};

    	addMagicSceneSection = function (sectionNode) {

    		var moduleName = sectionNode.getAttribute('id').toLowerCase();
    		if (moduleName != "") {
    		    sceneCollection[moduleName + 'Scene'] = new ScrollMagic.Scene({
    		        triggerElement: nodeCollection[moduleName].module[0],
    		        duration: nodeCollection[moduleName].module.outerHeight()
    		    })
                .on('enter', function () { updateNavStatus(moduleName); })
                .addTo(magicController);
    		}

    	};

    	for (var i = 0; i < $scrollSections.length; i++) {
    		addMagicSceneSection($scrollSections.eq(i)[0]);
    	}


    	//dont need sections anymore, have it garbage collected;
    	addMagicSceneSection = null;

	},
	refreshBodyDimensions: function() {
		var headerOffsets,
			deviceOffset,
			resizeDuration;

		headerOffsets = globalVars.elementStates.headerHeight * -1;


		deviceOffset = (window.innerWidth < 900) ? Math.ceil( $menu.outerHeight() + 49 ) : 0;//49 accounts for padding on top of scrollnav section;

		resizeDuration =  Math.ceil( $scrollspy.height() ) - Math.ceil( $menu.outerHeight() ) - deviceOffset;

		if (resizeDuration < 0) {
			//this.disabledFeature();

			return;
		}

		sceneCollection['sticky-menu']
			.duration( resizeDuration )
			.offset(headerOffsets);

		this.refreshSectionDimensions();

	},
	refreshSectionDimensions: function() {


		var computeSectionDuration = function(moduleName) {

			sceneCollection[moduleName + 'Scene']
	            .duration( nodeCollection[moduleName].module.outerHeight() );
		};


		Object.keys(nodeCollection).forEach(function(key,index) {
        	computeSectionDuration(key);
    	});

	},
	windowResizeEvent: function(){
		var resizeMagicLogic;



		resizeMagicLogic = function() {

			//if magic scene is disabled do nothing until it's activated;
			if( !sceneCollection['sticky-menu'].enabled() ) {
				return;
			}


			this.refreshBodyDimensions();

    	};

    	windowResize.add( resizeMagicLogic.bind(this) );
	},
	init: function init() {

		var populateNodeCollection;

		//globalVariables
		globalVars = require('./variables');
		windowResize = globalVars.windowResize;

		magicController = globalVars.magicController;
		sceneCollection = globalVars.sceneCollection;

		//initialize elements;
		$scrollspy = $('.js-scrollspy');
		$menu = $scrollspy.find('.js-scrollspy-nav');
		$menuItems = $menu.find('.js-option');
		$scrollSections = $scrollspy.find('.js-scrollspy-section');
		$mobileToggle =  $scrollspy.find('.js-nav-toggle');
		$bodyHtml = $('body,html');

		//variables
		activeNavClass = 'is-inview';
		mobileToggleClass = 'show-menu';
		headerOffsets = globalVars.elementStates.headerHeight * -1;
		nodeCollection = {};

		populateNodeCollection = function($sectionNode) {

	        var sectionID = $sectionNode[0].getAttribute('id').toLowerCase(),
	        	$navNode = $menuItems.filter(function(index) {

	        		var hrefAttribute = $(this)
	        							.find('.scrollspy-nav-link')[0]
	        							.getAttribute('href');

	        		return ( sectionID === hrefAttribute.slice(1).toLowerCase() );
	        	});

	        nodeCollection[sectionID.toLowerCase()] = {
	            module: $sectionNode,
	            navItem: $navNode
	        };
	    };

		for (var i = $scrollSections.length - 1; i >= 0; i--) {
			populateNodeCollection( $scrollSections.eq(i) );
		}

		populateNodeCollection = null;

		//setup initial class for navigation, and update mobile default label
		$menuItems
			.eq(0).addClass(activeNavClass)
			.find('.scrollspy-nav-link')
				.attr('aria-label', 'Is Selected');

		$mobileToggle.text($menuItems
								.eq(0)
								.find('.scrollspy-nav-link').text() );

		this.stickyMenuInit(headerOffsets);

		this.menuEventsInit();

		this.magicSceneInit();

		this.updateAriaStatus();

		this.windowResizeEvent();
	}
};


module.exports = ScrollSpy;

},{"./variables":75}],61:[function(require,module,exports){
'use strict';

var searchFilters,
	customPanelTransition,
	pageOptions,

	//module exports
	advancedSearch = require('./advanced-search'),
	globalVars = require('./variables'),
	cachedElements = globalVars.elementStates,
	throwawayLogic = require('./throwaway-search-logic'),

	//export module 
	SearchLandingFilters;


SearchLandingFilters = {

	slideToSearchResults: function () {
		//compute offset of searchFilters
		var filtersOffset = parseInt( searchFilters.getBoundingClientRect().bottom + window.pageYOffset , 10);

		filtersOffset = Math.ceil(filtersOffset - cachedElements.headerHeight);

		$('html,body').animate({
			scrollTop:filtersOffset 
		}, 1000); 

	},
	initAccoladeSearch: function(){
		var $accoladeSearch = $('.js-accolade-search'),
			_self = this;


		$accoladeSearch.on('click.accoladeHighlight','.js-accolade-search-highlight', function(ev){
			ev.preventDefault();
			ev.stopPropagation();

			_self.slideToSearchResults();
				
			//this code can be replaced with framework of choice
			customPanelTransition(pageOptions);

			throwawayLogic.applySelectedFilter( $(this).text() );
		});

	},
	initAlphaOptions: function() {
		var _self = this;

		$(searchFilters)
			.find('.js-alpha-search')
			.on('click','.js-alpha-letter', function(ev){
				ev.preventDefault();
				var $this = $(this);

				if($this.hasClass('is-selected') ) {
					$this.removeClass('is-selected');

					return;
				}
				_self.slideToSearchResults();
				
				//this code can be replaced with framework of choice
				customPanelTransition(pageOptions);

				throwawayLogic.applySelectedFilter( $(this).data('alpha-letter') );
			});
	},
	dropdownCallback: function($this, $selectedItem) {
		SearchLandingFilters.slideToSearchResults();

		//this code can be replaced with framework of choice
		customPanelTransition(pageOptions);

		if (!!$selectedItem) {
			throwawayLogic.applySelectedFilter( $selectedItem.text() );
		}
	},
	showLoadingScreen: function(){
		throwawayLogic.showLoadingScreen();
	},
	hideLoadingScreen: function(){
		throwawayLogic.hideLoadingScreen();
	},	
	transitionToSearchDefault: function() {

		throwawayLogic.transitionToSearchDefault();
	},
	init: function init(pageConfig) {

		if(!pageConfig) {
			//console.log('invalid object' );
		}

		pageOptions = pageConfig;
		searchFilters = document.getElementById('search-landing-filters');
		
		var _self = this;

		advancedSearch.init({
			$module: $(searchFilters).find('.js-advanced-search'),

			callback: _self.dropdownCallback
		});

		switch(pageConfig.pageName)  {
			case 'professionals':
				customPanelTransition = throwawayLogic.professionalsTransition;
				this.initAccoladeSearch();

				break;
			// case 'insights-landing':
			// 	customPanelTransition = throwawayLogic.insightsTransitionSearchResults;

			// 	break;
			default:
				customPanelTransition = throwawayLogic.defaultTransition;
		}
		

		//can be removed 
		throwawayLogic.initBaseLogic($('.js-search-landing-filters'), pageConfig);
	}

};

module.exports = SearchLandingFilters;
},{"./advanced-search":3,"./throwaway-search-logic":72,"./variables":75}],62:[function(require,module,exports){
'use strict';

var SearchLandingPanels,
	$searchPanelsTabs,
	selectedClassName = 'is-panel-active',
	cb,
	config,
	//Used with Insights Landing or News events template
	BackToTop;



 
SearchLandingPanels = {
	init: function(callback, pageOptions) {
		var _self = this;

		if( typeof callback === 'function') {
			cb = callback;
		} else {
			cb = false;
		}

		config = (!pageOptions) ? {} : pageOptions;


		if(config.activateBackToTop) {
			BackToTop = require('./back-to-top');
		}
		
		// _self.attachClickEvent()

		//this.onLoadPanelState();

	},
	onLoadPanelState: function() {

		var hasSearch = false;

		var qsParms = window.parseQueryString(window.location.search);		

		for (var prop in qsParms) {
			if (prop != 'scroll' && prop != 'unload') {
				hasSearch = true;
			}
		}

		if (!hasSearch) {
			return;
		} else {
      this.switchPanels(qsParms.panelid);
		}
	},
	switchPanels: function(panelId) {

		var $searchPanels = $('#search-panels'),
			$panelToShow = $searchPanels.find('#' + panelId);

			$panelToShow.find('[aria-expanded="false"]').attr('aria-expanded', true);

		$searchPanels.find('.' + selectedClassName).fadeOut('slow', function() {

			$(this)
				.removeClass(selectedClassName)
				.attr('aria-hidden', true);

			$panelToShow.fadeIn('fast', function() {

				$(this)
					.addClass(selectedClassName)
					.attr('aria-hidden', false);

				//if we are to show the insights explore tab, then we will need to reset the display of the carousel due to tab being displayed none
				if(panelId.indexOf('explore') >= 0 ) {

					if(!cb) {
						return;
					}

					cb();
				} else if (config.activateBackToTop) {

					if( !BackToTop.isEnabled() ) {

						BackToTop.activateFeature();
					}

					BackToTop.refreshBodyDimensions();
				}

				//gc
				$searchPanels = $panelToShow = null;
			});

		});
	},
	forcePanel: function(panelId) {

    var $searchPanels = $('#search-panels'),
      $panelToShow = $searchPanels.find('#' + panelId);

    if ($panelToShow[0].getAttribute('aria-hidden') === "false") return;

		this.switchPanels(panelId);
	}
};


module.exports = SearchLandingPanels;

},{"./back-to-top":10}],63:[function(require,module,exports){
'use strict';

var SearchLandingPanels,
	$searchPanelsTabs,
	selectedClassName = 'is-panel-active',
	cb,
	config,
	//Used with Insights Landing or News events template
	BackToTop;



 
SearchLandingPanels = {
	init: function(callback, pageOptions) {
		var _self = this;

		if( typeof callback === 'function') {
			cb = callback;
		} else {
			cb = false;
		}

		config = (!pageOptions) ? {} : pageOptions;


		if(config.activateBackToTop) {
			BackToTop = require('./back-to-top');
		}
		
		_self.attachClickEvent()

		//this.onLoadPanelState();

	},
	onLoadPanelState: function() {

		var pageName = window.location.href,
			hasSearch = false,
			linkTab,
			panelName;


		var qsParms = window.parseQueryString(window.location.search);		

		for (var prop in qsParms) {
			if (prop != 'scroll' && prop != 'unload') {
				hasSearch = true;
			}
		}

		if (!hasSearch) {
			return;
		} else {

			linkTab = $searchPanelsTabs
				.find('a')
				.filter(function(index) {
					var tempPanelName = this.getAttribute('href');

					tempPanelName = tempPanelName.slice(1);


					if (tempPanelName.indexOf('find') >= 0) {
						panelName = tempPanelName;
						return true;
					}

				});

			this.switchPanels(panelName.toLowerCase());

			this.updateTabsState(linkTab[0]);

			pageName =  linkTab = null;
		}
	},
	updateTabsState: function(tabLink) {
		//reset Classes
		$searchPanelsTabs
			.find('.' + selectedClassName)
			.removeClass(selectedClassName)
				.find('.search-landing-tabs-btn')
				.attr('aria-selected', false);

		$(tabLink)
			.attr('aria-selected', true)
			.parent()
				.addClass(selectedClassName);
	},
	switchPanels: function(panelId) {

		var $searchPanels = $('#search-panels'),
			$panelToShow = $searchPanels.find('#' + panelId);

			$panelToShow.find('[aria-expanded="false"]').attr('aria-expanded', true);

		$searchPanels.find('.' + selectedClassName).fadeOut('slow', function() {

			$(this)
				.removeClass(selectedClassName)
				.attr('aria-hidden', true);

			$panelToShow.fadeIn('fast', function() {

				$(this)
					.addClass(selectedClassName)
					.attr('aria-hidden', false);

				//if we are to show the insights explore tab, then we will need to reset the display of the carousel due to tab being displayed none
				if(panelId.indexOf('explore') >= 0 ) {

					if(!cb) {
						return;
					}

					cb();
				} else if (config.activateBackToTop) {

					if( !BackToTop.isEnabled() ) {

						BackToTop.activateFeature();
					}

					BackToTop.refreshBodyDimensions();
				}

				//gc
				$searchPanels = $panelToShow = null;
			});

		});
	},
	forcePanel: function(panelId) {
		var $searchPanelsTabs = $('.js-search-landing-tabs'),
			$tabToShow = $searchPanelsTabs.find('#' + panelId);			

			var domTarget = $tabToShow[0],
				panelName;

			if(!!!domTarget.getAttribute('aria-selected') ) return ;

			if( domTarget.getAttribute('aria-selected') === "true") return;

			panelName = domTarget.getAttribute('href');

			panelName = panelName.slice(1);

			this.switchPanels(panelName.toLowerCase());

			this.updateTabsState(domTarget);
	},
	attachClickEvent: function () {
		var _self = this

		$searchPanelsTabs = $('.js-search-landing-tabs');

		$searchPanelsTabs.on('click.searchTabs', function (ev) {
			ev.preventDefault();
			ev.stopPropagation();

			var domTarget = ev.target,
				panelName;

			if ($(domTarget).hasClass("js-has-angular-click")) return;

			if (!!!domTarget.getAttribute('aria-selected')) return;

			if (domTarget.getAttribute('aria-selected') === "true") return;

			panelName = domTarget.getAttribute('href');

			panelName = panelName.slice(1);

			_self.switchPanels(panelName.toLowerCase());

			_self.updateTabsState(domTarget);

		});
	}
};


module.exports = SearchLandingPanels;

},{"./back-to-top":10}],64:[function(require,module,exports){
'use strict';



var SectionNav = (function() {
	var $sectionNav,
		$menu,
		$mobileToggle,

		//offsets/classes
		activeMenuClass,

		//module exports
		globalVars,
		windowResize;

	var menuToggleInit = function (){
		var _self = this;

		//mobile toggle
		$mobileToggle.on('click', function(ev){

			ev.preventDefault();
			ev.stopPropagation();

			if ( this.getAttribute('aria-expanded') === 'false') {
				$(this)
					.addClass(activeMenuClass)
					.attr('aria-expanded', true);
                $('.section-nav').addClass(activeMenuClass);
				$menu.attr('aria-hidden', false);

			} else {
				$(this)
					.removeClass(activeMenuClass)
					.attr('aria-expanded', false);
                $('.section-nav').removeClass(activeMenuClass);
				$menu.attr('aria-hidden', true);
			}

		});
	};

	var setupAccessibilityDefaultInit = function(){

		if(globalVars.isMobile) {
			$menu
				.attr('aria-hidden', true)
					.find('.is-menu-active')
					.attr('aria-hidden', true);
		} else {
			$mobileToggle
				.attr('aria-hidden', true)
				.attr('aria-expanded', true);
		}

	};

	var initModule = function init() {
			//globalVariables
			$sectionNav = $('.section-nav');

			if ($sectionNav.length === 0) {
				return;
			}
			globalVars = require('./variables');
			windowResize = globalVars.windowResize;

			//initialize elements;
			$sectionNav = $('.section-nav');
			$menu = $sectionNav.find('.js-menu');
			$mobileToggle =  $sectionNav.find('.js-menu-toggle');

			//variables
			activeMenuClass = 'show-full-menu';


			//setup mobile toggle text if not already present
			$mobileToggle
				.text( $menu.find('.is-menu-active').text() )
				.attr('aria-label', 'Menu Selected - ' + $menu.find('.is-menu-active').text() );

			menuToggleInit();

			setupAccessibilityDefaultInit();

			$sectionNav = null;
	};

	return {
		init: initModule
	};
})();

module.exports = SectionNav.init();

},{"./variables":75}],65:[function(require,module,exports){

'use strict';

var updateFacadeText,
    initializeDropdowns,
    focusOnDropdown,
    runCallback;

updateFacadeText = function updateFacadeText(selectLabel) {
    var $this = $( this ),
        $selectedItem,
        $selectLabel,
        currentText;

    $selectedItem = $this.find(':selected');

    if (!$selectedItem.length) { return; } 

    // get the facade element used to display
    // the text of the selected option
    $selectLabel = $this.siblings(selectLabel);

    // get 'value' attribute value for selected option
    currentText = $selectedItem.text();

    // update select text label with current selected option value
    if ($selectLabel.length && currentText.length) {
        $selectLabel.text(currentText);
    }
};

focusOnDropdown = function () {
    var $dropdownToggle = $(this);

    $dropdownToggle.next().focus();
};

runCallback = function runCallback(callback) {
    var $this = $( this ),
        $selectedItem = $this.find(':selected');

    callback($this, $selectedItem);
};

initializeDropdowns  = function($selectDropdowns, callback) {
    var $dropdowns = $selectDropdowns,
        eventNamespace = '.selectDropdown',
        eventToggleNamespace = '.toggleDropdown';

    $dropdowns
        .off('change' + eventNamespace)
        .on('change' + eventNamespace, '.select-dropdown-select', function () {

            updateFacadeText.call(this, '.select-dropdown-toggle');

            if( typeof callback === 'function') {
                runCallback.call(this, callback);
            }
        });

    $dropdowns = null;
};

module.exports = initializeDropdowns;
},{}],66:[function(require,module,exports){
'use strict';

var homepage = document.getElementById('homepage'),
	$siteHeader,
	$breadcrumbs,
	animateHeaderOffset,
	rotateClass,
	pageOffset,
	rAFTicker;


if(!!homepage) {
    return;
}

//pull in global vars
$siteHeader = require('./variables').$elements.$siteHeader;

rotateClass = 'is-animated-rotated';

$breadcrumbs = $siteHeader.find('.js-breadcrumbs');

/*=============================================
=            REquestion animation Frame            =
=============================================*/
function setupWindowOffsets() {
	animateHeaderOffset = 150;
}

function attachScrollEvent() {
	// only listen for scroll events
	window.addEventListener('scroll', requestTicker, false);
}

function removeScrollEvent() {
	//remove ScrollEvent
	window.removeEventListener('scroll', requestTicker, false);
}

function requestTicker() {
	if (!rAFTicker) {
		requestAnimationFrame(windowScrollLogic);
		rAFTicker = true;
	}
}

function windowScrollLogic(){
	pageOffset = window.pageYOffset;

	//no need to update breadcrumb state
	if(window.innerWidth <= 630) {
		return;
	}

	if( pageOffset >= animateHeaderOffset ) {
		$siteHeader.addClass(rotateClass);
		$breadcrumbs.attr('aria-hidden', 'false');
	}	

	else {
		$siteHeader.removeClass(rotateClass);
		$breadcrumbs.attr('aria-hidden', true);
	}
	
	rAFTicker = false;
}

//setup initial values
setupWindowOffsets();
attachScrollEvent();

/*=====  End RAF Animation  ======*/
},{"./variables":75}],67:[function(require,module,exports){
'use strict';

// window.Headroom = require('headroom.js');

var $siteHeader,
    $body,

    $siteNav,
    $siteSearchPanel,
    //state variables
    isMobileNavShown = false,
    isSearchBoxShown = false,
    //classes
    showSearchboxClass,
    showSitenavClass,
    toggleSearchbox,
    toggleNavMenu,
    placeFocusOnPanel,
    placeFocusOnToggle,
    escapePanelEvent,
    hideMainContent,
    showMainContent,
    restrictFocus,

    cachedNavToggle,
    cachedSearchToggle,

    //module specific
    handleIOSFixedScrolling,
    globalVars,
    siteHeader,
    allNodes;


$siteHeader = $('.js-site-header');

//pull in global vars
globalVars = require('./variables');
handleIOSFixedScrolling = require('./handle-ios-fixed-scrolling');

$body = globalVars.$elements.body;

$siteNav = $('.js-site-nav');
$siteSearchPanel = $('.js-site-search-panel');

showSearchboxClass ='show-searchbox';
showSitenavClass = 'show-site-nav';

// get all DOM nodes
allNodes = document.querySelectorAll("*");

placeFocusOnPanel = function focus($panel) {
    //$panel.find('.js-close').focus();
    $panel.focus();
};

placeFocusOnToggle = function focus($toggle) {
    $toggle.focus();
};

restrictFocus = function restrictfocus(event) {
    // first argument to jQuery .contains must be a DOM node, not a jQ object
    var siteNavDomNode = $siteNav.get(0);
    var siteSearchPanelDomNode = $siteSearchPanel.get(0);

    if ( isMobileNavShown && !$.contains( siteNavDomNode, event.target ) ) {
      event.stopPropagation();
      $siteNav.focus();
    }
    else if (isSearchBoxShown && !$.contains( siteSearchPanelDomNode, event.target ) ) {
        event.stopPropagation();
        $siteSearchPanel.focus();
    }
};

// wire focus event detection to all DOM nodes
for (var i = 0, len = allNodes.length; i < len; i++) {
    allNodes.item(i).addEventListener('focus', restrictFocus);
}

escapePanelEvent = function (ev) {
  if (ev.which === 27) {
      ev.stopPropagation();
      ev.preventDefault();


      if(isMobileNavShown) {
        toggleNavMenu(ev);
      }

      if(isSearchBoxShown) {
        toggleSearchbox(ev);
      }
    }
};



toggleSearchbox = function toggleSearchbox(e, preventFocusToggle) {
    e.stopPropagation();
    e.preventDefault();

    var clickedToggleNode = e.target;


    if(isSearchBoxShown) {
        $siteSearchPanel
            .removeClass(showSearchboxClass)
             .attr('aria-hidden', true)
             .attr('tabindex', '-1')
            .off('keydown');


        isSearchBoxShown = false;

        if(!!cachedSearchToggle) {

            $(cachedSearchToggle)
                .attr('aria-expanded', false)
                .off('keydown');

            if ( !preventFocusToggle ) {

                placeFocusOnToggle( $(cachedSearchToggle) );
            }

            cachedSearchToggle = null;
        }
        showMainContent();
    }
    else {
        if(isMobileNavShown) { toggleNavMenu(e, true); }

        isSearchBoxShown = true;

        $siteSearchPanel
            .on('keydown', function(ev){
                escapePanelEvent(ev);
            })
            .addClass(showSearchboxClass)
            .attr('aria-hidden', false)
            .attr('tabindex', '0')
            
        hideMainContent();

        handleIOSFixedScrolling.handleInputFocus();

        $siteSearchPanel.find('input[type="text"]').focus();

        cachedSearchToggle =  ( $(clickedToggleNode).hasClass('js-site-search-toggle') ) ? clickedToggleNode :  $(clickedToggleNode).closest('.js-site-search-toggle')[0];

        $(cachedSearchToggle)
            .attr('aria-expanded', true)
            .on('keydown', function(ev){
                escapePanelEvent(ev);
            });
    }
};

toggleNavMenu = function toggleNavMenu(e, preventFocusToggle, allowDefault) {
    if (!allowDefault) {
        e.stopPropagation();
        e.preventDefault();
    }

    var clickedToggleNode = e.target;

    if(isMobileNavShown) {
        $siteNav.removeClass(showSitenavClass)
                .attr('aria-hidden', true)
                .attr('tabindex', '-1')
                .off('keydown');

        isMobileNavShown = false;

        if(!!cachedNavToggle) {

            $(cachedNavToggle)
                .attr('aria-expanded', false)
                .off('keydown');

            if ( !preventFocusToggle ) {
                placeFocusOnToggle( $(cachedNavToggle) );
            }

            cachedNavToggle = null;
        }

        showMainContent();
    }
    else {

        if(isSearchBoxShown) {
            toggleSearchbox(e, true);
        }

        isMobileNavShown = true;

        $siteNav
            .on('keydown', function(ev){
                escapePanelEvent(ev);
            })
            .addClass(showSitenavClass)
            .attr('tabindex', '0')
            .attr('aria-hidden', false)
            .find('.site-nav-menu-link')
                .eq(0)
                .focus();

        // setTimeout(function(){
            
        // },300);

        hideMainContent();

        cachedNavToggle = ( $(clickedToggleNode).hasClass('js-mobile-toggle') ) ? clickedToggleNode :  $(clickedToggleNode).closest('.js-mobile-toggle')[0];

        $(cachedNavToggle)
            .attr('aria-expanded', true)
            .on('keydown', function(ev){
                escapePanelEvent(ev);
            });
    }
};

hideMainContent = function () {
    $('main, [role="main"]').attr('tabindex', '-1').attr('aria-hidden', 'true');
    $('footer').attr('tabindex', '-1').attr('aria-hidden', 'true');
    $siteHeader.attr('tabindex', '-1').attr('aria-hidden', 'true');
};

showMainContent = function () {
    $('main, [role="main"]').attr('tabindex', '').attr('aria-hidden', 'false');
    $('footer').attr('tabindex', '').attr('aria-hidden', 'false');
    $siteHeader.attr('tabindex', '').attr('aria-hidden', 'false');
};

//initiliaze click events
$siteHeader
    .on('click', '.js-mobile-toggle', toggleNavMenu)
    .on('click', '.js-site-search-toggle', toggleSearchbox);


$siteNav.on('click.closeNav', '.js-close', function(e) {
    e.stopPropagation();

    toggleNavMenu(e);
});

$siteSearchPanel.on('click.closeSearch', '.js-close', function(e) {
    e.stopPropagation();

    toggleSearchbox(e);
});

handleIOSFixedScrolling.init($siteSearchPanel.find('input[type="text"]') );

if(globalVars.isMobile) {
    $siteHeader.find('.js-breadcrumbs').attr('aria-hidden', 'true');
}

//assign variables to export
siteHeader = {
    toggleSearchbox: toggleSearchbox,
    toggleNavMenu: toggleNavMenu
};

$('.site-nav-menu-link').click(function (e) {
    toggleNavMenu(e, true, true);
});

module.exports = siteHeader;

},{"./handle-ios-fixed-scrolling":39,"./variables":75}],68:[function(require,module,exports){
'use strict';

// Search Boxes
var $searchBox = $('.js-searchbox');

if(!$searchBox) {
    return;
} 

var siteSearchForm = {    
    init: function init($searchBox) {
        var _self = this;

        $searchBox.each(function() {
            var $this = $(this);

            var $input = $this.find('input[type=text]'),
                $button = $this.find('button');

            var siteSearchBaseUrl = $input.attr("data-site-search-url");


            $button.on('click tap', function () {
                _self.siteSearch(siteSearchBaseUrl, $input.val());
            });

            $input.keypress(function (event) {
                var keyCode = (event.which ? event.which : event.keyCode);
                if (keyCode === 13) {
                    _self.siteSearch(siteSearchBaseUrl, $input.val());
                    return false;
                }
                return true;
            });
        });
    },
    siteSearch: function siteSearch(baseUrl, term) {
        var siteSearchUrl = baseUrl + "?keyword=" + escape(term);
        window.location.href = siteSearchUrl;
    }
};

siteSearchForm.init($searchBox);


// Search Landing
var siteSearch = document.getElementById('site-search');

if(!siteSearch) {
    return;
}



window.AnimationSearchLogic = require('./animation-search-logic');
window.AnimationSearchLogic.init();

//import modules
var ToggleMenu = require('./toggle-menu'),
    globalVars = require('./variables');

//setup local variables
var setupAriaTags,
    $filterDropdown = $(siteSearch).find('.js-site-search-nav'),
    filterLogic = new ToggleMenu($filterDropdown, {
        triggerClass: 'js-nav-toggle',
        expandableMenu: 'site-search-nav-items',
        showOptions: 'show-menu'
    });



//initialize event to close the navigation after a category has been selected
$filterDropdown.on( 'click.menuOptions', '.site-search-nav-option', function(ev){
    ev.stopPropagation();

    $(this)
        .addClass('is-selected')
        .siblings()
            .removeClass('is-selected');
        
    filterLogic.toggleMenu();

    $filterDropdown
        .find('.js-nav-toggle')
        .text( $(this).text() );

    $filterDropdown.find('.js-filter-applied-name').text('Results are Filtered by ' + $(this).text() )
});


//Setting up Aria Attributes based on wether or not the filters are converted to a dropdown
setupAriaTags = function() {

    if (window.innerWidth <=  900) {
        $filterDropdown
            .find('.js-nav-toggle')
                .attr('aria-expanded', false)
            .end()
            .find('.site-search-nav-items')
                .attr('aria-hidden', true);
    }

};

setupAriaTags();

globalVars.windowResize.add(setupAriaTags);
},{"./animation-search-logic":9,"./toggle-menu":73,"./variables":75}],69:[function(require,module,exports){
'use strict';

var standardFormPage = document.getElementById('standard-form');

if(!standardFormPage) {
    return;
} 

window.AnimationSearchLogic = require('./animation-search-logic');
window.AnimationSearchLogic.init();

var $dropdowns,
	//module exports
	selectDropdowns,
	standardForm;

standardForm = {
    selectDropdownsInit: function () {
        /*----------  initialize dropdown Functionality  ----------*/
        $dropdowns = $(standardFormPage).find('.js-select-dropdown');
        selectDropdowns($dropdowns);

        //back to gc
        $dropdowns = null;
    },
    init: function init() {
        //modules
        selectDropdowns = require('./select-dropdown');
        this.selectDropdownsInit();
    }
};

standardForm.init();

//return for garbage collection
standardFormPage = null;
},{"./animation-search-logic":9,"./select-dropdown":65}],70:[function(require,module,exports){
'use strict';

var $tabs = $('.js-tabs');
var $radioOptions,
    $tabButton;

if ($tabs.length === 0) {
    return;
}

$tabButton = $tabs.find('[role="tab"]');

$tabButton.on('click', function(event) {
  event.preventDefault();

  var $this = $(this);
  var panelId = $this.attr('aria-controls');
  var $panels = $tabs.find('[role="tabpanel"]');
  var $panel = $('#' + panelId);

  if ($panel.length === 0) {
    return;
  }

  $this.siblings().attr('aria-selected', 'false');
  $this.attr('aria-selected', 'true');
  $this.siblings().removeClass('active');
  $this.addClass('active');

  $panels.attr('aria-hidden', 'true');
  $panels.addClass('is-hidden');

  $panel.attr('aria-hidden', 'false');
  $panel.removeClass('is-hidden');

});
},{}],71:[function(require,module,exports){
'use strict';

var searchFiltersForm,
	pageOptions,
	$clearAll,

	//module exports
	advancedSearch,
	exposedSearchFilters,
	throwawayLogic = require('./throwaway-search-logic'),
	animationSearchLogic = require('./animation-search-logic'),

	//export module
	SearchLandingFilters;


SearchLandingFilters = {
	handleContentDisplay: function() {

		var searchResultsContent = document.getElementById(pageOptions.searchResultsID);

		( searchResultsContent.getAttribute('aria-hidden') === 'true' ) ? (
			animationSearchLogic.transitionFromDefaultToResults()
		) : (
			animationSearchLogic.showSearchResults()
		);

		searchResultsContent = null;

	},
	dropdownCallback: function($this, $selectedItem) {

		if (!!$selectedItem) {

			throwawayLogic.applySelectedFilter( $selectedItem.text() );
		}
		animationSearchLogic.showSearchResults();		
	},
	categoryFilterCallback: function($category) {

		throwawayLogic.applySelectedFilter( $category.next().text() );

		animationSearchLogic.showSearchResults();
		
	},
	initClearAllEvent: function() {

		$clearAll.on('click.clearResults', function(ev) {
			ev.stopPropagation();

			animationSearchLogic.transitionToSearchDefault();


			//clear radio buttons
			if(!!pageOptions.categoryFilters) {

				advancedSearch.clearRadioButtons();
			}
			
		});
	},
	showLoadingScreen: function(){
		animationSearchLogic.showLoadingScreen();
	},
	hideLoadingScreen: function(){
		animationSearchLogic.hideLoadingScreen();
	},
	transitionToSearchDefault: function() {

		animationSearchLogic.transitionToSearchDefault();
	},

	init: function init(pageConfig) {

		if(!pageConfig) {
			//console.log('invalid argument, need Object supplied' );
		}

		pageOptions = pageConfig;
		pageOptions.searchFormID = 'search-landing-filters';

		//assign vanilla elements
		searchFiltersForm = document.getElementById(pageOptions.searchFormID);

		//assign jquery elements
		
		$clearAll = $('.js-applied-filters').find('.js-filter-clear');

		animationSearchLogic.init(pageOptions);

		//can be remove
		throwawayLogic.init();

		this.initClearAllEvent();

		var _self = this;

		//initialize advanced search
		if(!!pageOptions.advancedSearch) {
			advancedSearch = require('./advanced-search');

			advancedSearch.init({
				$module: $( searchFiltersForm ).find('.js-advanced-search'),
				$trigger: $(searchFiltersForm).find('.js-toggle'),
				callback: _self.dropdownCallback,
				categoryCallback: _self.categoryFilterCallback
			});
		}


		if(!!pageOptions.exposedSearchFilters) {
			exposedSearchFilters = require('./exposed-search-filters');

			exposedSearchFilters.init({
				$module: $( searchFiltersForm ).find('.js-exposed-search-filters'),
				callback: _self.dropdownCallback
			});
		}
	}
};

module.exports = SearchLandingFilters;
},{"./advanced-search":3,"./animation-search-logic":9,"./exposed-search-filters":21,"./throwaway-search-logic":72}],72:[function(require,module,exports){
'use strict';

var throwawayLogic,
	$appliedFiltersList,
	$clearAll,
	$keywordSearch,
	resultsBodyClass,
	pageConfig,
	timeoutDelay = 750,
	$loadingScreen,

	globalVars = require('./variables'),
	cachedElements = globalVars.elementStates,

	//used on insights landing
	BackToTop = require('./back-to-top');


throwawayLogic = {
	slideToSearchResults: function (searchFilters) {
		//compute offset of searchFilters
		var filtersOffset = parseInt( searchFilters.getBoundingClientRect().bottom + window.pageYOffset , 10);

		filtersOffset = Math.ceil(filtersOffset - cachedElements.headerHeight);

		$('html,body').animate({
			scrollTop:filtersOffset 
		}, 500);


		searchFilters = null;
	},
	applySelectedFilter: function (filterName) {

		if(!$appliedFiltersList) {
			$appliedFiltersList = $('.js-applied-filters').find('.applied-filters-list');
		} 
		var $htmlFilter = $('<div class="applied-filter js-filter">' + 
					filterName + 
					'<button aria-label="Remove Filter '+  
					filterName + 
					'" class="applied-filter-remove js-remove-filter"></button>' +
					'</div>' );
		$htmlFilter.prependTo($appliedFiltersList);

	},
	initClearAllEvent: function() {
		var _self = this;


		$clearAll.on('click.clearResults', function(ev) {
			ev.stopPropagation();

			_self.transitionToSearchDefault();
		});
	},
	init: function(){
		var $appliedFilters = $('.js-applied-filters');

		$loadingScreen = $('.js-loading-screen');

		$appliedFiltersList = $appliedFilters.find('.applied-filters-list');
	},
	initBaseLogic: function(searchFilters, pageConfiguration) {
		var _self = this,
			$appliedFilters = $('.js-applied-filters');

		$loadingScreen = $('.js-loading-screen');			

		$appliedFiltersList = $appliedFilters.find('.applied-filters-list');

		$clearAll = $appliedFilters.find('.js-filter-clear');

		$keywordSearch = $(searchFilters).find('.js-keyword-search').find('input');

		pageConfig = pageConfiguration;

		_self.initClearAllEvent();
		
		//handle submit of form
		$( searchFilters ).submit(function( ev ) {
			ev.preventDefault();

			switch(pageConfig.pageName)  {
				case 'professionals':
					_self.professionalsTransition();

					break;

				// case 'insights-landing':
				// 	_self.insightsTransitionSearchResults();

				// 	break;
				default:
					_self.defaultTransition(pageConfig);
			}

			_self.slideToSearchResults(searchFilters);

			if( !!$keywordSearch.val() ) {
				_self.applySelectedFilter($keywordSearch.val() );
			}
		
		});

		if(pageConfig.pageName === 'professionals') {
			resultsBodyClass = 'professionals-landing-results';
		} else {
			resultsBodyClass = 'search-landing-results';
		}

		//back to top init
		if(pageConfig.activateBackToTop) {
			BackToTop.init({silentInit: true});
		}
	},
	showLoadingScreen: function(){
		$loadingScreen.addClass('show-loading-screen');
	},
	hideLoadingScreen: function(){
		$loadingScreen.removeClass('show-loading-screen');
	},
	defaultTransition: function(pageConfig) {
		var resultsBody = document.getElementById('search-landing-results');

		var $loadingScreen = $('.js-loading-screen');
		$loadingScreen.addClass('show-loading-screen');			
		setTimeout(function() { $loadingScreen.removeClass('show-loading-screen'); }, timeoutDelay);

		if ( resultsBody.getAttribute('aria-hidden') === 'true') {
			$(resultsBody).fadeIn('fast', function() {
				$(this).attr('aria-hidden', false);
			});


			if(pageConfig.activateBackToTop) {
				BackToTop.refreshBodyDimensions();
			}

			resultsBody = null;
		} else {

			if(pageConfig.activateBackToTop) {
				BackToTop.refreshBodyDimensions();
			}

			resultsBody = null;	
		}
	},
	transitionToSearchDefault: function() {
		var _self = this;

		var resultsBody = document.getElementById(resultsBodyClass);
		
		_self.showLoadingScreen();

		$appliedFiltersList.find('.js-filter').fadeOut();

		
		$('html,body').animate({
			scrollTop:0 
		}, timeoutDelay);


		$(resultsBody).slideUp(timeoutDelay, function() {
			$(this).attr('aria-hidden', true);

			_self.hideLoadingScreen();

			resultsBody = null;

			if(pageConfig.activateBackToTop) {
				BackToTop.disableFeature();
			}

		})
		.parent()
		.find('#professionals-landing-promo').fadeIn('slow');

		resultsBody = null;
	},
	professionalsTransition: function() {
		var _self = this;

		var ProfessionalResults = document.getElementById('professionals-landing-results');

		var $loadingScreen = $('.js-loading-screen');
	 	$loadingScreen.addClass('show-loading-screen');			
		setTimeout(function() { $loadingScreen.removeClass('show-loading-screen'); }, timeoutDelay);

		if( ProfessionalResults.getAttribute('aria-hidden') === 'true') {

			$(ProfessionalResults)
				.parent()
				.css('height', $(ProfessionalResults).outerHeight() )
			.find('#professionals-landing-promo').fadeOut('slow', function() {
				$(this).attr('aria-hidden', true);
				$(this).parent()
						.css('height', '');

				$(ProfessionalResults).fadeIn('slow', function() {
					$(this).attr('aria-hidden', false);
				});

				ProfessionalResults = null;
			});
		}
	}
};


module.exports = throwawayLogic;

},{"./back-to-top":10,"./variables":75}],73:[function(require,module,exports){
'use strict';

function ToggleMenu (toggleEl, classOptions) {
    this.$toggleMenu = toggleEl;
    this.$trigger = null;

    this.classNames =  classOptions || {
        triggerClass: 'js-trigger',
        expandableMenu: 'js-menu',
        showOptions: 'show-menu'
    };

    this.bindEvents();
}


ToggleMenu.prototype.toggleMenu = function toggleMenu(){
    var _self = this;

    var $expandableMenu = _self.$toggleMenu.find('.' + _self.classNames.expandableMenu);

    if ( _self.$toggleMenu.data('is-expanded') ) {

        _self.$toggleMenu
                .removeClass(_self.classNames.showOptions)
                .data('is-expanded', false);

        _self.$trigger.attr('aria-expanded', false).blur();

        if ($expandableMenu.length > 0) $expandableMenu.attr('aria-hidden', true);
    }

    else {
        _self.$toggleMenu.addClass( _self.classNames.showOptions );

        _self.$toggleMenu.data('is-expanded', true);

        _self.$trigger.attr('aria-expanded', true);

        if ($expandableMenu.length > 0) {

            $expandableMenu.attr('aria-hidden', false);
            
            $expandableMenu
                .find('a')
                    .eq(0)
                    .focus(); 
        }
    }

    $expandableMenu  = null;
};


ToggleMenu.prototype.bindEvents = function bind() {
    var _self = this;

    //Assign trigger Element
    _self.$trigger = _self.$toggleMenu.find('.' + _self.classNames.triggerClass);

    //set data attribute to keep track of expanded Menu
    if (typeof _self.$toggleMenu.data('is-expanded') === 'undefined') {

        _self.$toggleMenu.data('is-expanded', false);
    }


    //set active class if expanded by default
    if ( _self.$toggleMenu.data('is-expanded') ) {
        _self.$toggleMenu.addClass( _self.classNames.showOptions );
    }


    //toggle view of dropdown display
    _self.$trigger
    .off('click.toggleMenu')
    .on('click.toggleMenu', function (ev) {
        ev.preventDefault();
        ev.stopPropagation();

        _self.toggleMenu();
    });

};


module.exports = ToggleMenu;

},{}],74:[function(require,module,exports){
'use strict';

//helper functions
window.helperUtils = {
    getDocDimen: function () {
        var winDimen = {};

        winDimen.height = window.innerHeight;
        winDimen.width = window.innerWidth;

        return winDimen;
    }
};

window.parseQueryString = function (str) {
    if (typeof str !== 'string') {
        return {};
    }
    str = str.trim().replace(/^\?/, '');
    if (!str) {
        return {};
    }
    return str.trim().split('&').reduce(function (ret, param) {
        var parts = param.replace(/\+/g, ' ').split('=');
        ret[parts[0]] = parts[1] === undefined ? null : decodeURIComponent(parts[1]);
        return ret;
    }, {});
};

/**
 * Get the value of a querystring
 * @param  {String} field The field to get the value of
 * @param  {String} url   The URL to get the value from (optional)
 * @return {String}       The field value
 */
window.getQueryString = function (field, url) {
    var href = url ? url : window.location.href;
    var reg = new RegExp('[?&]' + field + '=([^&#]*)', 'i');
    var string = reg.exec(href);
    return string ? string[1] : null;
};


// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
// http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating

// requestAnimationFrame polyfill by Erik Möller
// fixes from Paul Irish and Tino Zijdel

(function () {
    var lastTime = 0;
    var vendors = ['ms', 'moz', 'webkit', 'o'];
    for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
        window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
        window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame'] || window[vendors[x] + 'CancelRequestAnimationFrame'];
    }

    if (!window.requestAnimationFrame)
        window.requestAnimationFrame = function (callback, element) {
            var currTime = new Date().getTime();
            var timeToCall = Math.max(0, 16 - (currTime - lastTime));
            var id = window.setTimeout(function () { callback(currTime + timeToCall); },
	          timeToCall);
            lastTime = currTime + timeToCall;
            return id;
        };

    if (!window.cancelAnimationFrame)
        window.cancelAnimationFrame = function (id) {
            clearTimeout(id);
        };
}());

},{}],75:[function(require,module,exports){
'use strict';

var globalVars = {

    device: {
        isIpad: null,
        isIphone: null
    },

    elementStates: {
        headerHeight: null
    },

    $elements: {
        $siteHeader: $('.js-site-header'),
        $lawyerCareersSubHeader: $('.lawyer-careers-navigation'),
    },

    isMobile: false,
    isTabletMax: false,
};

var setupValues,

	//responsive media query function
	mqMobile;


//setup globalMagicController
globalVars.magicController = new ScrollMagic.Controller();

globalVars.sceneCollection = {};

globalVars.elementStates = {
    //if the page isn't a lawyer careers interior page, then $careersSubHeader.outerheight is null and it is not accounted for
    headerHeight: (globalVars.$elements.$siteHeader.outerHeight() + globalVars.$elements.$lawyerCareersSubHeader.outerHeight())
};

setupValues = function (tabletState){
	globalVars.isMobile = (window.innerWidth < 767) ? true : false;
    globalVars.isMobileLawyerCareers = (window.innerWidth < 993) ? true : false;
    globalVars.isTabletMax = tabletState;

    globalVars.elementStates.headerHeight = Math.ceil( globalVars.$elements.$siteHeader.outerHeight() + globalVars.$elements.$lawyerCareersSubHeader.outerHeight() );
};

//make sure this matches css
mqMobile = window.matchMedia('(max-width: 960px)');

(mqMobile.matches) ? setupValues(true) : setupValues(false);

mqMobile.addListener( function(changed) {
	(changed.matches) ? setupValues(true) : setupValues(false);
});



( navigator.userAgent.match(/iPhone/i) ) ? globalVars.device.isIphone = true : globalVars.device.isIphone = false;
( navigator.userAgent.match(/iPad/i) ) ? globalVars.device.isIpad = true : globalVars.device.isIpad = false;

// global var for iPad portrait used by scrollspy nav
globalVars.isIpadPortrait = window.innerWidth === 768 && globalVars.device.isIpad;


globalVars.windowResize =  (function() {

    var callbacks = [],
        running = false;

    // fired on resize event
    function resize() {

        if (!running) {
            running = true;

            if (window.requestAnimationFrame) {
                window.requestAnimationFrame(runCallbacks);
            } else {
                setTimeout(runCallbacks, 66);
            }
        }

    }

    // run the actual callbacks
    function runCallbacks() {

        callbacks.forEach(function(callback) {
            callback();
        });

        running = false;
    }

    // adds callback to loop
    function addCallback(callback) {

        if (callback) {
            callbacks.push(callback);
        }

    }

    return {
        // public method to add additional callback
        add: function(callback) {
            if (!callbacks.length) {
                window.addEventListener('resize', resize);
            }
            addCallback(callback);
        }
    };
}());


module.exports = globalVars;



},{}],76:[function(require,module,exports){
(function (window) {
    'use strict';

    require('./app/jquery.history.js');

    require('./app/variables');
    require('./app/util-helper');
    require('./app/site-header');
    require('./app/site-header-perspective');
    require('./app/lawyer-careers-mobile-nav');
    require('./app/footnote-jump-links');

    //homepage
    require('./app/homepage');
    require('./app/popup');
    require('./app/home-explore');
    require('./app/messaging-platform');

    //common components
    require('./app/section-nav');
    require('./app/read-more');
    require('./app/oni-table.js');

    //pages
    require('./app/people-detail');
    require('./app/locations-detail');
    require('./app/capability-landing');
    require('./app/capability-detail');
    require('./app/careers-detail');
    require('./app/insights-detail');
    require('./app/insights-landing');
    require('./app/professionals-landing');
    require('./app/locations-landing');
    require('./app/careers-landing');
    require('./app/careers-lawyer-page');
    require('./app/careers-location-header');
    require('./app/about-landing');
    require('./app/general-content');
    require('./app/news-rankings');
    require('./app/standard-form');

    //shared file between main and alumni site
    require('./app/job-board');
    require('./app/job-detail');

    //alumni
    require('./app/alumni-homepage');
    require('./app/alumni-directory');
    require('./app/alumni-news-events');
    require('./app/alumni-cle-library');
    require('./app/alumni-spotlight-detail');

    //external links
    require('./app/external-links-new-window');

    //Foundation Site
    require('./app/foundation-homepage');
    require('./app/foundation-fellows-directory');
    require('./app/foundation-news-stories');
    require('./app/foundation-generic-content');
    require('./app/foundation-facts');
    require('./app/foundation-news-detail');
    require('./app/foundation-webinars');
    require('./app/foundation-forum');
    require('./app/foundation-forum-detail');

    // Site Search
    require('./app/site-search');

})(window);

},{"./app/about-landing":1,"./app/alumni-cle-library":4,"./app/alumni-directory":5,"./app/alumni-homepage":6,"./app/alumni-news-events":7,"./app/alumni-spotlight-detail":8,"./app/capability-detail":11,"./app/capability-landing":12,"./app/careers-detail":14,"./app/careers-landing":15,"./app/careers-lawyer-page":16,"./app/careers-location-header":17,"./app/external-links-new-window":22,"./app/footnote-jump-links":24,"./app/foundation-facts":27,"./app/foundation-fellows-directory":28,"./app/foundation-forum":30,"./app/foundation-forum-detail":29,"./app/foundation-generic-content":31,"./app/foundation-homepage":32,"./app/foundation-news-detail":34,"./app/foundation-news-stories":35,"./app/foundation-webinars":37,"./app/general-content":38,"./app/home-explore":42,"./app/homepage":43,"./app/insights-detail":44,"./app/insights-landing":45,"./app/job-board":46,"./app/job-detail":47,"./app/jquery.history.js":48,"./app/lawyer-careers-mobile-nav":49,"./app/locations-detail":51,"./app/locations-landing":52,"./app/messaging-platform":53,"./app/news-rankings":54,"./app/oni-table.js":55,"./app/people-detail":56,"./app/popup":57,"./app/professionals-landing":58,"./app/read-more":59,"./app/section-nav":64,"./app/site-header":67,"./app/site-header-perspective":66,"./app/site-search":68,"./app/standard-form":69,"./app/util-helper":74,"./app/variables":75}],77:[function(require,module,exports){
/* 
     _ _      _       _
 ___| (_) ___| | __  (_)___
/ __| | |/ __| |/ /  | / __|
\__ \ | | (__|   < _ | \__ \
|___/_|_|\___|_|\_(_)/ |___/
                   |__/

 Version: 1.6.0
  Author: Ken Wheeler
 Website: http://kenwheeler.github.io
    Docs: http://kenwheeler.github.io/slick
    Repo: http://github.com/kenwheeler/slick
  Issues: http://github.com/kenwheeler/slick/issues

 */
/* global window, document, define, jQuery, setInterval, clearInterval */
(function(factory) {
    'use strict';
    
    factory(jQuery);

}(function($) {
    'use strict';
    var Slick = window.Slick || {};

    Slick = (function() {

        var instanceUid = 0;

        function Slick(element, settings) {

            var _ = this, dataSettings;

            _.defaults = {
                accessibility: true,
                adaptiveHeight: false,
                appendArrows: $(element),
                appendDots: $(element),
                arrows: true,
                asNavFor: null,
                prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button">Previous</button>',
                nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button">Next</button>',
                autoplay: false,
                autoplaySpeed: 3000,
                centerMode: false,
                centerPadding: '50px',
                cssEase: 'ease',
                customPaging: function(slider, i) {
                    return $('<button type="button" data-role="none" role="button" tabindex="0" />').text(i + 1);
                },
                dots: false,
                dotsClass: 'slick-dots',
                draggable: true,
                easing: 'linear',
                edgeFriction: 0.35,
                fade: false,
                focusOnSelect: false,
                infinite: true,
                initialSlide: 0,
                lazyLoad: 'ondemand',
                mobileFirst: false,
                pauseOnHover: true,
                pauseOnFocus: true,
                pauseOnDotsHover: false,
                respondTo: 'window',
                responsive: null,
                rows: 1,
                rtl: false,
                slide: '',
                slidesPerRow: 1,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                swipe: true,
                swipeToSlide: false,
                touchMove: true,
                touchThreshold: 5,
                useCSS: true,
                useTransform: true,
                variableWidth: false,
                vertical: false,
                verticalSwiping: false,
                waitForAnimate: true,
                zIndex: 1000
            };

            _.initials = {
                animating: false,
                dragging: false,
                autoPlayTimer: null,
                currentDirection: 0,
                currentLeft: null,
                currentSlide: 0,
                direction: 1,
                $dots: null,
                listWidth: null,
                listHeight: null,
                loadIndex: 0,
                $nextArrow: null,
                $prevArrow: null,
                slideCount: null,
                slideWidth: null,
                $slideTrack: null,
                $slides: null,
                sliding: false,
                slideOffset: 0,
                swipeLeft: null,
                $list: null,
                touchObject: {},
                transformsEnabled: false,
                unslicked: false
            };

            $.extend(_, _.initials);

            _.activeBreakpoint = null;
            _.animType = null;
            _.animProp = null;
            _.breakpoints = [];
            _.breakpointSettings = [];
            _.cssTransitions = false;
            _.focussed = false;
            _.interrupted = false;
            _.hidden = 'hidden';
            _.paused = true;
            _.positionProp = null;
            _.respondTo = null;
            _.rowCount = 1;
            _.shouldClick = true;
            _.$slider = $(element);
            _.$slidesCache = null;
            _.transformType = null;
            _.transitionType = null;
            _.visibilityChange = 'visibilitychange';
            _.windowWidth = 0;
            _.windowTimer = null;

            dataSettings = $(element).data('slick') || {};

            _.options = $.extend({}, _.defaults, settings, dataSettings);

            _.currentSlide = _.options.initialSlide;

            _.originalSettings = _.options;

            if (typeof document.mozHidden !== 'undefined') {
                _.hidden = 'mozHidden';
                _.visibilityChange = 'mozvisibilitychange';
            } else if (typeof document.webkitHidden !== 'undefined') {
                _.hidden = 'webkitHidden';
                _.visibilityChange = 'webkitvisibilitychange';
            }

            _.autoPlay = $.proxy(_.autoPlay, _);
            _.autoPlayClear = $.proxy(_.autoPlayClear, _);
            _.autoPlayIterator = $.proxy(_.autoPlayIterator, _);
            _.changeSlide = $.proxy(_.changeSlide, _);
            _.clickHandler = $.proxy(_.clickHandler, _);
            _.selectHandler = $.proxy(_.selectHandler, _);
            _.setPosition = $.proxy(_.setPosition, _);
            _.swipeHandler = $.proxy(_.swipeHandler, _);
            _.dragHandler = $.proxy(_.dragHandler, _);
            _.keyHandler = $.proxy(_.keyHandler, _);

            _.instanceUid = instanceUid++;

            // A simple way to check for HTML strings
            // Strict HTML recognition (must start with <)
            // Extracted from jQuery v1.11 source
            _.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/;


            _.registerBreakpoints();
            _.init(true);

        }

        return Slick;

    }());

    Slick.prototype.activateADA = function() {
        var _ = this;

        _.$slideTrack.find('.slick-active').attr({
            'aria-hidden': 'false'
        }).find('a, input, button, select').attr({
            'tabindex': '0'
        });

    };

    Slick.prototype.addSlide = Slick.prototype.slickAdd = function(markup, index, addBefore) {

        var _ = this;

        if (typeof(index) === 'boolean') {
            addBefore = index;
            index = null;
        } else if (index < 0 || (index >= _.slideCount)) {
            return false;
        }

        _.unload();

        if (typeof(index) === 'number') {
            if (index === 0 && _.$slides.length === 0) {
                $(markup).appendTo(_.$slideTrack);
            } else if (addBefore) {
                $(markup).insertBefore(_.$slides.eq(index));
            } else {
                $(markup).insertAfter(_.$slides.eq(index));
            }
        } else {
            if (addBefore === true) {
                $(markup).prependTo(_.$slideTrack);
            } else {
                $(markup).appendTo(_.$slideTrack);
            }
        }

        _.$slides = _.$slideTrack.children(this.options.slide);

        _.$slideTrack.children(this.options.slide).detach();

        _.$slideTrack.append(_.$slides);

        _.$slides.each(function(index, element) {
            $(element).attr('data-slick-index', index);
        });

        _.$slidesCache = _.$slides;

        _.reinit();

    };

    Slick.prototype.animateHeight = function() {
        var _ = this;
        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
            _.$list.animate({
                height: targetHeight
            }, _.options.speed);
        }
    };

    Slick.prototype.animateSlide = function(targetLeft, callback) {

        var animProps = {},
            _ = this;

        _.animateHeight();

        if (_.options.rtl === true && _.options.vertical === false) {
            targetLeft = -targetLeft;
        }
        if (_.transformsEnabled === false) {
            if (_.options.vertical === false) {
                _.$slideTrack.animate({
                    left: targetLeft
                }, _.options.speed, _.options.easing, callback);
            } else {
                _.$slideTrack.animate({
                    top: targetLeft
                }, _.options.speed, _.options.easing, callback);
            }

        } else {

            if (_.cssTransitions === false) {
                if (_.options.rtl === true) {
                    _.currentLeft = -(_.currentLeft);
                }
                $({
                    animStart: _.currentLeft
                }).animate({
                    animStart: targetLeft
                }, {
                    duration: _.options.speed,
                    easing: _.options.easing,
                    step: function(now) {
                        now = Math.ceil(now);
                        if (_.options.vertical === false) {
                            animProps[_.animType] = 'translate(' +
                                now + 'px, 0px)';
                            _.$slideTrack.css(animProps);
                        } else {
                            animProps[_.animType] = 'translate(0px,' +
                                now + 'px)';
                            _.$slideTrack.css(animProps);
                        }
                    },
                    complete: function() {
                        if (callback) {
                            callback.call();
                        }
                    }
                });

            } else {

                _.applyTransition();
                targetLeft = Math.ceil(targetLeft);

                if (_.options.vertical === false) {
                    animProps[_.animType] = 'translate3d(' + targetLeft + 'px, 0px, 0px)';
                } else {
                    animProps[_.animType] = 'translate3d(0px,' + targetLeft + 'px, 0px)';
                }
                _.$slideTrack.css(animProps);

                if (callback) {
                    setTimeout(function() {

                        _.disableTransition();

                        callback.call();
                    }, _.options.speed);
                }

            }

        }

    };

    Slick.prototype.getNavTarget = function() {

        var _ = this,
            asNavFor = _.options.asNavFor;

        if ( asNavFor && asNavFor !== null ) {
            asNavFor = $(asNavFor).not(_.$slider);
        }

        return asNavFor;

    };

    Slick.prototype.asNavFor = function(index) {

        var _ = this,
            asNavFor = _.getNavTarget();

        if ( asNavFor !== null && typeof asNavFor === 'object' ) {
            asNavFor.each(function() {
                var target = $(this).slick('getSlick');
                if(!target.unslicked) {
                    target.slideHandler(index, true);
                }
            });
        }

    };

    Slick.prototype.applyTransition = function(slide) {

        var _ = this,
            transition = {};

        if (_.options.fade === false) {
            transition[_.transitionType] = _.transformType + ' ' + _.options.speed + 'ms ' + _.options.cssEase;
        } else {
            transition[_.transitionType] = 'opacity ' + _.options.speed + 'ms ' + _.options.cssEase;
        }

        if (_.options.fade === false) {
            _.$slideTrack.css(transition);
        } else {
            _.$slides.eq(slide).css(transition);
        }

    };

    Slick.prototype.autoPlay = function() {

        var _ = this;

        _.autoPlayClear();

        if ( _.slideCount > _.options.slidesToShow ) {
            _.autoPlayTimer = setInterval( _.autoPlayIterator, _.options.autoplaySpeed );
        }

    };

    Slick.prototype.autoPlayClear = function() {

        var _ = this;

        if (_.autoPlayTimer) {
            clearInterval(_.autoPlayTimer);
        }

    };

    Slick.prototype.autoPlayIterator = function() {

        var _ = this,
            slideTo = _.currentSlide + _.options.slidesToScroll;

        if ( !_.paused && !_.interrupted && !_.focussed ) {

            if ( _.options.infinite === false ) {

                if ( _.direction === 1 && ( _.currentSlide + 1 ) === ( _.slideCount - 1 )) {
                    _.direction = 0;
                }

                else if ( _.direction === 0 ) {

                    slideTo = _.currentSlide - _.options.slidesToScroll;

                    if ( _.currentSlide - 1 === 0 ) {
                        _.direction = 1;
                    }

                }

            }

            _.slideHandler( slideTo );

        }

    };

    Slick.prototype.buildArrows = function() {

        var _ = this;

        if (_.options.arrows === true ) {

            _.$prevArrow = $(_.options.prevArrow).addClass('slick-arrow');
            _.$nextArrow = $(_.options.nextArrow).addClass('slick-arrow');

            if( _.slideCount > _.options.slidesToShow ) {

                _.$prevArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');
                _.$nextArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');

                if (_.htmlExpr.test(_.options.prevArrow)) {
                    _.$prevArrow.prependTo(_.options.appendArrows);
                }

                if (_.htmlExpr.test(_.options.nextArrow)) {
                    _.$nextArrow.appendTo(_.options.appendArrows);
                }

                if (_.options.infinite !== true) {
                    _.$prevArrow
                        .addClass('slick-disabled')
                        .attr('aria-disabled', 'true');
                }

            } else {

                _.$prevArrow.add( _.$nextArrow )

                    .addClass('slick-hidden')
                    .attr({
                        'aria-disabled': 'true',
                        'tabindex': '-1'
                    });

            }

        }

    };

    Slick.prototype.buildDots = function() {

        var _ = this,
            i, dot;

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

            _.$slider.addClass('slick-dotted');

            dot = $('<ul />').addClass(_.options.dotsClass);

            for (i = 0; i <= _.getDotCount(); i += 1) {
                dot.append($('<li />').append(_.options.customPaging.call(this, _, i)));
            }

            _.$dots = dot.appendTo(_.options.appendDots);

            _.$dots.find('li').first().addClass('slick-active').attr('aria-hidden', 'false');

        }

    };

    Slick.prototype.buildOut = function() {

        var _ = this;

        _.$slides =
            _.$slider
                .children( _.options.slide + ':not(.slick-cloned)')
                .addClass('slick-slide');

        _.slideCount = _.$slides.length;

        _.$slides.each(function(index, element) {
            $(element)
                .attr('data-slick-index', index)
                .data('originalStyling', $(element).attr('style') || '');
        });

        _.$slider.addClass('slick-slider');

        _.$slideTrack = (_.slideCount === 0) ?
            $('<div class="slick-track"/>').appendTo(_.$slider) :
            _.$slides.wrapAll('<div class="slick-track"/>').parent();

        _.$list = _.$slideTrack.wrap(
            '<div aria-live="polite" class="slick-list"/>').parent();
        _.$slideTrack.css('opacity', 0);

        if (_.options.centerMode === true || _.options.swipeToSlide === true) {
            _.options.slidesToScroll = 1;
        }

        $('img[data-lazy]', _.$slider).not('[src]').addClass('slick-loading');

        _.setupInfinite();

        _.buildArrows();

        _.buildDots();

        _.updateDots();


        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);

        if (_.options.draggable === true) {
            _.$list.addClass('draggable');
        }

    };

    Slick.prototype.buildRows = function() {

        var _ = this, a, b, c, newSlides, numOfSlides, originalSlides,slidesPerSection;

        newSlides = document.createDocumentFragment();
        originalSlides = _.$slider.children();

        if(_.options.rows > 1) {

            slidesPerSection = _.options.slidesPerRow * _.options.rows;
            numOfSlides = Math.ceil(
                originalSlides.length / slidesPerSection
            );

            for(a = 0; a < numOfSlides; a++){
                var slide = document.createElement('div');
                for(b = 0; b < _.options.rows; b++) {
                    var row = document.createElement('div');
                    for(c = 0; c < _.options.slidesPerRow; c++) {
                        var target = (a * slidesPerSection + ((b * _.options.slidesPerRow) + c));
                        if (originalSlides.get(target)) {
                            row.appendChild(originalSlides.get(target));
                        }
                    }
                    slide.appendChild(row);
                }
                newSlides.appendChild(slide);
            }

            _.$slider.empty().append(newSlides);
            _.$slider.children().children().children()
                .css({
                    'width':(100 / _.options.slidesPerRow) + '%',
                    'display': 'inline-block'
                });

        }

    };

    Slick.prototype.checkResponsive = function(initial, forceUpdate) {

        var _ = this,
            breakpoint, targetBreakpoint, respondToWidth, triggerBreakpoint = false;
        var sliderWidth = _.$slider.width();
        var windowWidth = window.innerWidth || $(window).width();

        if (_.respondTo === 'window') {
            respondToWidth = windowWidth;
        } else if (_.respondTo === 'slider') {
            respondToWidth = sliderWidth;
        } else if (_.respondTo === 'min') {
            respondToWidth = Math.min(windowWidth, sliderWidth);
        }

        if ( _.options.responsive &&
            _.options.responsive.length &&
            _.options.responsive !== null) {

            targetBreakpoint = null;

            for (breakpoint in _.breakpoints) {
                if (_.breakpoints.hasOwnProperty(breakpoint)) {
                    if (_.originalSettings.mobileFirst === false) {
                        if (respondToWidth < _.breakpoints[breakpoint]) {
                            targetBreakpoint = _.breakpoints[breakpoint];
                        }
                    } else {
                        if (respondToWidth > _.breakpoints[breakpoint]) {
                            targetBreakpoint = _.breakpoints[breakpoint];
                        }
                    }
                }
            }

            if (targetBreakpoint !== null) {
                if (_.activeBreakpoint !== null) {
                    if (targetBreakpoint !== _.activeBreakpoint || forceUpdate) {
                        _.activeBreakpoint =
                            targetBreakpoint;
                        if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
                            _.unslick(targetBreakpoint);
                        } else {
                            _.options = $.extend({}, _.originalSettings,
                                _.breakpointSettings[
                                    targetBreakpoint]);
                            if (initial === true) {
                                _.currentSlide = _.options.initialSlide;
                            }
                            _.refresh(initial);
                        }
                        triggerBreakpoint = targetBreakpoint;
                    }
                } else {
                    _.activeBreakpoint = targetBreakpoint;
                    if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
                        _.unslick(targetBreakpoint);
                    } else {
                        _.options = $.extend({}, _.originalSettings,
                            _.breakpointSettings[
                                targetBreakpoint]);
                        if (initial === true) {
                            _.currentSlide = _.options.initialSlide;
                        }
                        _.refresh(initial);
                    }
                    triggerBreakpoint = targetBreakpoint;
                }
            } else {
                if (_.activeBreakpoint !== null) {
                    _.activeBreakpoint = null;
                    _.options = _.originalSettings;
                    if (initial === true) {
                        _.currentSlide = _.options.initialSlide;
                    }
                    _.refresh(initial);
                    triggerBreakpoint = targetBreakpoint;
                }
            }

            // only trigger breakpoints during an actual break. not on initialize.
            if( !initial && triggerBreakpoint !== false ) {
                _.$slider.trigger('breakpoint', [_, triggerBreakpoint]);
            }
        }

    };

    Slick.prototype.changeSlide = function(event, dontAnimate) {

        var _ = this,
            $target = $(event.currentTarget),
            indexOffset, slideOffset, unevenOffset;

        // If target is a link, prevent default action.
        if($target.is('a')) {
            event.preventDefault();
        }

        // If target is not the <li> element (ie: a child), find the <li>.
        if(!$target.is('li')) {
            $target = $target.closest('li');
        }

        unevenOffset = (_.slideCount % _.options.slidesToScroll !== 0);
        indexOffset = unevenOffset ? 0 : (_.slideCount - _.currentSlide) % _.options.slidesToScroll;

        switch (event.data.message) {

            case 'previous':
                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : _.options.slidesToShow - indexOffset;
                if (_.slideCount > _.options.slidesToShow) {
                    _.slideHandler(_.currentSlide - slideOffset, false, dontAnimate);
                }
                break;

            case 'next':
                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : indexOffset;
                if (_.slideCount > _.options.slidesToShow) {
                    _.slideHandler(_.currentSlide + slideOffset, false, dontAnimate);
                }
                break;

            case 'index':
                var index = event.data.index === 0 ? 0 :
                    event.data.index || $target.index() * _.options.slidesToScroll;

                _.slideHandler(_.checkNavigable(index), false, dontAnimate);
                $target.children().trigger('focus');
                break;

            default:
                return;
        }

    };

    Slick.prototype.checkNavigable = function(index) {

        var _ = this,
            navigables, prevNavigable;

        navigables = _.getNavigableIndexes();
        prevNavigable = 0;
        if (index > navigables[navigables.length - 1]) {
            index = navigables[navigables.length - 1];
        } else {
            for (var n in navigables) {
                if (index < navigables[n]) {
                    index = prevNavigable;
                    break;
                }
                prevNavigable = navigables[n];
            }
        }

        return index;
    };

    Slick.prototype.cleanUpEvents = function() {

        var _ = this;

        if (_.options.dots && _.$dots !== null) {

            $('li', _.$dots)
                .off('click.slick', _.changeSlide)
                .off('mouseenter.slick', $.proxy(_.interrupt, _, true))
                .off('mouseleave.slick', $.proxy(_.interrupt, _, false));

        }

        _.$slider.off('focus.slick blur.slick');

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow && _.$prevArrow.off('click.slick', _.changeSlide);
            _.$nextArrow && _.$nextArrow.off('click.slick', _.changeSlide);
        }

        _.$list.off('touchstart.slick mousedown.slick', _.swipeHandler);
        _.$list.off('touchmove.slick mousemove.slick', _.swipeHandler);
        _.$list.off('touchend.slick mouseup.slick', _.swipeHandler);
        _.$list.off('touchcancel.slick mouseleave.slick', _.swipeHandler);

        _.$list.off('click.slick', _.clickHandler);

        $(document).off(_.visibilityChange, _.visibility);

        _.cleanUpSlideEvents();

        if (_.options.accessibility === true) {
            _.$list.off('keydown.slick', _.keyHandler);
        }

        if (_.options.focusOnSelect === true) {
            $(_.$slideTrack).children().off('click.slick', _.selectHandler);
        }

        $(window).off('orientationchange.slick.slick-' + _.instanceUid, _.orientationChange);

        $(window).off('resize.slick.slick-' + _.instanceUid, _.resize);

        $('[draggable!=true]', _.$slideTrack).off('dragstart', _.preventDefault);

        $(window).off('load.slick.slick-' + _.instanceUid, _.setPosition);
        $(document).off('ready.slick.slick-' + _.instanceUid, _.setPosition);

    };

    Slick.prototype.cleanUpSlideEvents = function() {

        var _ = this;

        _.$list.off('mouseenter.slick', $.proxy(_.interrupt, _, true));
        _.$list.off('mouseleave.slick', $.proxy(_.interrupt, _, false));

    };

    Slick.prototype.cleanUpRows = function() {

        var _ = this, originalSlides;

        if(_.options.rows > 1) {
            originalSlides = _.$slides.children().children();
            originalSlides.removeAttr('style');
            _.$slider.empty().append(originalSlides);
        }

    };

    Slick.prototype.clickHandler = function(event) {

        var _ = this;

        if (_.shouldClick === false) {
            event.stopImmediatePropagation();
            event.stopPropagation();
            event.preventDefault();
        }

    };

    Slick.prototype.destroy = function(refresh) {

        var _ = this;

        _.autoPlayClear();

        _.touchObject = {};

        _.cleanUpEvents();

        $('.slick-cloned', _.$slider).detach();

        if (_.$dots) {
            _.$dots.remove();
        }


        if ( _.$prevArrow && _.$prevArrow.length ) {

            _.$prevArrow
                .removeClass('slick-disabled slick-arrow slick-hidden')
                .removeAttr('aria-hidden aria-disabled tabindex')
                .css('display','');

            if ( _.htmlExpr.test( _.options.prevArrow )) {
                _.$prevArrow.remove();
            }
        }

        if ( _.$nextArrow && _.$nextArrow.length ) {

            _.$nextArrow
                .removeClass('slick-disabled slick-arrow slick-hidden')
                .removeAttr('aria-hidden aria-disabled tabindex')
                .css('display','');

            if ( _.htmlExpr.test( _.options.nextArrow )) {
                _.$nextArrow.remove();
            }

        }


        if (_.$slides) {

            _.$slides
                .removeClass('slick-slide slick-active slick-center slick-visible slick-current')
                .removeAttr('aria-hidden')
                .removeAttr('data-slick-index')
                .each(function(){
                    $(this).attr('style', $(this).data('originalStyling'));
                });

            _.$slideTrack.children(this.options.slide).detach();

            _.$slideTrack.detach();

            _.$list.detach();

            _.$slider.append(_.$slides);
        }

        _.cleanUpRows();

        _.$slider.removeClass('slick-slider');
        _.$slider.removeClass('slick-initialized');
        _.$slider.removeClass('slick-dotted');

        _.unslicked = true;

        if(!refresh) {
            _.$slider.trigger('destroy', [_]);
        }

    };

    Slick.prototype.disableTransition = function(slide) {

        var _ = this,
            transition = {};

        transition[_.transitionType] = '';

        if (_.options.fade === false) {
            _.$slideTrack.css(transition);
        } else {
            _.$slides.eq(slide).css(transition);
        }

    };

    Slick.prototype.fadeSlide = function(slideIndex, callback) {

        var _ = this;

        if (_.cssTransitions === false) {

            _.$slides.eq(slideIndex).css({
                zIndex: _.options.zIndex
            });

            _.$slides.eq(slideIndex).animate({
                opacity: 1
            }, _.options.speed, _.options.easing, callback);

        } else {

            _.applyTransition(slideIndex);

            _.$slides.eq(slideIndex).css({
                opacity: 1,
                zIndex: _.options.zIndex
            });

            if (callback) {
                setTimeout(function() {

                    _.disableTransition(slideIndex);

                    callback.call();
                }, _.options.speed);
            }

        }

    };

    Slick.prototype.fadeSlideOut = function(slideIndex) {

        var _ = this;

        if (_.cssTransitions === false) {

            _.$slides.eq(slideIndex).animate({
                opacity: 0,
                zIndex: _.options.zIndex - 2
            }, _.options.speed, _.options.easing);

        } else {

            _.applyTransition(slideIndex);

            _.$slides.eq(slideIndex).css({
                opacity: 0,
                zIndex: _.options.zIndex - 2
            });

        }

    };

    Slick.prototype.filterSlides = Slick.prototype.slickFilter = function(filter) {

        var _ = this;

        if (filter !== null) {

            _.$slidesCache = _.$slides;

            _.unload();

            _.$slideTrack.children(this.options.slide).detach();

            _.$slidesCache.filter(filter).appendTo(_.$slideTrack);

            _.reinit();

        }

    };

    Slick.prototype.focusHandler = function() {

        var _ = this;

        _.$slider
            .off('focus.slick blur.slick')
            .on('focus.slick blur.slick',
                '*:not(.slick-arrow)', function(event) {

            event.stopImmediatePropagation();
            var $sf = $(this);

            setTimeout(function() {

                if( _.options.pauseOnFocus ) {
                    _.focussed = $sf.is(':focus');
                    _.autoPlay();
                }

            }, 0);

        });
    };

    Slick.prototype.getCurrent = Slick.prototype.slickCurrentSlide = function() {

        var _ = this;
        return _.currentSlide;

    };

    Slick.prototype.getDotCount = function() {

        var _ = this;

        var breakPoint = 0;
        var counter = 0;
        var pagerQty = 0;

        if (_.options.infinite === true) {
            while (breakPoint < _.slideCount) {
                ++pagerQty;
                breakPoint = counter + _.options.slidesToScroll;
                counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
            }
        } else if (_.options.centerMode === true) {
            pagerQty = _.slideCount;
        } else if(!_.options.asNavFor) {
            pagerQty = 1 + Math.ceil((_.slideCount - _.options.slidesToShow) / _.options.slidesToScroll);
        }else {
            while (breakPoint < _.slideCount) {
                ++pagerQty;
                breakPoint = counter + _.options.slidesToScroll;
                counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
            }
        }

        return pagerQty - 1;

    };

    Slick.prototype.getLeft = function(slideIndex) {

        var _ = this,
            targetLeft,
            verticalHeight,
            verticalOffset = 0,
            targetSlide;

        _.slideOffset = 0;
        verticalHeight = _.$slides.first().outerHeight(true);

        if (_.options.infinite === true) {
            if (_.slideCount > _.options.slidesToShow) {
                _.slideOffset = (_.slideWidth * _.options.slidesToShow) * -1;
                verticalOffset = (verticalHeight * _.options.slidesToShow) * -1;
            }
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                if (slideIndex + _.options.slidesToScroll > _.slideCount && _.slideCount > _.options.slidesToShow) {
                    if (slideIndex > _.slideCount) {
                        _.slideOffset = ((_.options.slidesToShow - (slideIndex - _.slideCount)) * _.slideWidth) * -1;
                        verticalOffset = ((_.options.slidesToShow - (slideIndex - _.slideCount)) * verticalHeight) * -1;
                    } else {
                        _.slideOffset = ((_.slideCount % _.options.slidesToScroll) * _.slideWidth) * -1;
                        verticalOffset = ((_.slideCount % _.options.slidesToScroll) * verticalHeight) * -1;
                    }
                }
            }
        } else {
            if (slideIndex + _.options.slidesToShow > _.slideCount) {
                _.slideOffset = ((slideIndex + _.options.slidesToShow) - _.slideCount) * _.slideWidth;
                verticalOffset = ((slideIndex + _.options.slidesToShow) - _.slideCount) * verticalHeight;
            }
        }

        if (_.slideCount <= _.options.slidesToShow) {
            _.slideOffset = 0;
            verticalOffset = 0;
        }

        if (_.options.centerMode === true && _.options.infinite === true) {
            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2) - _.slideWidth;
        } else if (_.options.centerMode === true) {
            _.slideOffset = 0;
            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2);
        }

        if (_.options.vertical === false) {
            targetLeft = ((slideIndex * _.slideWidth) * -1) + _.slideOffset;
        } else {
            targetLeft = ((slideIndex * verticalHeight) * -1) + verticalOffset;
        }

        if (_.options.variableWidth === true) {

            if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
                targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
            } else {
                targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow);
            }

            if (_.options.rtl === true) {
                if (targetSlide[0]) {
                    targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
                } else {
                    targetLeft =  0;
                }
            } else {
                targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
            }

            if (_.options.centerMode === true) {
                if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
                    targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
                } else {
                    targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow + 1);
                }

                if (_.options.rtl === true) {
                    if (targetSlide[0]) {
                        targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
                    } else {
                        targetLeft =  0;
                    }
                } else {
                    targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
                }

                targetLeft += (_.$list.width() - targetSlide.outerWidth()) / 2;
            }
        }

        return targetLeft;

    };

    Slick.prototype.getOption = Slick.prototype.slickGetOption = function(option) {

        var _ = this;

        return _.options[option];

    };

    Slick.prototype.getNavigableIndexes = function() {

        var _ = this,
            breakPoint = 0,
            counter = 0,
            indexes = [],
            max;

        if (_.options.infinite === false) {
            max = _.slideCount;
        } else {
            breakPoint = _.options.slidesToScroll * -1;
            counter = _.options.slidesToScroll * -1;
            max = _.slideCount * 2;
        }

        while (breakPoint < max) {
            indexes.push(breakPoint);
            breakPoint = counter + _.options.slidesToScroll;
            counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
        }

        return indexes;

    };

    Slick.prototype.getSlick = function() {

        return this;

    };

    Slick.prototype.getSlideCount = function() {

        var _ = this,
            slidesTraversed, swipedSlide, centerOffset;

        centerOffset = _.options.centerMode === true ? _.slideWidth * Math.floor(_.options.slidesToShow / 2) : 0;

        if (_.options.swipeToSlide === true) {
            _.$slideTrack.find('.slick-slide').each(function(index, slide) {
                if (slide.offsetLeft - centerOffset + ($(slide).outerWidth() / 2) > (_.swipeLeft * -1)) {
                    swipedSlide = slide;
                    return false;
                }
            });

            slidesTraversed = Math.abs($(swipedSlide).attr('data-slick-index') - _.currentSlide) || 1;

            return slidesTraversed;

        } else {
            return _.options.slidesToScroll;
        }

    };

    Slick.prototype.goTo = Slick.prototype.slickGoTo = function(slide, dontAnimate) {

        var _ = this;

        _.changeSlide({
            data: {
                message: 'index',
                index: parseInt(slide)
            }
        }, dontAnimate);

    };

    Slick.prototype.init = function(creation) {

        var _ = this;

        if (!$(_.$slider).hasClass('slick-initialized')) {

            $(_.$slider).addClass('slick-initialized');

            _.buildRows();
            _.buildOut();
            _.setProps();
            _.startLoad();
            _.loadSlider();
            _.initializeEvents();
            _.updateArrows();
            _.updateDots();
            _.checkResponsive(true);
            _.focusHandler();

        }

        if (creation) {
            _.$slider.trigger('init', [_]);
        }

        if (_.options.accessibility === true) {
            _.initADA();
        }

        if ( _.options.autoplay ) {

            _.paused = false;
            _.autoPlay();

        }

    };

    Slick.prototype.initADA = function() {
        var _ = this;
        _.$slides.add(_.$slideTrack.find('.slick-cloned')).attr({
            'aria-hidden': 'true',
            'tabindex': '-1'
        }).find('a, input, button, select').attr({
            'tabindex': '-1'
        });

        // _.$slideTrack.attr('role', 'listbox');

        _.$slides.not(_.$slideTrack.find('.slick-cloned')).each(function(i) {
            $(this).attr({
                'id': 'tabpanel-'  + i + '',
                'aria-labelledby': 'tab-topic-' + i + ''
            });
        });

        if (_.$dots !== null) {
            _.$dots.attr('role', 'tablist').find('li').each(function(i) {
                $(this).attr({
                    'role': 'presentation',
                    'aria-selected': 'false',
                    'aria-controls': 'navigation' + _.instanceUid + i + '',
                    'id': 'slick-slide' + _.instanceUid + i + ''
                });
            })
                .first().attr('aria-selected', 'true').end()
                .find('button').attr('role', 'button').end()
                .closest('div').attr('role', 'toolbar');
        }
        _.activateADA();

    };

    Slick.prototype.initArrowEvents = function() {

        var _ = this;

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow
               .off('click.slick')
               .on('click.slick', {
                    message: 'previous'
               }, _.changeSlide);
            _.$nextArrow
               .off('click.slick')
               .on('click.slick', {
                    message: 'next'
               }, _.changeSlide);
        }

    };

    Slick.prototype.initDotEvents = function() {

        var _ = this;

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
            $('li', _.$dots).on('click.slick', {
                message: 'index'
            }, _.changeSlide);
        }

        if ( _.options.dots === true && _.options.pauseOnDotsHover === true ) {

            $('li', _.$dots)
                .on('mouseenter.slick', $.proxy(_.interrupt, _, true))
                .on('mouseleave.slick', $.proxy(_.interrupt, _, false));

        }

    };

    Slick.prototype.initSlideEvents = function() {

        var _ = this;

        if ( _.options.pauseOnHover ) {

            _.$list.on('mouseenter.slick', $.proxy(_.interrupt, _, true));
            _.$list.on('mouseleave.slick', $.proxy(_.interrupt, _, false));

        }

    };

    Slick.prototype.initializeEvents = function() {

        var _ = this;

        _.initArrowEvents();

        _.initDotEvents();
        _.initSlideEvents();

        _.$list.on('touchstart.slick mousedown.slick', {
            action: 'start'
        }, _.swipeHandler);
        _.$list.on('touchmove.slick mousemove.slick', {
            action: 'move'
        }, _.swipeHandler);
        _.$list.on('touchend.slick mouseup.slick', {
            action: 'end'
        }, _.swipeHandler);
        _.$list.on('touchcancel.slick mouseleave.slick', {
            action: 'end'
        }, _.swipeHandler);

        _.$list.on('click.slick', _.clickHandler);

        $(document).on(_.visibilityChange, $.proxy(_.visibility, _));

        if (_.options.accessibility === true) {
            _.$list.on('keydown.slick', _.keyHandler);
        }

        if (_.options.focusOnSelect === true) {
            $(_.$slideTrack).children().on('click.slick', _.selectHandler);
        }

        $(window).on('orientationchange.slick.slick-' + _.instanceUid, $.proxy(_.orientationChange, _));

        $(window).on('resize.slick.slick-' + _.instanceUid, $.proxy(_.resize, _));

        $('[draggable!=true]', _.$slideTrack).on('dragstart', _.preventDefault);

        $(window).on('load.slick.slick-' + _.instanceUid, _.setPosition);
        $(document).on('ready.slick.slick-' + _.instanceUid, _.setPosition);

    };

    Slick.prototype.initUI = function() {

        var _ = this;

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {

            _.$prevArrow.show();
            _.$nextArrow.show();

        }

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

            _.$dots.show();

        }

    };

    Slick.prototype.keyHandler = function(event) {

        var _ = this;
         //Dont slide if the cursor is inside the form fields and arrow keys are pressed
        if(!event.target.tagName.match('TEXTAREA|INPUT|SELECT')) {
            if (event.keyCode === 37 && _.options.accessibility === true) {
                _.changeSlide({
                    data: {
                        message: _.options.rtl === true ? 'next' :  'previous'
                    }
                });
            } else if (event.keyCode === 39 && _.options.accessibility === true) {
                _.changeSlide({
                    data: {
                        message: _.options.rtl === true ? 'previous' : 'next'
                    }
                });
            }
        }

    };

    Slick.prototype.lazyLoad = function() {

        var _ = this,
            loadRange, cloneRange, rangeStart, rangeEnd;

        function loadImages(imagesScope) {

            $('img[data-lazy]', imagesScope).each(function() {

                var image = $(this),
                    imageSource = $(this).attr('data-lazy'),
                    imageToLoad = document.createElement('img');

                imageToLoad.onload = function() {

                    image
                        .animate({ opacity: 0 }, 100, function() {
                            image
                                .attr('src', imageSource)
                                .animate({ opacity: 1 }, 200, function() {
                                    image
                                        .removeAttr('data-lazy')
                                        .removeClass('slick-loading');
                                });
                            _.$slider.trigger('lazyLoaded', [_, image, imageSource]);
                        });

                };

                imageToLoad.onerror = function() {

                    image
                        .removeAttr( 'data-lazy' )
                        .removeClass( 'slick-loading' )
                        .addClass( 'slick-lazyload-error' );

                    _.$slider.trigger('lazyLoadError', [ _, image, imageSource ]);

                };

                imageToLoad.src = imageSource;

            });

        }

        if (_.options.centerMode === true) {
            if (_.options.infinite === true) {
                rangeStart = _.currentSlide + (_.options.slidesToShow / 2 + 1);
                rangeEnd = rangeStart + _.options.slidesToShow + 2;
            } else {
                rangeStart = Math.max(0, _.currentSlide - (_.options.slidesToShow / 2 + 1));
                rangeEnd = 2 + (_.options.slidesToShow / 2 + 1) + _.currentSlide;
            }
        } else {
            rangeStart = _.options.infinite ? _.options.slidesToShow + _.currentSlide : _.currentSlide;
            rangeEnd = Math.ceil(rangeStart + _.options.slidesToShow);
            if (_.options.fade === true) {
                if (rangeStart > 0) rangeStart--;
                if (rangeEnd <= _.slideCount) rangeEnd++;
            }
        }

        loadRange = _.$slider.find('.slick-slide').slice(rangeStart, rangeEnd);
        loadImages(loadRange);

        if (_.slideCount <= _.options.slidesToShow) {
            cloneRange = _.$slider.find('.slick-slide');
            loadImages(cloneRange);
        } else
        if (_.currentSlide >= _.slideCount - _.options.slidesToShow) {
            cloneRange = _.$slider.find('.slick-cloned').slice(0, _.options.slidesToShow);
            loadImages(cloneRange);
        } else if (_.currentSlide === 0) {
            cloneRange = _.$slider.find('.slick-cloned').slice(_.options.slidesToShow * -1);
            loadImages(cloneRange);
        }

    };

    Slick.prototype.loadSlider = function() {

        var _ = this;

        _.setPosition();

        _.$slideTrack.css({
            opacity: 1
        });

        _.$slider.removeClass('slick-loading');

        _.initUI();

        if (_.options.lazyLoad === 'progressive') {
            _.progressiveLazyLoad();
        }

    };

    Slick.prototype.next = Slick.prototype.slickNext = function() {

        var _ = this;

        _.changeSlide({
            data: {
                message: 'next'
            }
        });

    };

    Slick.prototype.orientationChange = function() {

        var _ = this;

        _.checkResponsive();
        _.setPosition();

    };

    Slick.prototype.pause = Slick.prototype.slickPause = function() {

        var _ = this;

        _.autoPlayClear();
        _.paused = true;

    };

    Slick.prototype.play = Slick.prototype.slickPlay = function() {

        var _ = this;

        _.autoPlay();
        _.options.autoplay = true;
        _.paused = false;
        _.focussed = false;
        _.interrupted = false;

    };

    Slick.prototype.postSlide = function(index) {

        var _ = this;

        if( !_.unslicked ) {

            _.$slider.trigger('afterChange', [_, index]);

            _.animating = false;

            _.setPosition();

            _.swipeLeft = null;

            if ( _.options.autoplay ) {
                _.autoPlay();
            }

            if (_.options.accessibility === true) {
                _.initADA();
            }

        }

    };

    Slick.prototype.prev = Slick.prototype.slickPrev = function() {

        var _ = this;

        _.changeSlide({
            data: {
                message: 'previous'
            }
        });

    };

    Slick.prototype.preventDefault = function(event) {

        event.preventDefault();

    };

    Slick.prototype.progressiveLazyLoad = function( tryCount ) {

        tryCount = tryCount || 1;

        var _ = this,
            $imgsToLoad = $( 'img[data-lazy]', _.$slider ),
            image,
            imageSource,
            imageToLoad;

        if ( $imgsToLoad.length ) {

            image = $imgsToLoad.first();
            imageSource = image.attr('data-lazy');
            imageToLoad = document.createElement('img');

            imageToLoad.onload = function() {

                image
                    .attr( 'src', imageSource )
                    .removeAttr('data-lazy')
                    .removeClass('slick-loading');

                if ( _.options.adaptiveHeight === true ) {
                    _.setPosition();
                }

                _.$slider.trigger('lazyLoaded', [ _, image, imageSource ]);
                _.progressiveLazyLoad();

            };

            imageToLoad.onerror = function() {

                if ( tryCount < 3 ) {

                    /**
                     * try to load the image 3 times,
                     * leave a slight delay so we don't get
                     * servers blocking the request.
                     */
                    setTimeout( function() {
                        _.progressiveLazyLoad( tryCount + 1 );
                    }, 500 );

                } else {

                    image
                        .removeAttr( 'data-lazy' )
                        .removeClass( 'slick-loading' )
                        .addClass( 'slick-lazyload-error' );

                    _.$slider.trigger('lazyLoadError', [ _, image, imageSource ]);

                    _.progressiveLazyLoad();

                }

            };

            imageToLoad.src = imageSource;

        } else {

            _.$slider.trigger('allImagesLoaded', [ _ ]);

        }

    };

    Slick.prototype.refresh = function( initializing ) {

        var _ = this, currentSlide, lastVisibleIndex;

        lastVisibleIndex = _.slideCount - _.options.slidesToShow;

        // in non-infinite sliders, we don't want to go past the
        // last visible index.
        if( !_.options.infinite && ( _.currentSlide > lastVisibleIndex )) {
            _.currentSlide = lastVisibleIndex;
        }

        // if less slides than to show, go to start.
        if ( _.slideCount <= _.options.slidesToShow ) {
            _.currentSlide = 0;

        }

        currentSlide = _.currentSlide;

        _.destroy(true);

        $.extend(_, _.initials, { currentSlide: currentSlide });

        _.init();

        if( !initializing ) {

            _.changeSlide({
                data: {
                    message: 'index',
                    index: currentSlide
                }
            }, false);

        }

    };

    Slick.prototype.registerBreakpoints = function() {

        var _ = this, breakpoint, currentBreakpoint, l,
            responsiveSettings = _.options.responsive || null;

        if ( $.type(responsiveSettings) === 'array' && responsiveSettings.length ) {

            _.respondTo = _.options.respondTo || 'window';

            for ( breakpoint in responsiveSettings ) {

                l = _.breakpoints.length-1;
                currentBreakpoint = responsiveSettings[breakpoint].breakpoint;

                if (responsiveSettings.hasOwnProperty(breakpoint)) {

                    // loop through the breakpoints and cut out any existing
                    // ones with the same breakpoint number, we don't want dupes.
                    while( l >= 0 ) {
                        if( _.breakpoints[l] && _.breakpoints[l] === currentBreakpoint ) {
                            _.breakpoints.splice(l,1);
                        }
                        l--;
                    }

                    _.breakpoints.push(currentBreakpoint);
                    _.breakpointSettings[currentBreakpoint] = responsiveSettings[breakpoint].settings;

                }

            }

            _.breakpoints.sort(function(a, b) {
                return ( _.options.mobileFirst ) ? a-b : b-a;
            });

        }

    };

    Slick.prototype.reinit = function() {

        var _ = this;

        _.$slides =
            _.$slideTrack
                .children(_.options.slide)
                .addClass('slick-slide');

        _.slideCount = _.$slides.length;

        if (_.currentSlide >= _.slideCount && _.currentSlide !== 0) {
            _.currentSlide = _.currentSlide - _.options.slidesToScroll;
        }

        if (_.slideCount <= _.options.slidesToShow) {
            _.currentSlide = 0;
        }

        _.registerBreakpoints();

        _.setProps();
        _.setupInfinite();
        _.buildArrows();
        _.updateArrows();
        _.initArrowEvents();
        _.buildDots();
        _.updateDots();
        _.initDotEvents();
        _.cleanUpSlideEvents();
        _.initSlideEvents();

        _.checkResponsive(false, true);

        if (_.options.focusOnSelect === true) {
            $(_.$slideTrack).children().on('click.slick', _.selectHandler);
        }

        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);

        _.setPosition();
        _.focusHandler();

        _.paused = !_.options.autoplay;
        _.autoPlay();

        _.$slider.trigger('reInit', [_]);

    };

    Slick.prototype.resize = function() {

        var _ = this;

        if ($(window).width() !== _.windowWidth) {
            clearTimeout(_.windowDelay);
            _.windowDelay = window.setTimeout(function() {
                _.windowWidth = $(window).width();
                _.checkResponsive();
                if( !_.unslicked ) { _.setPosition(); }
            }, 50);
        }
    };

    Slick.prototype.removeSlide = Slick.prototype.slickRemove = function(index, removeBefore, removeAll) {

        var _ = this;

        if (typeof(index) === 'boolean') {
            removeBefore = index;
            index = removeBefore === true ? 0 : _.slideCount - 1;
        } else {
            index = removeBefore === true ? --index : index;
        }

        if (_.slideCount < 1 || index < 0 || index > _.slideCount - 1) {
            return false;
        }

        _.unload();

        if (removeAll === true) {
            _.$slideTrack.children().remove();
        } else {
            _.$slideTrack.children(this.options.slide).eq(index).remove();
        }

        _.$slides = _.$slideTrack.children(this.options.slide);

        _.$slideTrack.children(this.options.slide).detach();

        _.$slideTrack.append(_.$slides);

        _.$slidesCache = _.$slides;

        _.reinit();

    };

    Slick.prototype.setCSS = function(position) {

        var _ = this,
            positionProps = {},
            x, y;

        if (_.options.rtl === true) {
            position = -position;
        }
        x = _.positionProp == 'left' ? Math.ceil(position) + 'px' : '0px';
        y = _.positionProp == 'top' ? Math.ceil(position) + 'px' : '0px';

        positionProps[_.positionProp] = position;

        if (_.transformsEnabled === false) {
            _.$slideTrack.css(positionProps);
        } else {
            positionProps = {};
            if (_.cssTransitions === false) {
                positionProps[_.animType] = 'translate(' + x + ', ' + y + ')';
                _.$slideTrack.css(positionProps);
            } else {
                positionProps[_.animType] = 'translate3d(' + x + ', ' + y + ', 0px)';
                _.$slideTrack.css(positionProps);
            }
        }

    };

    Slick.prototype.setDimensions = function() {

        var _ = this;

        if (_.options.vertical === false) {
            if (_.options.centerMode === true) {
                _.$list.css({
                    padding: ('0px ' + _.options.centerPadding)
                });
            }
        } else {
            _.$list.height(_.$slides.first().outerHeight(true) * _.options.slidesToShow);
            if (_.options.centerMode === true) {
                _.$list.css({
                    padding: (_.options.centerPadding + ' 0px')
                });
            }
        }

        _.listWidth = _.$list.width();
        _.listHeight = _.$list.height();


        if (_.options.vertical === false && _.options.variableWidth === false) {
            _.slideWidth = Math.ceil(_.listWidth / _.options.slidesToShow);
            _.$slideTrack.width(Math.ceil((_.slideWidth * _.$slideTrack.children('.slick-slide').length)));

        } else if (_.options.variableWidth === true) {
            _.$slideTrack.width(5000 * _.slideCount);
        } else {
            _.slideWidth = Math.ceil(_.listWidth);
            _.$slideTrack.height(Math.ceil((_.$slides.first().outerHeight(true) * _.$slideTrack.children('.slick-slide').length)));
        }

        var offset = _.$slides.first().outerWidth(true) - _.$slides.first().width();
        if (_.options.variableWidth === false) _.$slideTrack.children('.slick-slide').width(_.slideWidth - offset);

    };

    Slick.prototype.setFade = function() {

        var _ = this,
            targetLeft;

        _.$slides.each(function(index, element) {
            targetLeft = (_.slideWidth * index) * -1;
            if (_.options.rtl === true) {
                $(element).css({
                    position: 'relative',
                    right: targetLeft,
                    top: 0,
                    zIndex: _.options.zIndex - 2,
                    opacity: 0
                });
            } else {
                $(element).css({
                    position: 'relative',
                    left: targetLeft,
                    top: 0,
                    zIndex: _.options.zIndex - 2,
                    opacity: 0
                });
            }
        });

        _.$slides.eq(_.currentSlide).css({
            zIndex: _.options.zIndex - 1,
            opacity: 1
        });

    };

    Slick.prototype.setHeight = function() {

        var _ = this;

        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
            _.$list.css('height', targetHeight);
        }

    };

    Slick.prototype.setOption =
    Slick.prototype.slickSetOption = function() {

        /**
         * accepts arguments in format of:
         *
         *  - for changing a single option's value:
         *     .slick("setOption", option, value, refresh )
         *
         *  - for changing a set of responsive options:
         *     .slick("setOption", 'responsive', [{}, ...], refresh )
         *
         *  - for updating multiple values at once (not responsive)
         *     .slick("setOption", { 'option': value, ... }, refresh )
         */

        var _ = this, l, item, option, value, refresh = false, type;

        if( $.type( arguments[0] ) === 'object' ) {

            option =  arguments[0];
            refresh = arguments[1];
            type = 'multiple';

        } else if ( $.type( arguments[0] ) === 'string' ) {

            option =  arguments[0];
            value = arguments[1];
            refresh = arguments[2];

            if ( arguments[0] === 'responsive' && $.type( arguments[1] ) === 'array' ) {

                type = 'responsive';

            } else if ( typeof arguments[1] !== 'undefined' ) {

                type = 'single';

            }

        }

        if ( type === 'single' ) {

            _.options[option] = value;


        } else if ( type === 'multiple' ) {

            $.each( option , function( opt, val ) {

                _.options[opt] = val;

            });


        } else if ( type === 'responsive' ) {

            for ( item in value ) {

                if( $.type( _.options.responsive ) !== 'array' ) {

                    _.options.responsive = [ value[item] ];

                } else {

                    l = _.options.responsive.length-1;

                    // loop through the responsive object and splice out duplicates.
                    while( l >= 0 ) {

                        if( _.options.responsive[l].breakpoint === value[item].breakpoint ) {

                            _.options.responsive.splice(l,1);

                        }

                        l--;

                    }

                    _.options.responsive.push( value[item] );

                }

            }

        }

        if ( refresh ) {

            _.unload();
            _.reinit();

        }

    };

    Slick.prototype.setPosition = function() {

        var _ = this;

        _.setDimensions();

        _.setHeight();

        if (_.options.fade === false) {
            _.setCSS(_.getLeft(_.currentSlide));
        } else {
            _.setFade();
        }

        _.$slider.trigger('setPosition', [_]);

    };

    Slick.prototype.setProps = function() {

        var _ = this,
            bodyStyle = document.body.style;

        _.positionProp = _.options.vertical === true ? 'top' : 'left';

        if (_.positionProp === 'top') {
            _.$slider.addClass('slick-vertical');
        } else {
            _.$slider.removeClass('slick-vertical');
        }

        if (bodyStyle.WebkitTransition !== undefined ||
            bodyStyle.MozTransition !== undefined ||
            bodyStyle.msTransition !== undefined) {
            if (_.options.useCSS === true) {
                _.cssTransitions = true;
            }
        }

        if ( _.options.fade ) {
            if ( typeof _.options.zIndex === 'number' ) {
                if( _.options.zIndex < 3 ) {
                    _.options.zIndex = 3;
                }
            } else {
                _.options.zIndex = _.defaults.zIndex;
            }
        }

        if (bodyStyle.OTransform !== undefined) {
            _.animType = 'OTransform';
            _.transformType = '-o-transform';
            _.transitionType = 'OTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.MozTransform !== undefined) {
            _.animType = 'MozTransform';
            _.transformType = '-moz-transform';
            _.transitionType = 'MozTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.MozPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.webkitTransform !== undefined) {
            _.animType = 'webkitTransform';
            _.transformType = '-webkit-transform';
            _.transitionType = 'webkitTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.msTransform !== undefined) {
            _.animType = 'msTransform';
            _.transformType = '-ms-transform';
            _.transitionType = 'msTransition';
            if (bodyStyle.msTransform === undefined) _.animType = false;
        }
        if (bodyStyle.transform !== undefined && _.animType !== false) {
            _.animType = 'transform';
            _.transformType = 'transform';
            _.transitionType = 'transition';
        }
        _.transformsEnabled = _.options.useTransform && (_.animType !== null && _.animType !== false);
    };


    Slick.prototype.setSlideClasses = function(index) {

        var _ = this,
            centerOffset, allSlides, indexOffset, remainder;

        allSlides = _.$slider
            .find('.slick-slide')
            .removeClass('slick-active slick-center slick-current')
            .attr('aria-hidden', 'true');

        _.$slides
            .eq(index)
            .addClass('slick-current');

        if (_.options.centerMode === true) {

            centerOffset = Math.floor(_.options.slidesToShow / 2);

            if (_.options.infinite === true) {

                if (index >= centerOffset && index <= (_.slideCount - 1) - centerOffset) {

                    _.$slides
                        .slice(index - centerOffset, index + centerOffset + 1)
                        .addClass('slick-active')
                        .attr('aria-hidden', 'false');

                } else {

                    indexOffset = _.options.slidesToShow + index;
                    allSlides
                        .slice(indexOffset - centerOffset + 1, indexOffset + centerOffset + 2)
                        .addClass('slick-active')
                        .attr('aria-hidden', 'false');

                }

                if (index === 0) {

                    allSlides
                        .eq(allSlides.length - 1 - _.options.slidesToShow)
                        .addClass('slick-center');

                } else if (index === _.slideCount - 1) {

                    allSlides
                        .eq(_.options.slidesToShow)
                        .addClass('slick-center');

                }

            }

            _.$slides
                .eq(index)
                .addClass('slick-center');

        } else {

            if (index >= 0 && index <= (_.slideCount - _.options.slidesToShow)) {

                _.$slides
                    .slice(index, index + _.options.slidesToShow)
                    .addClass('slick-active')
                    .attr('aria-hidden', 'false');

            } else if (allSlides.length <= _.options.slidesToShow) {

                allSlides
                    .addClass('slick-active')
                    .attr('aria-hidden', 'false');

            } else {

                remainder = _.slideCount % _.options.slidesToShow;
                indexOffset = _.options.infinite === true ? _.options.slidesToShow + index : index;

                if (_.options.slidesToShow == _.options.slidesToScroll && (_.slideCount - index) < _.options.slidesToShow) {

                    allSlides
                        .slice(indexOffset - (_.options.slidesToShow - remainder), indexOffset + remainder)
                        .addClass('slick-active')
                        .attr('aria-hidden', 'false');

                } else {

                    allSlides
                        .slice(indexOffset, indexOffset + _.options.slidesToShow)
                        .addClass('slick-active')
                        .attr('aria-hidden', 'false');

                }

            }

        }

        if (_.options.lazyLoad === 'ondemand') {
            _.lazyLoad();
        }

    };

    Slick.prototype.setupInfinite = function() {

        var _ = this,
            i, slideIndex, infiniteCount;

        if (_.options.fade === true) {
            _.options.centerMode = false;
        }

        if (_.options.infinite === true && _.options.fade === false) {

            slideIndex = null;

            if (_.slideCount > _.options.slidesToShow) {

                if (_.options.centerMode === true) {
                    infiniteCount = _.options.slidesToShow + 1;
                } else {
                    infiniteCount = _.options.slidesToShow;
                }

                for (i = _.slideCount; i > (_.slideCount -
                        infiniteCount); i -= 1) {
                    slideIndex = i - 1;
                    $(_.$slides[slideIndex]).clone(true).attr('id', '')
                        .attr('data-slick-index', slideIndex - _.slideCount)
                        .prependTo(_.$slideTrack).addClass('slick-cloned');
                }
                for (i = 0; i < infiniteCount; i += 1) {
                    slideIndex = i;
                    $(_.$slides[slideIndex]).clone(true).attr('id', '')
                        .attr('data-slick-index', slideIndex + _.slideCount)
                        .appendTo(_.$slideTrack).addClass('slick-cloned');
                }
                _.$slideTrack.find('.slick-cloned').find('[id]').each(function() {
                    $(this).attr('id', '');
                });

            }

        }

    };

    Slick.prototype.interrupt = function( toggle ) {

        var _ = this;

        if( !toggle ) {
            _.autoPlay();
        }
        _.interrupted = toggle;

    };

    Slick.prototype.selectHandler = function(event) {

        var _ = this;

        var targetElement =
            $(event.target).is('.slick-slide') ?
                $(event.target) :
                $(event.target).parents('.slick-slide');

        var index = parseInt(targetElement.attr('data-slick-index'));

        if (!index) index = 0;

        if (_.slideCount <= _.options.slidesToShow) {

            _.setSlideClasses(index);
            _.asNavFor(index);
            return;

        }

        _.slideHandler(index);

    };

    Slick.prototype.slideHandler = function(index, sync, dontAnimate) {

        var targetSlide, animSlide, oldSlide, slideLeft, targetLeft = null,
            _ = this, navTarget;

        sync = sync || false;

        if (_.animating === true && _.options.waitForAnimate === true) {
            return;
        }

        if (_.options.fade === true && _.currentSlide === index) {
            return;
        }

        if (_.slideCount <= _.options.slidesToShow) {
            return;
        }

        if (sync === false) {
            _.asNavFor(index);
        }

        targetSlide = index;
        targetLeft = _.getLeft(targetSlide);
        slideLeft = _.getLeft(_.currentSlide);

        _.currentLeft = _.swipeLeft === null ? slideLeft : _.swipeLeft;

        if (_.options.infinite === false && _.options.centerMode === false && (index < 0 || index > _.getDotCount() * _.options.slidesToScroll)) {
            if (_.options.fade === false) {
                targetSlide = _.currentSlide;
                if (dontAnimate !== true) {
                    _.animateSlide(slideLeft, function() {
                        _.postSlide(targetSlide);
                    });
                } else {
                    _.postSlide(targetSlide);
                }
            }
            return;
        } else if (_.options.infinite === false && _.options.centerMode === true && (index < 0 || index > (_.slideCount - _.options.slidesToScroll))) {
            if (_.options.fade === false) {
                targetSlide = _.currentSlide;
                if (dontAnimate !== true) {
                    _.animateSlide(slideLeft, function() {
                        _.postSlide(targetSlide);
                    });
                } else {
                    _.postSlide(targetSlide);
                }
            }
            return;
        }

        if ( _.options.autoplay ) {
            clearInterval(_.autoPlayTimer);
        }

        if (targetSlide < 0) {
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                animSlide = _.slideCount - (_.slideCount % _.options.slidesToScroll);
            } else {
                animSlide = _.slideCount + targetSlide;
            }
        } else if (targetSlide >= _.slideCount) {
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                animSlide = 0;
            } else {
                animSlide = targetSlide - _.slideCount;
            }
        } else {
            animSlide = targetSlide;
        }

        _.animating = true;

        _.$slider.trigger('beforeChange', [_, _.currentSlide, animSlide]);

        oldSlide = _.currentSlide;
        _.currentSlide = animSlide;

        _.setSlideClasses(_.currentSlide);

        if ( _.options.asNavFor ) {

            navTarget = _.getNavTarget();
            navTarget = navTarget.slick('getSlick');

            if ( navTarget.slideCount <= navTarget.options.slidesToShow ) {
                navTarget.setSlideClasses(_.currentSlide);
            }

        }

        _.updateDots();
        _.updateArrows();

        if (_.options.fade === true) {
            if (dontAnimate !== true) {

                _.fadeSlideOut(oldSlide);

                _.fadeSlide(animSlide, function() {
                    _.postSlide(animSlide);
                });

            } else {
                _.postSlide(animSlide);
            }
            _.animateHeight();
            return;
        }

        if (dontAnimate !== true) {
            _.animateSlide(targetLeft, function() {
                _.postSlide(animSlide);
            });
        } else {
            _.postSlide(animSlide);
        }

    };

    Slick.prototype.startLoad = function() {

        var _ = this;

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {

            _.$prevArrow.hide();
            _.$nextArrow.hide();

        }

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

            _.$dots.hide();

        }

        _.$slider.addClass('slick-loading');

    };

    Slick.prototype.swipeDirection = function() {

        var xDist, yDist, r, swipeAngle, _ = this;

        xDist = _.touchObject.startX - _.touchObject.curX;
        yDist = _.touchObject.startY - _.touchObject.curY;
        r = Math.atan2(yDist, xDist);

        swipeAngle = Math.round(r * 180 / Math.PI);
        if (swipeAngle < 0) {
            swipeAngle = 360 - Math.abs(swipeAngle);
        }

        if ((swipeAngle <= 45) && (swipeAngle >= 0)) {
            return (_.options.rtl === false ? 'left' : 'right');
        }
        if ((swipeAngle <= 360) && (swipeAngle >= 315)) {
            return (_.options.rtl === false ? 'left' : 'right');
        }
        if ((swipeAngle >= 135) && (swipeAngle <= 225)) {
            return (_.options.rtl === false ? 'right' : 'left');
        }
        if (_.options.verticalSwiping === true) {
            if ((swipeAngle >= 35) && (swipeAngle <= 135)) {
                return 'down';
            } else {
                return 'up';
            }
        }

        return 'vertical';

    };

    Slick.prototype.swipeEnd = function(event) {

        var _ = this,
            slideCount,
            direction;

        _.dragging = false;
        _.interrupted = false;
        _.shouldClick = ( _.touchObject.swipeLength > 10 ) ? false : true;

        if ( _.touchObject.curX === undefined ) {
            return false;
        }

        if ( _.touchObject.edgeHit === true ) {
            _.$slider.trigger('edge', [_, _.swipeDirection() ]);
        }

        if ( _.touchObject.swipeLength >= _.touchObject.minSwipe ) {

            direction = _.swipeDirection();

            switch ( direction ) {

                case 'left':
                case 'down':

                    slideCount =
                        _.options.swipeToSlide ?
                            _.checkNavigable( _.currentSlide + _.getSlideCount() ) :
                            _.currentSlide + _.getSlideCount();

                    _.currentDirection = 0;

                    break;

                case 'right':
                case 'up':

                    slideCount =
                        _.options.swipeToSlide ?
                            _.checkNavigable( _.currentSlide - _.getSlideCount() ) :
                            _.currentSlide - _.getSlideCount();

                    _.currentDirection = 1;

                    break;

                default:


            }

            if( direction != 'vertical' ) {

                _.slideHandler( slideCount );
                _.touchObject = {};
                _.$slider.trigger('swipe', [_, direction ]);

            }

        } else {

            if ( _.touchObject.startX !== _.touchObject.curX ) {

                _.slideHandler( _.currentSlide );
                _.touchObject = {};

            }

        }

    };

    Slick.prototype.swipeHandler = function(event) {

        var _ = this;

        if ((_.options.swipe === false) || ('ontouchend' in document && _.options.swipe === false)) {
            return;
        } else if (_.options.draggable === false && event.type.indexOf('mouse') !== -1) {
            return;
        }

        _.touchObject.fingerCount = event.originalEvent && event.originalEvent.touches !== undefined ?
            event.originalEvent.touches.length : 1;

        _.touchObject.minSwipe = _.listWidth / _.options
            .touchThreshold;

        if (_.options.verticalSwiping === true) {
            _.touchObject.minSwipe = _.listHeight / _.options
                .touchThreshold;
        }

        switch (event.data.action) {

            case 'start':
                _.swipeStart(event);
                break;

            case 'move':
                _.swipeMove(event);
                break;

            case 'end':
                _.swipeEnd(event);
                break;

        }

    };

    Slick.prototype.swipeMove = function(event) {

        var _ = this,
            edgeWasHit = false,
            curLeft, swipeDirection, swipeLength, positionOffset, touches;

        touches = event.originalEvent !== undefined ? event.originalEvent.touches : null;

        if (!_.dragging || touches && touches.length !== 1) {
            return false;
        }

        curLeft = _.getLeft(_.currentSlide);

        _.touchObject.curX = touches !== undefined ? touches[0].pageX : event.clientX;
        _.touchObject.curY = touches !== undefined ? touches[0].pageY : event.clientY;

        _.touchObject.swipeLength = Math.round(Math.sqrt(
            Math.pow(_.touchObject.curX - _.touchObject.startX, 2)));

        if (_.options.verticalSwiping === true) {
            _.touchObject.swipeLength = Math.round(Math.sqrt(
                Math.pow(_.touchObject.curY - _.touchObject.startY, 2)));
        }

        swipeDirection = _.swipeDirection();

        if (swipeDirection === 'vertical') {
            return;
        }

        if (event.originalEvent !== undefined && _.touchObject.swipeLength > 4) {
            event.preventDefault();
        }

        positionOffset = (_.options.rtl === false ? 1 : -1) * (_.touchObject.curX > _.touchObject.startX ? 1 : -1);
        if (_.options.verticalSwiping === true) {
            positionOffset = _.touchObject.curY > _.touchObject.startY ? 1 : -1;
        }


        swipeLength = _.touchObject.swipeLength;

        _.touchObject.edgeHit = false;

        if (_.options.infinite === false) {
            if ((_.currentSlide === 0 && swipeDirection === 'right') || (_.currentSlide >= _.getDotCount() && swipeDirection === 'left')) {
                swipeLength = _.touchObject.swipeLength * _.options.edgeFriction;
                _.touchObject.edgeHit = true;
            }
        }

        if (_.options.vertical === false) {
            _.swipeLeft = curLeft + swipeLength * positionOffset;
        } else {
            _.swipeLeft = curLeft + (swipeLength * (_.$list.height() / _.listWidth)) * positionOffset;
        }
        if (_.options.verticalSwiping === true) {
            _.swipeLeft = curLeft + swipeLength * positionOffset;
        }

        if (_.options.fade === true || _.options.touchMove === false) {
            return false;
        }

        if (_.animating === true) {
            _.swipeLeft = null;
            return false;
        }

        _.setCSS(_.swipeLeft);

    };

    Slick.prototype.swipeStart = function(event) {

        var _ = this,
            touches;

        _.interrupted = true;

        if (_.touchObject.fingerCount !== 1 || _.slideCount <= _.options.slidesToShow) {
            _.touchObject = {};
            return false;
        }

        if (event.originalEvent !== undefined && event.originalEvent.touches !== undefined) {
            touches = event.originalEvent.touches[0];
        }

        _.touchObject.startX = _.touchObject.curX = touches !== undefined ? touches.pageX : event.clientX;
        _.touchObject.startY = _.touchObject.curY = touches !== undefined ? touches.pageY : event.clientY;

        _.dragging = true;

    };

    Slick.prototype.unfilterSlides = Slick.prototype.slickUnfilter = function() {

        var _ = this;

        if (_.$slidesCache !== null) {

            _.unload();

            _.$slideTrack.children(this.options.slide).detach();

            _.$slidesCache.appendTo(_.$slideTrack);

            _.reinit();

        }

    };

    Slick.prototype.unload = function() {

        var _ = this;

        $('.slick-cloned', _.$slider).remove();

        if (_.$dots) {
            _.$dots.remove();
        }

        if (_.$prevArrow && _.htmlExpr.test(_.options.prevArrow)) {
            _.$prevArrow.remove();
        }

        if (_.$nextArrow && _.htmlExpr.test(_.options.nextArrow)) {
            _.$nextArrow.remove();
        }

        _.$slides
            .removeClass('slick-slide slick-active slick-visible slick-current')
            .attr('aria-hidden', 'true')
            .css('width', '');

    };

    Slick.prototype.unslick = function(fromBreakpoint) {

        var _ = this;
        _.$slider.trigger('unslick', [_, fromBreakpoint]);
        _.destroy();

    };

    Slick.prototype.updateArrows = function() {

        var _ = this,
            centerOffset;

        centerOffset = Math.floor(_.options.slidesToShow / 2);

        if ( _.options.arrows === true &&
            _.slideCount > _.options.slidesToShow &&
            !_.options.infinite ) {

            _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
            _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            if (_.currentSlide === 0) {

                _.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow && _.options.centerMode === false) {

                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            } else if (_.currentSlide >= _.slideCount - 1 && _.options.centerMode === true) {

                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            }

        }

    };

    Slick.prototype.updateDots = function() {

        var _ = this;

        if (_.$dots !== null) {

            _.$dots
                .find('li')
                .removeClass('slick-active')
                .attr('aria-hidden', 'true');

            _.$dots
                .find('li')
                .eq(Math.floor(_.currentSlide / _.options.slidesToScroll))
                .addClass('slick-active')
                .attr('aria-hidden', 'false');

        }

    };

    Slick.prototype.visibility = function() {

        var _ = this;

        if ( _.options.autoplay ) {

            if ( document[_.hidden] ) {

                _.interrupted = true;

            } else {

                _.interrupted = false;

            }

        }

    };

    $.fn.slick = function() {
        var _ = this,
            opt = arguments[0],
            args = Array.prototype.slice.call(arguments, 1),
            l = _.length,
            i,
            ret;
        for (i = 0; i < l; i++) {
            if (typeof opt == 'object' || typeof opt == 'undefined')
                _[i].slick = new Slick(_[i], opt);
            else
                ret = _[i].slick[opt].apply(_[i].slick, args);
            if (typeof ret != 'undefined') return ret;
        }
        return _;
    };

}));

},{}]},{},[76]);
